/* tslint:disable */
/* eslint-disable */
/**
 * Europrocurement Api Facturation
 * API de gestion des facturation
 *
 * The version of the OpenAPI document: 1.24.6
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AjustementDePrestationFormalit
 */
export interface AjustementDePrestationFormalit {
    /**
     * articles de formalité
     * @type {Array<number>}
     * @memberof AjustementDePrestationFormalit
     */
    'articles'?: Array<number>;
    /**
     * acomptes des dossiers
     * @type {Array<number>}
     * @memberof AjustementDePrestationFormalit
     */
    'acomptes'?: Array<number>;
}
/**
 * 
 * @export
 * @interface AjustementDePrestationFormalitAjustementCreate
 */
export interface AjustementDePrestationFormalitAjustementCreate {
    /**
     * articles de formalité
     * @type {Array<number>}
     * @memberof AjustementDePrestationFormalitAjustementCreate
     */
    'articles'?: Array<number>;
    /**
     * acomptes des dossiers
     * @type {Array<number>}
     * @memberof AjustementDePrestationFormalitAjustementCreate
     */
    'acomptes'?: Array<number>;
}
/**
 * 
 * @export
 * @interface AjustementDePrestationFormalitJsonld
 */
export interface AjustementDePrestationFormalitJsonld {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof AjustementDePrestationFormalitJsonld
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof AjustementDePrestationFormalitJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AjustementDePrestationFormalitJsonld
     */
    '@type'?: string;
    /**
     * articles de formalité
     * @type {Array<number>}
     * @memberof AjustementDePrestationFormalitJsonld
     */
    'articles'?: Array<number>;
    /**
     * acomptes des dossiers
     * @type {Array<number>}
     * @memberof AjustementDePrestationFormalitJsonld
     */
    'acomptes'?: Array<number>;
}
/**
 * 
 * @export
 * @interface AjustementDePrestationFormalitJsonldAjustementCreate
 */
export interface AjustementDePrestationFormalitJsonldAjustementCreate {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof AjustementDePrestationFormalitJsonldAjustementCreate
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof AjustementDePrestationFormalitJsonldAjustementCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof AjustementDePrestationFormalitJsonldAjustementCreate
     */
    '@type'?: string;
    /**
     * articles de formalité
     * @type {Array<number>}
     * @memberof AjustementDePrestationFormalitJsonldAjustementCreate
     */
    'articles'?: Array<number>;
    /**
     * acomptes des dossiers
     * @type {Array<number>}
     * @memberof AjustementDePrestationFormalitJsonldAjustementCreate
     */
    'acomptes'?: Array<number>;
}
/**
 * @type AjustementDePrestationFormalitJsonldContext
 * @export
 */
export type AjustementDePrestationFormalitJsonldContext = AjustementDePrestationFormalitJsonldContextOneOf | string;

/**
 * 
 * @export
 * @interface AjustementDePrestationFormalitJsonldContextOneOf
 */
export interface AjustementDePrestationFormalitJsonldContextOneOf {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof AjustementDePrestationFormalitJsonldContextOneOf
     */
    '@vocab': string;
    /**
     * 
     * @type {string}
     * @memberof AjustementDePrestationFormalitJsonldContextOneOf
     */
    'hydra': AjustementDePrestationFormalitJsonldContextOneOfHydraEnum;
}

export const AjustementDePrestationFormalitJsonldContextOneOfHydraEnum = {
    HttpWwwW3OrgNsHydraCore: 'http://www.w3.org/ns/hydra/core#'
} as const;

export type AjustementDePrestationFormalitJsonldContextOneOfHydraEnum = typeof AjustementDePrestationFormalitJsonldContextOneOfHydraEnum[keyof typeof AjustementDePrestationFormalitJsonldContextOneOfHydraEnum];

/**
 * 
 * @export
 * @interface ApiAjustementArticlesPrestationPost401Response
 */
export interface ApiAjustementArticlesPrestationPost401Response {
    /**
     * 
     * @type {string}
     * @memberof ApiAjustementArticlesPrestationPost401Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiAjustementArticlesPrestationPost403Response
 */
export interface ApiAjustementArticlesPrestationPost403Response {
    /**
     * 
     * @type {string}
     * @memberof ApiAjustementArticlesPrestationPost403Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiAjustementArticlesPrestationPost403ResponseException}
     * @memberof ApiAjustementArticlesPrestationPost403Response
     */
    'exception'?: ApiAjustementArticlesPrestationPost403ResponseException;
}
/**
 * 
 * @export
 * @interface ApiAjustementArticlesPrestationPost403ResponseException
 */
export interface ApiAjustementArticlesPrestationPost403ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiAjustementArticlesPrestationPost403ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiAjustementArticlesPrestationPost403ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ApiDevisCollectionsPost400Response
 */
export interface ApiDevisCollectionsPost400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiDevisCollectionsPost400Response
     */
    'error': string;
    /**
     * 
     * @type {ApiDevisCollectionsPost400ResponseException}
     * @memberof ApiDevisCollectionsPost400Response
     */
    'exception': ApiDevisCollectionsPost400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiDevisCollectionsPost400ResponseException
 */
export interface ApiDevisCollectionsPost400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiDevisCollectionsPost400ResponseException
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ApiDevisCollectionsPost400ResponseException
     */
    'code': number;
    /**
     * liste des propiétés invalides
     * @type {Array<ApiDevisCollectionsPost400ResponseExceptionViolationsInner>}
     * @memberof ApiDevisCollectionsPost400ResponseException
     */
    'violations'?: Array<ApiDevisCollectionsPost400ResponseExceptionViolationsInner>;
}
/**
 * 
 * @export
 * @interface ApiDevisCollectionsPost400ResponseExceptionViolationsInner
 */
export interface ApiDevisCollectionsPost400ResponseExceptionViolationsInner {
    /**
     * nom de la propriété invalide
     * @type {string}
     * @memberof ApiDevisCollectionsPost400ResponseExceptionViolationsInner
     */
    'property'?: string;
    /**
     * message descriptif de la violation
     * @type {string}
     * @memberof ApiDevisCollectionsPost400ResponseExceptionViolationsInner
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiDevisFormaliteGetCollection200Response
 */
export interface ApiDevisFormaliteGetCollection200Response {
    /**
     * 
     * @type {Array<DevisFormalitJsonldDevisRead>}
     * @memberof ApiDevisFormaliteGetCollection200Response
     */
    'hydra:member': Array<DevisFormalitJsonldDevisRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDevisFormaliteGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiDevisFormaliteGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiDevisFormaliteGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDevisFormaliteGetCollection200ResponseHydraSearch
 */
export interface ApiDevisFormaliteGetCollection200ResponseHydraSearch {
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraSearch
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraSearch
     */
    'hydra:template'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraSearch
     */
    'hydra:variableRepresentation'?: string;
    /**
     * 
     * @type {Array<ApiDevisFormaliteGetCollection200ResponseHydraSearchHydraMappingInner>}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraSearch
     */
    'hydra:mapping'?: Array<ApiDevisFormaliteGetCollection200ResponseHydraSearchHydraMappingInner>;
}
/**
 * 
 * @export
 * @interface ApiDevisFormaliteGetCollection200ResponseHydraSearchHydraMappingInner
 */
export interface ApiDevisFormaliteGetCollection200ResponseHydraSearchHydraMappingInner {
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraSearchHydraMappingInner
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraSearchHydraMappingInner
     */
    'variable'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraSearchHydraMappingInner
     */
    'property'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraSearchHydraMappingInner
     */
    'required'?: boolean;
}
/**
 * 
 * @export
 * @interface ApiDevisFormaliteGetCollection200ResponseHydraView
 */
export interface ApiDevisFormaliteGetCollection200ResponseHydraView {
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraView
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraView
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraView
     */
    'hydra:first'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraView
     */
    'hydra:last'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraView
     */
    'hydra:previous'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteGetCollection200ResponseHydraView
     */
    'hydra:next'?: string;
}
/**
 * 
 * @export
 * @interface ApiDevisFormaliteIdDelete400Response
 */
export interface ApiDevisFormaliteIdDelete400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteIdDelete400Response
     */
    'error': string;
    /**
     * 
     * @type {ApiDevisFormaliteIdDelete400ResponseException}
     * @memberof ApiDevisFormaliteIdDelete400Response
     */
    'exception': ApiDevisFormaliteIdDelete400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiDevisFormaliteIdDelete400ResponseException
 */
export interface ApiDevisFormaliteIdDelete400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteIdDelete400ResponseException
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ApiDevisFormaliteIdDelete400ResponseException
     */
    'code': number;
    /**
     * liste des propiétés invalides
     * @type {Array<ApiDevisFormaliteIdDelete400ResponseExceptionViolationsInner>}
     * @memberof ApiDevisFormaliteIdDelete400ResponseException
     */
    'violations'?: Array<ApiDevisFormaliteIdDelete400ResponseExceptionViolationsInner>;
}
/**
 * 
 * @export
 * @interface ApiDevisFormaliteIdDelete400ResponseExceptionViolationsInner
 */
export interface ApiDevisFormaliteIdDelete400ResponseExceptionViolationsInner {
    /**
     * nom de la propriété invalide
     * @type {string}
     * @memberof ApiDevisFormaliteIdDelete400ResponseExceptionViolationsInner
     */
    'property'?: string;
    /**
     * message descriptif de la violation
     * @type {string}
     * @memberof ApiDevisFormaliteIdDelete400ResponseExceptionViolationsInner
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiDevisFormaliteIdGet404Response
 */
export interface ApiDevisFormaliteIdGet404Response {
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteIdGet404Response
     */
    'error'?: string;
    /**
     * 
     * @type {ApiDevisFormaliteIdGet404ResponseException}
     * @memberof ApiDevisFormaliteIdGet404Response
     */
    'exception'?: ApiDevisFormaliteIdGet404ResponseException;
}
/**
 * 
 * @export
 * @interface ApiDevisFormaliteIdGet404ResponseException
 */
export interface ApiDevisFormaliteIdGet404ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiDevisFormaliteIdGet404ResponseException
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof ApiDevisFormaliteIdGet404ResponseException
     */
    'code'?: number;
}
/**
 * 
 * @export
 * @interface ApiDevisLigneGetCollection200Response
 */
export interface ApiDevisLigneGetCollection200Response {
    /**
     * 
     * @type {Array<DevisLignesFormalitJsonldDevisLignesRead>}
     * @memberof ApiDevisLigneGetCollection200Response
     */
    'hydra:member': Array<DevisLignesFormalitJsonldDevisLignesRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDevisLigneGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiDevisLigneGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiDevisLigneGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossierFormaliteGetCollection200Response
 */
export interface ApiDossierFormaliteGetCollection200Response {
    /**
     * 
     * @type {Array<FacturationFormalitJsonldDonneesFacturationRead>}
     * @memberof ApiDossierFormaliteGetCollection200Response
     */
    'hydra:member': Array<FacturationFormalitJsonldDonneesFacturationRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossierFormaliteGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiDossierFormaliteGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiDossierFormaliteGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiDossiersDossierFacturesGetCollection200Response
 */
export interface ApiDossiersDossierFacturesGetCollection200Response {
    /**
     * 
     * @type {Array<FactureJsonldFactureReadTimestampableBlameambleGroup>}
     * @memberof ApiDossiersDossierFacturesGetCollection200Response
     */
    'hydra:member': Array<FactureJsonldFactureReadTimestampableBlameambleGroup>;
    /**
     * 
     * @type {number}
     * @memberof ApiDossiersDossierFacturesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiDossiersDossierFacturesGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiDossiersDossierFacturesGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiFacturesIdDelete400Response
 */
export interface ApiFacturesIdDelete400Response {
    /**
     * 
     * @type {string}
     * @memberof ApiFacturesIdDelete400Response
     */
    'error': string;
    /**
     * 
     * @type {ApiFacturesIdDelete400ResponseException}
     * @memberof ApiFacturesIdDelete400Response
     */
    'exception': ApiFacturesIdDelete400ResponseException;
}
/**
 * 
 * @export
 * @interface ApiFacturesIdDelete400ResponseException
 */
export interface ApiFacturesIdDelete400ResponseException {
    /**
     * 
     * @type {string}
     * @memberof ApiFacturesIdDelete400ResponseException
     */
    'message': string;
    /**
     * 
     * @type {number}
     * @memberof ApiFacturesIdDelete400ResponseException
     */
    'code': number;
    /**
     * liste des propiétés invalides
     * @type {Array<ApiFacturesIdDelete400ResponseExceptionViolationsInner>}
     * @memberof ApiFacturesIdDelete400ResponseException
     */
    'violations'?: Array<ApiFacturesIdDelete400ResponseExceptionViolationsInner>;
}
/**
 * 
 * @export
 * @interface ApiFacturesIdDelete400ResponseExceptionViolationsInner
 */
export interface ApiFacturesIdDelete400ResponseExceptionViolationsInner {
    /**
     * nom de la propriété invalide
     * @type {string}
     * @memberof ApiFacturesIdDelete400ResponseExceptionViolationsInner
     */
    'property'?: string;
    /**
     * message descriptif de la violation
     * @type {string}
     * @memberof ApiFacturesIdDelete400ResponseExceptionViolationsInner
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface ApiLienPanierReglementGetCollection200Response
 */
export interface ApiLienPanierReglementGetCollection200Response {
    /**
     * 
     * @type {Array<PanierPaiementJsonldPanierLienRead>}
     * @memberof ApiLienPanierReglementGetCollection200Response
     */
    'hydra:member': Array<PanierPaiementJsonldPanierLienRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLienPanierReglementGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiLienPanierReglementGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiLienPanierReglementGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLigneDevisAnnonceLegaleGetCollection200Response
 */
export interface ApiLigneDevisAnnonceLegaleGetCollection200Response {
    /**
     * 
     * @type {Array<DevisLignesAnnonceLGaleJsonldLigneDevisALRead>}
     * @memberof ApiLigneDevisAnnonceLegaleGetCollection200Response
     */
    'hydra:member': Array<DevisLignesAnnonceLGaleJsonldLigneDevisALRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLigneDevisAnnonceLegaleGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiLigneDevisAnnonceLegaleGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiLigneDevisAnnonceLegaleGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLignesFacturesGetCollection200Response
 */
export interface ApiLignesFacturesGetCollection200Response {
    /**
     * 
     * @type {Array<LigneFactureJsonldLigneFactureRead>}
     * @memberof ApiLignesFacturesGetCollection200Response
     */
    'hydra:member': Array<LigneFactureJsonldLigneFactureRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLignesFacturesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiLignesFacturesGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiLignesFacturesGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionCollectionDossierClientEntityIdGetCollection200Response
 */
export interface ApiLogActionCollectionDossierClientEntityIdGetCollection200Response {
    /**
     * 
     * @type {Array<LogActionCollectionDossierJsonldLogRead>}
     * @memberof ApiLogActionCollectionDossierClientEntityIdGetCollection200Response
     */
    'hydra:member': Array<LogActionCollectionDossierJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionCollectionDossierClientEntityIdGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiLogActionCollectionDossierClientEntityIdGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionCollectionDossierClientEntityIdGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionDevisClientEntityIdGetCollection200Response
 */
export interface ApiLogActionDevisClientEntityIdGetCollection200Response {
    /**
     * 
     * @type {Array<LogActionDevisJsonldLogRead>}
     * @memberof ApiLogActionDevisClientEntityIdGetCollection200Response
     */
    'hydra:member': Array<LogActionDevisJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionDevisClientEntityIdGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiLogActionDevisClientEntityIdGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionDevisClientEntityIdGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionDossierClientEntityIdGetCollection200Response
 */
export interface ApiLogActionDossierClientEntityIdGetCollection200Response {
    /**
     * 
     * @type {Array<LogActionDossierJsonldLogRead>}
     * @memberof ApiLogActionDossierClientEntityIdGetCollection200Response
     */
    'hydra:member': Array<LogActionDossierJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionDossierClientEntityIdGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiLogActionDossierClientEntityIdGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionDossierClientEntityIdGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionFactureClientEntityIdGetCollection200Response
 */
export interface ApiLogActionFactureClientEntityIdGetCollection200Response {
    /**
     * 
     * @type {Array<LogActionFactureJsonldLogRead>}
     * @memberof ApiLogActionFactureClientEntityIdGetCollection200Response
     */
    'hydra:member': Array<LogActionFactureJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionFactureClientEntityIdGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiLogActionFactureClientEntityIdGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionFactureClientEntityIdGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionTiersClientEntityIdGetCollection200Response
 */
export interface ApiLogActionTiersClientEntityIdGetCollection200Response {
    /**
     * 
     * @type {Array<LogActionTiersJsonldLogRead>}
     * @memberof ApiLogActionTiersClientEntityIdGetCollection200Response
     */
    'hydra:member': Array<LogActionTiersJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionTiersClientEntityIdGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiLogActionTiersClientEntityIdGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionTiersClientEntityIdGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiLogActionUtilisateurClientEntityIdGetCollection200Response
 */
export interface ApiLogActionUtilisateurClientEntityIdGetCollection200Response {
    /**
     * 
     * @type {Array<LogActionUtilisateurJsonldLogRead>}
     * @memberof ApiLogActionUtilisateurClientEntityIdGetCollection200Response
     */
    'hydra:member': Array<LogActionUtilisateurJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiLogActionUtilisateurClientEntityIdGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiLogActionUtilisateurClientEntityIdGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiLogActionUtilisateurClientEntityIdGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiOpensearchFacturesGetCollection200Response
 */
export interface ApiOpensearchFacturesGetCollection200Response {
    /**
     * 
     * @type {Array<FactureOpenSearchJsonldOpensearchFactureRead>}
     * @memberof ApiOpensearchFacturesGetCollection200Response
     */
    'hydra:member': Array<FactureOpenSearchJsonldOpensearchFactureRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiOpensearchFacturesGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiOpensearchFacturesGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiOpensearchFacturesGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiPanierReglementGetCollection200Response
 */
export interface ApiPanierReglementGetCollection200Response {
    /**
     * 
     * @type {Array<PanierPaiementJsonldPanierRead>}
     * @memberof ApiPanierReglementGetCollection200Response
     */
    'hydra:member': Array<PanierPaiementJsonldPanierRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiPanierReglementGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiPanierReglementGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiPanierReglementGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiReductionArticlesDossierGetCollection200Response
 */
export interface ApiReductionArticlesDossierGetCollection200Response {
    /**
     * 
     * @type {Array<ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead>}
     * @memberof ApiReductionArticlesDossierGetCollection200Response
     */
    'hydra:member': Array<ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead>;
    /**
     * 
     * @type {number}
     * @memberof ApiReductionArticlesDossierGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiReductionArticlesDossierGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiReductionArticlesDossierGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ApiReductionArticlesPrestationGetCollection200Response
 */
export interface ApiReductionArticlesPrestationGetCollection200Response {
    /**
     * 
     * @type {Array<RemisesDesArticlesDePrestationFormalitJsonld>}
     * @memberof ApiReductionArticlesPrestationGetCollection200Response
     */
    'hydra:member': Array<RemisesDesArticlesDePrestationFormalitJsonld>;
    /**
     * 
     * @type {number}
     * @memberof ApiReductionArticlesPrestationGetCollection200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof ApiReductionArticlesPrestationGetCollection200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof ApiReductionArticlesPrestationGetCollection200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface ArticleTarifDTODonneesFacturationRead
 */
export interface ArticleTarifDTODonneesFacturationRead {
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'rubFac'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'unite'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'quantite'?: number;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'prixBase'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'htReference'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'affiche'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'tauxTva'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'formalite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'idAnnonce'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'dossier'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'idDrt'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'articleFacturable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'motifNonFacturable'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'articleModifiable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'articleFactureValidee'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'articleFacture'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'articleFactureNumero'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'articleAjustement'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'factArticle'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'articleSupprimable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'rang'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'fMasqueCalcul'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'fAjouteCalcul'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTODonneesFacturationRead
     */
    'prestationId'?: number;
}
/**
 * 
 * @export
 * @interface ArticleTarifDTOJsonldDonneesFacturationRead
 */
export interface ArticleTarifDTOJsonldDonneesFacturationRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'rubFac'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'unite'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'quantite'?: number;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'prixBase'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'montant'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'htReference'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'affiche'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'tauxTva'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'ttc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'formalite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'idAnnonce'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'dossier'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'idDrt'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'articleFacturable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'motifNonFacturable'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'articleModifiable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'articleFactureValidee'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'articleFacture'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'articleFactureNumero'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'articleAjustement'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'factArticle'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'articleSupprimable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'rang'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'fMasqueCalcul'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'fAjouteCalcul'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ArticleTarifDTOJsonldDonneesFacturationRead
     */
    'prestationId'?: number;
}
/**
 * 
 * @export
 * @interface ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
 */
export interface ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead {
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'ttc'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'resteAPayer'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'ttcProforma'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'facturable'?: boolean;
    /**
     * Get the value of motifNonFacturable
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'motifNonFacturable'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'cegidRegimetva'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'client'?: number;
    /**
     * 
     * @type {number}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'prescripteurDevis'?: number;
    /**
     * 
     * @type {number}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'societeDevis'?: number;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'acompteAttendu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'resteAFacturer'?: string;
    /**
     * 
     * @type {ProvisionTarifDTODonneesFacturationRead}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'provisions'?: ProvisionTarifDTODonneesFacturationRead;
    /**
     * 
     * @type {RemisesVisiblesCumuleesTarifDTODonneesFacturationRead}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'remisesVisiblesCumulees'?: RemisesVisiblesCumuleesTarifDTODonneesFacturationRead;
    /**
     * 
     * @type {RemisesInvisiblesCumuleesTarifDTODonneesFacturationRead}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'remisesInvisiblesCumulees'?: RemisesInvisiblesCumuleesTarifDTODonneesFacturationRead;
    /**
     * 
     * @type {Array<DossierTarifDTODonneesFacturationRead>}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'dossiers'?: Array<DossierTarifDTODonneesFacturationRead>;
    /**
     * 
     * @type {Array<TauxTvaDTODonneesFacturationRead>}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitDonneesFacturationRead
     */
    'tauxTvas'?: Array<TauxTvaDTODonneesFacturationRead>;
}
/**
 * 
 * @export
 * @interface ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
 */
export interface ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead {
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'ttc'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'resteAPayer'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'ttcProforma'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'facturable'?: boolean;
    /**
     * Get the value of motifNonFacturable
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'motifNonFacturable'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'cegidRegimetva'?: string;
    /**
     * 
     * @type {number}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'client'?: number;
    /**
     * 
     * @type {number}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'prescripteurDevis'?: number;
    /**
     * 
     * @type {number}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'societeDevis'?: number;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'acompteAttendu'?: string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'resteAFacturer'?: string;
    /**
     * 
     * @type {ProvisionTarifDTOJsonldDonneesFacturationRead}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'provisions'?: ProvisionTarifDTOJsonldDonneesFacturationRead;
    /**
     * 
     * @type {RemisesVisiblesCumuleesTarifDTOJsonldDonneesFacturationRead}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'remisesVisiblesCumulees'?: RemisesVisiblesCumuleesTarifDTOJsonldDonneesFacturationRead;
    /**
     * 
     * @type {RemisesInvisiblesCumuleesTarifDTOJsonldDonneesFacturationRead}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'remisesInvisiblesCumulees'?: RemisesInvisiblesCumuleesTarifDTOJsonldDonneesFacturationRead;
    /**
     * 
     * @type {Array<DossierTarifDTOJsonldDonneesFacturationRead>}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'dossiers'?: Array<DossierTarifDTOJsonldDonneesFacturationRead>;
    /**
     * 
     * @type {Array<TauxTvaDTOJsonldDonneesFacturationRead>}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitJsonldDonneesFacturationRead
     */
    'tauxTvas'?: Array<TauxTvaDTOJsonldDonneesFacturationRead>;
}
/**
 * 
 * @export
 * @interface DevisArticleDtoDevisCreate
 */
export interface DevisArticleDtoDevisCreate {
    /**
     * 
     * @type {number}
     * @memberof DevisArticleDtoDevisCreate
     */
    'factArticle'?: number;
    /**
     * 
     * @type {string}
     * @memberof DevisArticleDtoDevisCreate
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisArticleDtoDevisCreate
     */
    'pxBase'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisArticleDtoDevisCreate
     */
    'quantite'?: number;
    /**
     * 
     * @type {number}
     * @memberof DevisArticleDtoDevisCreate
     */
    'prestaAl'?: number | null;
}
/**
 * 
 * @export
 * @interface DevisArticleDtoJsonldDevisCreate
 */
export interface DevisArticleDtoJsonldDevisCreate {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof DevisArticleDtoJsonldDevisCreate
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof DevisArticleDtoJsonldDevisCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisArticleDtoJsonldDevisCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DevisArticleDtoJsonldDevisCreate
     */
    'factArticle'?: number;
    /**
     * 
     * @type {string}
     * @memberof DevisArticleDtoJsonldDevisCreate
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisArticleDtoJsonldDevisCreate
     */
    'pxBase'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisArticleDtoJsonldDevisCreate
     */
    'quantite'?: number;
    /**
     * 
     * @type {number}
     * @memberof DevisArticleDtoJsonldDevisCreate
     */
    'prestaAl'?: number | null;
}
/**
 * 
 * @export
 * @interface DevisFormalitDevisCreateDtoDevisCreate
 */
export interface DevisFormalitDevisCreateDtoDevisCreate {
    /**
     * 
     * @type {number}
     * @memberof DevisFormalitDevisCreateDtoDevisCreate
     */
    'prescripteurDevis': number;
    /**
     * 
     * @type {number}
     * @memberof DevisFormalitDevisCreateDtoDevisCreate
     */
    'client': number;
    /**
     * 
     * @type {number}
     * @memberof DevisFormalitDevisCreateDtoDevisCreate
     */
    'societeDevis': number;
    /**
     * 
     * @type {Sting}
     * @memberof DevisFormalitDevisCreateDtoDevisCreate
     */
    'cegidRegimetva': DevisFormalitDevisCreateDtoDevisCreateCegidRegimetvaEnum;
    /**
     * 
     * @type {Array<DevisArticleDtoDevisCreate>}
     * @memberof DevisFormalitDevisCreateDtoDevisCreate
     */
    'articles'?: Array<DevisArticleDtoDevisCreate>;
}

export const DevisFormalitDevisCreateDtoDevisCreateCegidRegimetvaEnum = {
    Cor: 'COR',
    Dom: 'DOM',
    Exo: 'EXO',
    Fra: 'FRA',
    Pol: 'POL'
} as const;

export type DevisFormalitDevisCreateDtoDevisCreateCegidRegimetvaEnum = typeof DevisFormalitDevisCreateDtoDevisCreateCegidRegimetvaEnum[keyof typeof DevisFormalitDevisCreateDtoDevisCreateCegidRegimetvaEnum];

/**
 * 
 * @export
 * @interface DevisFormalitDevisCreateDtoJsonldDevisCreate
 */
export interface DevisFormalitDevisCreateDtoJsonldDevisCreate {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof DevisFormalitDevisCreateDtoJsonldDevisCreate
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisCreateDtoJsonldDevisCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisCreateDtoJsonldDevisCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DevisFormalitDevisCreateDtoJsonldDevisCreate
     */
    'prescripteurDevis': number;
    /**
     * 
     * @type {number}
     * @memberof DevisFormalitDevisCreateDtoJsonldDevisCreate
     */
    'client': number;
    /**
     * 
     * @type {number}
     * @memberof DevisFormalitDevisCreateDtoJsonldDevisCreate
     */
    'societeDevis': number;
    /**
     * 
     * @type {Sting}
     * @memberof DevisFormalitDevisCreateDtoJsonldDevisCreate
     */
    'cegidRegimetva': DevisFormalitDevisCreateDtoJsonldDevisCreateCegidRegimetvaEnum;
    /**
     * 
     * @type {Array<DevisArticleDtoJsonldDevisCreate>}
     * @memberof DevisFormalitDevisCreateDtoJsonldDevisCreate
     */
    'articles'?: Array<DevisArticleDtoJsonldDevisCreate>;
}

export const DevisFormalitDevisCreateDtoJsonldDevisCreateCegidRegimetvaEnum = {
    Cor: 'COR',
    Dom: 'DOM',
    Exo: 'EXO',
    Fra: 'FRA',
    Pol: 'POL'
} as const;

export type DevisFormalitDevisCreateDtoJsonldDevisCreateCegidRegimetvaEnum = typeof DevisFormalitDevisCreateDtoJsonldDevisCreateCegidRegimetvaEnum[keyof typeof DevisFormalitDevisCreateDtoJsonldDevisCreateCegidRegimetvaEnum];

/**
 * 
 * @export
 * @interface DevisFormalitDevisRead
 */
export interface DevisFormalitDevisRead {
    /**
     * 
     * @type {number}
     * @memberof DevisFormalitDevisRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisRead
     */
    'dossierAl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisRead
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof DevisFormalitDevisRead
     */
    'societe'?: object;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisRead
     */
    'prescripteur'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisRead
     */
    'auteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisRead
     */
    'totalHt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisRead
     */
    'totalTva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisRead
     */
    'totalTtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisRead
     */
    'file'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevisFormalitDevisRead
     */
    'actif'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevisFormalitDevisRead
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevisFormalitDevisRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {Array<TblDevisLignesDevisRead>}
     * @memberof DevisFormalitDevisRead
     */
    'lignes'?: Array<TblDevisLignesDevisRead>;
}
/**
 * 
 * @export
 * @interface DevisFormalitDevisReadPdf
 */
export interface DevisFormalitDevisReadPdf {
    /**
     * Lien vers le pdf du devis simplifié
     * @type {string}
     * @memberof DevisFormalitDevisReadPdf
     */
    'pdfSimple'?: string;
    /**
     * Lien vers le pdf du devis détaillé
     * @type {string}
     * @memberof DevisFormalitDevisReadPdf
     */
    'pdfDetail'?: string;
    /**
     * Date d\'expiration des liens vers les pdf du devis
     * @type {string}
     * @memberof DevisFormalitDevisReadPdf
     */
    'expires'?: string;
}
/**
 * 
 * @export
 * @interface DevisFormalitDevisbyCollectionCreateDtoDevisCollectionCreate
 */
export interface DevisFormalitDevisbyCollectionCreateDtoDevisCollectionCreate {
    /**
     * 
     * @type {Array<number>}
     * @memberof DevisFormalitDevisbyCollectionCreateDtoDevisCollectionCreate
     */
    'ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate
 */
export interface DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate
     */
    'ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface DevisFormalitJsonldDevisRead
 */
export interface DevisFormalitJsonldDevisRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof DevisFormalitJsonldDevisRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'dossierAl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {TblSocieteJsonldDevisRead}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'societe'?: TblSocieteJsonldDevisRead | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'prescripteur'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'auteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'totalHt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'totalTva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'totalTtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'file'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'actif'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {Array<TblDevisLignesJsonldDevisRead>}
     * @memberof DevisFormalitJsonldDevisRead
     */
    'lignes'?: Array<TblDevisLignesJsonldDevisRead>;
}
/**
 * 
 * @export
 * @interface DevisFormalitJsonldDevisReadPdf
 */
export interface DevisFormalitJsonldDevisReadPdf {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof DevisFormalitJsonldDevisReadPdf
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisReadPdf
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisFormalitJsonldDevisReadPdf
     */
    '@type'?: string;
    /**
     * Lien vers le pdf du devis simplifié
     * @type {string}
     * @memberof DevisFormalitJsonldDevisReadPdf
     */
    'pdfSimple'?: string;
    /**
     * Lien vers le pdf du devis détaillé
     * @type {string}
     * @memberof DevisFormalitJsonldDevisReadPdf
     */
    'pdfDetail'?: string;
    /**
     * Date d\'expiration des liens vers les pdf du devis
     * @type {string}
     * @memberof DevisFormalitJsonldDevisReadPdf
     */
    'expires'?: string;
}
/**
 * 
 * @export
 * @interface DevisLignesAnnonceLGaleJsonldLigneDevisALRead
 */
export interface DevisLignesAnnonceLGaleJsonldLigneDevisALRead {
    /**
     * 
     * @type {string}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    '@type'?: string;
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'idAnnonce'?: number;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'numLigne'?: number;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'rubfac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'unite'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'qte'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'prixbase'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'numTva'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'tauxTva'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'pxBase'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'ligneHt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'ligneTva'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'idDevis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'idArticle'?: number | null;
    /**
     * 
     * @type {TblFactArticlesJsonldLigneDevisALRead}
     * @memberof DevisLignesAnnonceLGaleJsonldLigneDevisALRead
     */
    'article'?: TblFactArticlesJsonldLigneDevisALRead | null;
}
/**
 * 
 * @export
 * @interface DevisLignesAnnonceLGaleLigneDevisALRead
 */
export interface DevisLignesAnnonceLGaleLigneDevisALRead {
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'idAnnonce'?: number;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'numLigne'?: number;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'rubfac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'unite'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'qte'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'prixbase'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'numTva'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'tauxTva'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'pxBase'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'ligneHt'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'ligneTva'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'idDevis'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'idArticle'?: number | null;
    /**
     * 
     * @type {TblFactArticlesLigneDevisALRead}
     * @memberof DevisLignesAnnonceLGaleLigneDevisALRead
     */
    'article'?: TblFactArticlesLigneDevisALRead | null;
}
/**
 * 
 * @export
 * @interface DevisLignesFormalitDevisLignesRead
 */
export interface DevisLignesFormalitDevisLignesRead {
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'numero'?: number;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'rubfac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'unite'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'quantite'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'prixBase'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'numeroTva'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'tauxTva'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'tva'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'affiche'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'compte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'cegidCompte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'cegidSp1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'cegidSp2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'cegidTl1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'cegidTl2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'cegidTl3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'dep'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'jal'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'idAnnonce'?: number | null;
    /**
     * 
     * @type {TblDevisDevisLignesRead}
     * @memberof DevisLignesFormalitDevisLignesRead
     */
    'devis'?: TblDevisDevisLignesRead | null;
}
/**
 * 
 * @export
 * @interface DevisLignesFormalitJsonldDevisLignesRead
 */
export interface DevisLignesFormalitJsonldDevisLignesRead {
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    '@type'?: string;
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'numero'?: number;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'rubfac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'unite'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'quantite'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'prixBase'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'numeroTva'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'tauxTva'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'tva'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'affiche'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'compte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'cegidCompte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'cegidSp1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'cegidSp2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'cegidTl1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'cegidTl2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'cegidTl3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'dep'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'jal'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'idAnnonce'?: number | null;
    /**
     * 
     * @type {TblDevisJsonldDevisLignesRead}
     * @memberof DevisLignesFormalitJsonldDevisLignesRead
     */
    'devis'?: TblDevisJsonldDevisLignesRead | null;
}
/**
 * 
 * @export
 * @interface DossierFacturableDTODonneesFacturationRead
 */
export interface DossierFacturableDTODonneesFacturationRead {
    /**
     * 
     * @type {number}
     * @memberof DossierFacturableDTODonneesFacturationRead
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DossierFacturableDTODonneesFacturationRead
     */
    'dossierFacturable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DossierFacturableDTODonneesFacturationRead
     */
    'motifNonFacturable'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierFacturableDTOJsonldDonneesFacturationRead
 */
export interface DossierFacturableDTOJsonldDonneesFacturationRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof DossierFacturableDTOJsonldDonneesFacturationRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof DossierFacturableDTOJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierFacturableDTOJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierFacturableDTOJsonldDonneesFacturationRead
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DossierFacturableDTOJsonldDonneesFacturationRead
     */
    'dossierFacturable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DossierFacturableDTOJsonldDonneesFacturationRead
     */
    'motifNonFacturable'?: string | null;
}
/**
 * 
 * @export
 * @interface DossierTarifDTODonneesFacturationRead
 */
export interface DossierTarifDTODonneesFacturationRead {
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'numero'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'ttc'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'resteAFacturer'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'dossierFacturable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'motifNonFacturable'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'dossierFacture'?: boolean;
    /**
     * 
     * @type {Array<ArticleTarifDTODonneesFacturationRead>}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'articles'?: Array<ArticleTarifDTODonneesFacturationRead>;
    /**
     * 
     * @type {Array<PrestationTarifDTODonneesFacturationRead>}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'prestations'?: Array<PrestationTarifDTODonneesFacturationRead>;
    /**
     * 
     * @type {Array<ReductionTarifDTODonneesFacturationRead>}
     * @memberof DossierTarifDTODonneesFacturationRead
     */
    'reductions'?: Array<ReductionTarifDTODonneesFacturationRead>;
}
/**
 * 
 * @export
 * @interface DossierTarifDTOJsonldDonneesFacturationRead
 */
export interface DossierTarifDTOJsonldDonneesFacturationRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'numero'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'tva'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'ttc'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'resteAFacturer'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'dossierFacturable'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'motifNonFacturable'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'dossierFacture'?: boolean;
    /**
     * 
     * @type {Array<ArticleTarifDTOJsonldDonneesFacturationRead>}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'articles'?: Array<ArticleTarifDTOJsonldDonneesFacturationRead>;
    /**
     * 
     * @type {Array<PrestationTarifDTOJsonldDonneesFacturationRead>}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'prestations'?: Array<PrestationTarifDTOJsonldDonneesFacturationRead>;
    /**
     * 
     * @type {Array<ReductionTarifDTOJsonldDonneesFacturationRead>}
     * @memberof DossierTarifDTOJsonldDonneesFacturationRead
     */
    'reductions'?: Array<ReductionTarifDTOJsonldDonneesFacturationRead>;
}
/**
 * 
 * @export
 * @interface FacturationFormalitDonneesFacturationRead
 */
export interface FacturationFormalitDonneesFacturationRead {
    /**
     * 
     * @type {Array<DossierFacturableDTODonneesFacturationRead>}
     * @memberof FacturationFormalitDonneesFacturationRead
     */
    'dossiers'?: Array<DossierFacturableDTODonneesFacturationRead>;
}
/**
 * 
 * @export
 * @interface FacturationFormalitJsonldDonneesFacturationRead
 */
export interface FacturationFormalitJsonldDonneesFacturationRead {
    /**
     * 
     * @type {string}
     * @memberof FacturationFormalitJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FacturationFormalitJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<DossierFacturableDTOJsonldDonneesFacturationRead>}
     * @memberof FacturationFormalitJsonldDonneesFacturationRead
     */
    'dossiers'?: Array<DossierFacturableDTOJsonldDonneesFacturationRead>;
}
/**
 * 
 * @export
 * @interface FactureFactureCreate
 */
export interface FactureFactureCreate {
    /**
     * 
     * @type {Array<TblFligneFactureCreate>}
     * @memberof FactureFactureCreate
     */
    'lignes'?: Array<TblFligneFactureCreate>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FactureFactureCreate
     */
    'reglements'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FactureFactureReadPdf
 */
export interface FactureFactureReadPdf {
    /**
     * Lien vers le pdf de la facture
     * @type {string}
     * @memberof FactureFactureReadPdf
     */
    'pdf'?: string;
    /**
     * Date d\'expiration des liens vers les pdf de la facture
     * @type {string}
     * @memberof FactureFactureReadPdf
     */
    'expires'?: string;
}
/**
 * 
 * @export
 * @interface FactureFactureReadTimestampableBlameambleGroup
 */
export interface FactureFactureReadTimestampableBlameambleGroup {
    /**
     * identifiant de la facture
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dossierAl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'numeroDossier'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateFacture'?: string;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'raisonSociale'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adresse1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adresse2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adresse3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adresse4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'codePostal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'ville'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tiersCorrespondance'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'raisonSocialeC'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adresse1C'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adresse2C'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adresse3C'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adresse4C'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'codePostalC'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'villeC'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'cliCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'totalHt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'totalTva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'totalTtc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'paye'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateExport'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'societe'?: object;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'contact'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'gratuit'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'remise'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'delaiPaiement'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'userCreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateCreation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'contactClient'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaBase1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaBase2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaBase3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaBase4'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaTx1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaTx2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaTx3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaTx4'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaMontant1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaMontant2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaMontant3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tvaMontant4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'montantPaiementRecu'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'userMaj'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateMaj'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'compta'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'contactFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'contactCorrespondance'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'rrrPaye'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'datePaiementRrr'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'rrrRefuse'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'formalite'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'factureEnPreparation'?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'societeFacture'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'facturationDiverse'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'idDossierFactureDiverse'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'comptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateExportCegid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'cegidTvaEncaissement'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'cegidRegimeTva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'cegidLibelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'statFacture'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'factureAvoir'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'factureAvoirRemise'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'cegidRejetExportCompta'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'cegidRejetDateExport'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'formalite2'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adjNomTgi'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adjDateVente'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adjAffaire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adjDetailVente'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateEcheanceFacture'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'factureAdju'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'adjDossier'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'presentationAdju'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateLettrageReglement'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'editionReleve'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'nonRelancable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'idUserNonRelancable'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateNonRelancable'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'rbtFraisAchats'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'idFactureRefAvoir'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'idFactureReleveAvoir'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'venteIndirecte'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'horsParrainage'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tiersParrain'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tauxParrainG'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'tauxParrainHg'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'traAchat'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateTraAchat'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'factureMultiple'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'comNonRelancable'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'exportG3'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'referenceInterne'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'parrainageEdition'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'retourNpai'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'nImpNeotouch'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'commande'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'idDdm'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'intercoTraitee'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateTraitementInterco'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'numeroFactureInterco'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'coef'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'comRegie'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateComRegie'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'fournisseurComRegie'?: number;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'idTcf'?: number;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'releveRrrConfrereFile'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'fnpExclus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'cegidFile'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'justifsDetailsInterdit'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'nJustifsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'nJustifsPayants'?: number;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'nJustifsGratuits'?: number;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'idPfj'?: number;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'numEngagement'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'kdoTraite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateTraitementKdo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'idUserKdoTraite'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dnidTraite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateTraitementDnid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'numAchatRrr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'dateAchatRrr'?: string | null;
    /**
     * 
     * @type {Array<TblFligneFactureReadTimestampableBlameambleGroup>}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'lignes'?: Array<TblFligneFactureReadTimestampableBlameambleGroup>;
    /**
     * 
     * @type {Array<TblReglement2DetailsFactureReadTimestampableBlameambleGroup>}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'reglements'?: Array<TblReglement2DetailsFactureReadTimestampableBlameambleGroup>;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureFactureReadTimestampableBlameambleGroup
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface FactureJsonld
 */
export interface FactureJsonld {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof FactureJsonld
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonld
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface FactureJsonldFactureCreate
 */
export interface FactureJsonldFactureCreate {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof FactureJsonldFactureCreate
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<TblFligneJsonldFactureCreate>}
     * @memberof FactureJsonldFactureCreate
     */
    'lignes'?: Array<TblFligneJsonldFactureCreate>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FactureJsonldFactureCreate
     */
    'reglements'?: Array<string>;
}
/**
 * 
 * @export
 * @interface FactureJsonldFactureReadPdf
 */
export interface FactureJsonldFactureReadPdf {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof FactureJsonldFactureReadPdf
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadPdf
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadPdf
     */
    '@type'?: string;
    /**
     * Lien vers le pdf de la facture
     * @type {string}
     * @memberof FactureJsonldFactureReadPdf
     */
    'pdf'?: string;
    /**
     * Date d\'expiration des liens vers les pdf de la facture
     * @type {string}
     * @memberof FactureJsonldFactureReadPdf
     */
    'expires'?: string;
}
/**
 * 
 * @export
 * @interface FactureJsonldFactureReadTimestampableBlameambleGroup
 */
export interface FactureJsonldFactureReadTimestampableBlameambleGroup {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * identifiant de la facture
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dossierAl'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'numeroDossier'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateFacture'?: string;
    /**
     * Identifiant du prescripteur
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'prescripteur'?: string;
    /**
     * ID du client si renseigné
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'client'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'raisonSociale'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adresse1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adresse2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adresse3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adresse4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'codePostal'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'ville'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tiersCorrespondance'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'raisonSocialeC'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adresse1C'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adresse2C'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adresse3C'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adresse4C'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'codePostalC'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'villeC'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'reference'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'cliCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'totalHt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'totalTva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'totalTtc'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'paye'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateExport'?: string | null;
    /**
     * 
     * @type {TblSocieteJsonldFactureReadTimestampableBlameambleGroup}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'societe'?: TblSocieteJsonldFactureReadTimestampableBlameambleGroup;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'contact'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'gratuit'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'remise'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'deleted'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'delaiPaiement'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'userCreation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateCreation'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'contactClient'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaBase1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaBase2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaBase3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaBase4'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaTx1'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaTx2'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaTx3'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaTx4'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaMontant1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaMontant2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaMontant3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tvaMontant4'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'montantPaiementRecu'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'userMaj'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateMaj'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'compta'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'contactFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'contactCorrespondance'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'rrrPaye'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'datePaiementRrr'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'rrrRefuse'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'formalite'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'factureEnPreparation'?: boolean | null;
    /**
     * 
     * @type {TblSocieteJsonldFactureReadTimestampableBlameambleGroup}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'societeFacture'?: TblSocieteJsonldFactureReadTimestampableBlameambleGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'facturationDiverse'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'idDossierFactureDiverse'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'comptaCegid'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateExportCegid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidTvaEncaissement'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidRegimeTva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidLibelle'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'statFacture'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'factureAvoir'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'factureAvoirRemise'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidRejetExportCompta'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidRejetDateExport'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'formalite2'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adjNomTgi'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adjDateVente'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adjAffaire'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adjDetailVente'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateEcheanceFacture'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'factureAdju'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'adjDossier'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'presentationAdju'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateLettrageReglement'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'editionReleve'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'nonRelancable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'idUserNonRelancable'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateNonRelancable'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'rbtFraisAchats'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'idFactureRefAvoir'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'idFactureReleveAvoir'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'venteIndirecte'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'horsParrainage'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tiersParrain'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tauxParrainG'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'tauxParrainHg'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'traAchat'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateTraAchat'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'factureMultiple'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'comNonRelancable'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'exportG3'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'referenceInterne'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'parrainageEdition'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'retourNpai'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'nImpNeotouch'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'commande'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'idDdm'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'intercoTraitee'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateTraitementInterco'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'numeroFactureInterco'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'coef'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'comRegie'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateComRegie'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'fournisseurComRegie'?: number;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'idTcf'?: number;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'releveRrrConfrereFile'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'fnpExclus'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidFile'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'justifsDetailsInterdit'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'nJustifsTotal'?: number;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'nJustifsPayants'?: number;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'nJustifsGratuits'?: number;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'idPfj'?: number;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'numEngagement'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'kdoTraite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateTraitementKdo'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'idUserKdoTraite'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dnidTraite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateTraitementDnid'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'numAchatRrr'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateAchatRrr'?: string | null;
    /**
     * 
     * @type {Array<TblFligneJsonldFactureReadTimestampableBlameambleGroup>}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'lignes'?: Array<TblFligneJsonldFactureReadTimestampableBlameambleGroup>;
    /**
     * 
     * @type {Array<TblReglement2DetailsJsonldFactureReadTimestampableBlameambleGroup>}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'reglements'?: Array<TblReglement2DetailsJsonldFactureReadTimestampableBlameambleGroup>;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'createdBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureJsonldFactureReadTimestampableBlameambleGroup
     */
    'updatedAt'?: string;
}
/**
 * 
 * @export
 * @interface FactureOpenSearchIndexBatchFactureResponse
 */
export interface FactureOpenSearchIndexBatchFactureResponse {
    /**
     * 
     * @type {Array<FactureOpenSearchIndexBatchFactureResponseItemsInner>}
     * @memberof FactureOpenSearchIndexBatchFactureResponse
     */
    'items'?: Array<FactureOpenSearchIndexBatchFactureResponseItemsInner>;
}
/**
 * 
 * @export
 * @interface FactureOpenSearchIndexBatchFactureResponseItemsInner
 */
export interface FactureOpenSearchIndexBatchFactureResponseItemsInner {
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchIndexBatchFactureResponseItemsInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchIndexBatchFactureResponseItemsInner
     */
    'status'?: FactureOpenSearchIndexBatchFactureResponseItemsInnerStatusEnum;
}

export const FactureOpenSearchIndexBatchFactureResponseItemsInnerStatusEnum = {
    Ok: 'OK',
    NotFound: 'NOT FOUND'
} as const;

export type FactureOpenSearchIndexBatchFactureResponseItemsInnerStatusEnum = typeof FactureOpenSearchIndexBatchFactureResponseItemsInnerStatusEnum[keyof typeof FactureOpenSearchIndexBatchFactureResponseItemsInnerStatusEnum];

/**
 * 
 * @export
 * @interface FactureOpenSearchIndexBatchFactureResponseJsonld
 */
export interface FactureOpenSearchIndexBatchFactureResponseJsonld {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof FactureOpenSearchIndexBatchFactureResponseJsonld
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchIndexBatchFactureResponseJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchIndexBatchFactureResponseJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<FactureOpenSearchIndexBatchFactureResponseItemsInner>}
     * @memberof FactureOpenSearchIndexBatchFactureResponseJsonld
     */
    'items'?: Array<FactureOpenSearchIndexBatchFactureResponseItemsInner>;
}
/**
 * 
 * @export
 * @interface FactureOpenSearchJsonldOpensearchFactureIndexBacth
 */
export interface FactureOpenSearchJsonldOpensearchFactureIndexBacth {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof FactureOpenSearchJsonldOpensearchFactureIndexBacth
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureIndexBacth
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureIndexBacth
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof FactureOpenSearchJsonldOpensearchFactureIndexBacth
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface FactureOpenSearchJsonldOpensearchFactureRead
 */
export interface FactureOpenSearchJsonldOpensearchFactureRead {
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    '@type'?: string;
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'factureNumero'?: string | null;
    /**
     * 
     * @type {Array<FactureOpenSearchOpensearchFactureReadDossiersInner>}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'dossiers'?: Array<FactureOpenSearchOpensearchFactureReadDossiersInner> | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'reference'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'totalTtc'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'paye'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'dateEcheanceFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'dateFacture'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'factureClientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'factureClientRaisonSociale'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'montantPaiementRecu'?: number | null;
    /**
     * Status is based on 2 properties -> paye or dateEcheanceFacture (and current datetime)
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'status'?: string | null;
    /**
     * If total ttc <= 0    Avoir
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'prescripteurId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'prescripteurLibelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'ddmId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'factureEnPreparation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'domainLibelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'idFactureAvoir'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'fGroupee'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchJsonldOpensearchFactureRead
     */
    'typeFormalite'?: string | null;
}
/**
 * 
 * @export
 * @interface FactureOpenSearchOpensearchFactureIndexBacth
 */
export interface FactureOpenSearchOpensearchFactureIndexBacth {
    /**
     * 
     * @type {Array<number>}
     * @memberof FactureOpenSearchOpensearchFactureIndexBacth
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface FactureOpenSearchOpensearchFactureRead
 */
export interface FactureOpenSearchOpensearchFactureRead {
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'factureNumero'?: string | null;
    /**
     * 
     * @type {Array<FactureOpenSearchOpensearchFactureReadDossiersInner>}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'dossiers'?: Array<FactureOpenSearchOpensearchFactureReadDossiersInner> | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'reference'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'totalTtc'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'paye'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'deleted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'dateEcheanceFacture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'dateFacture'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'factureClientId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'factureClientRaisonSociale'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'montantPaiementRecu'?: number | null;
    /**
     * Status is based on 2 properties -> paye or dateEcheanceFacture (and current datetime)
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'status'?: string | null;
    /**
     * If total ttc <= 0    Avoir
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'prescripteurId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'prescripteurLibelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'ddmId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'factureEnPreparation'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'domainLibelle'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'idFactureAvoir'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'fGroupee'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureRead
     */
    'typeFormalite'?: string | null;
}
/**
 * 
 * @export
 * @interface FactureOpenSearchOpensearchFactureReadDossiersInner
 */
export interface FactureOpenSearchOpensearchFactureReadDossiersInner {
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureReadDossiersInner
     */
    'dossierNumero'?: string;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureReadDossiersInner
     */
    'dossierId'?: number;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureReadDossiersInner
     */
    'clientId'?: number;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureReadDossiersInner
     */
    'raisonSociale'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureReadDossiersInner
     */
    'libelleFormalite'?: string;
    /**
     * 
     * @type {string}
     * @memberof FactureOpenSearchOpensearchFactureReadDossiersInner
     */
    'collectionNumero'?: string;
    /**
     * 
     * @type {number}
     * @memberof FactureOpenSearchOpensearchFactureReadDossiersInner
     */
    'collectionId'?: number;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldPanierLienRead
 */
export interface FproDossierJsonldPanierLienRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof FproDossierJsonldPanierLienRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldPanierLienRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldPanierLienRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldPanierLienRead
     */
    'numero'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldPanierRead
 */
export interface FproDossierJsonldPanierRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof FproDossierJsonldPanierRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldPanierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldPanierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldPanierRead
     */
    'numero'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierJsonldPanierunitaireRead
 */
export interface FproDossierJsonldPanierunitaireRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof FproDossierJsonldPanierunitaireRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldPanierunitaireRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldPanierunitaireRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FproDossierJsonldPanierunitaireRead
     */
    'numero'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierPanierLienRead
 */
export interface FproDossierPanierLienRead {
    /**
     * 
     * @type {string}
     * @memberof FproDossierPanierLienRead
     */
    'numero'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierPanierRead
 */
export interface FproDossierPanierRead {
    /**
     * 
     * @type {string}
     * @memberof FproDossierPanierRead
     */
    'numero'?: string;
}
/**
 * 
 * @export
 * @interface FproDossierPanierunitaireRead
 */
export interface FproDossierPanierunitaireRead {
    /**
     * 
     * @type {string}
     * @memberof FproDossierPanierunitaireRead
     */
    'numero'?: string;
}
/**
 * 
 * @export
 * @interface GetActionLoggerCategory200Response
 */
export interface GetActionLoggerCategory200Response {
    /**
     * 
     * @type {Array<LogActionMapCategoryJsonldLogRead>}
     * @memberof GetActionLoggerCategory200Response
     */
    'hydra:member': Array<LogActionMapCategoryJsonldLogRead>;
    /**
     * 
     * @type {number}
     * @memberof GetActionLoggerCategory200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof GetActionLoggerCategory200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof GetActionLoggerCategory200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface GetActionLoggerCollectionDossier200Response
 */
export interface GetActionLoggerCollectionDossier200Response {
    /**
     * 
     * @type {Array<LogActionCollectionDossierJsonldLogReadExpanded>}
     * @memberof GetActionLoggerCollectionDossier200Response
     */
    'hydra:member': Array<LogActionCollectionDossierJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof GetActionLoggerCollectionDossier200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof GetActionLoggerCollectionDossier200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof GetActionLoggerCollectionDossier200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface GetActionLoggerDevis200Response
 */
export interface GetActionLoggerDevis200Response {
    /**
     * 
     * @type {Array<LogActionDevisJsonldLogReadExpanded>}
     * @memberof GetActionLoggerDevis200Response
     */
    'hydra:member': Array<LogActionDevisJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof GetActionLoggerDevis200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof GetActionLoggerDevis200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof GetActionLoggerDevis200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface GetActionLoggerDossier200Response
 */
export interface GetActionLoggerDossier200Response {
    /**
     * 
     * @type {Array<LogActionDossierJsonldLogReadExpanded>}
     * @memberof GetActionLoggerDossier200Response
     */
    'hydra:member': Array<LogActionDossierJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof GetActionLoggerDossier200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof GetActionLoggerDossier200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof GetActionLoggerDossier200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface GetActionLoggerFacture200Response
 */
export interface GetActionLoggerFacture200Response {
    /**
     * 
     * @type {Array<LogActionFactureJsonldLogReadExpanded>}
     * @memberof GetActionLoggerFacture200Response
     */
    'hydra:member': Array<LogActionFactureJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof GetActionLoggerFacture200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof GetActionLoggerFacture200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof GetActionLoggerFacture200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface GetActionLoggerTiers200Response
 */
export interface GetActionLoggerTiers200Response {
    /**
     * 
     * @type {Array<LogActionTiersJsonldLogReadExpanded>}
     * @memberof GetActionLoggerTiers200Response
     */
    'hydra:member': Array<LogActionTiersJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof GetActionLoggerTiers200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof GetActionLoggerTiers200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof GetActionLoggerTiers200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface GetActionLoggerUtilisateur200Response
 */
export interface GetActionLoggerUtilisateur200Response {
    /**
     * 
     * @type {Array<LogActionUtilisateurJsonldLogReadExpanded>}
     * @memberof GetActionLoggerUtilisateur200Response
     */
    'hydra:member': Array<LogActionUtilisateurJsonldLogReadExpanded>;
    /**
     * 
     * @type {number}
     * @memberof GetActionLoggerUtilisateur200Response
     */
    'hydra:totalItems'?: number;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraView}
     * @memberof GetActionLoggerUtilisateur200Response
     */
    'hydra:view'?: ApiDevisFormaliteGetCollection200ResponseHydraView;
    /**
     * 
     * @type {ApiDevisFormaliteGetCollection200ResponseHydraSearch}
     * @memberof GetActionLoggerUtilisateur200Response
     */
    'hydra:search'?: ApiDevisFormaliteGetCollection200ResponseHydraSearch;
}
/**
 * 
 * @export
 * @interface LigneFactureJsonldLigneFactureRead
 */
export interface LigneFactureJsonldLigneFactureRead {
    /**
     * 
     * @type {string}
     * @memberof LigneFactureJsonldLigneFactureRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LigneFactureJsonldLigneFactureRead
     */
    '@type'?: string;
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LigneFactureJsonldLigneFactureRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {number}
     * @memberof LigneFactureJsonldLigneFactureRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof LigneFactureJsonldLigneFactureRead
     */
    'rubriqueFacturation': string | null;
    /**
     * 
     * @type {string}
     * @memberof LigneFactureJsonldLigneFactureRead
     */
    'libelle': string | null;
}
/**
 * 
 * @export
 * @interface LigneFactureLigneFactureRead
 */
export interface LigneFactureLigneFactureRead {
    /**
     * 
     * @type {number}
     * @memberof LigneFactureLigneFactureRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof LigneFactureLigneFactureRead
     */
    'rubriqueFacturation': string | null;
    /**
     * 
     * @type {string}
     * @memberof LigneFactureLigneFactureRead
     */
    'libelle': string | null;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossier
 */
export interface LogActionCollectionDossier {
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossier
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossier
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionCollectionDossier
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossier
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossier
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossier
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossier
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierJsonld
 */
export interface LogActionCollectionDossierJsonld {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionCollectionDossierJsonld
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionCollectionDossierJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonld
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierJsonldLogRead
 */
export interface LogActionCollectionDossierJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierJsonldLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionCollectionDossierJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierJsonldLogReadExpanded
 */
export interface LogActionCollectionDossierJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierJsonldLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionCollectionDossierJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierJsonldLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierLogRead
 */
export interface LogActionCollectionDossierLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionCollectionDossierLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionCollectionDossierLogReadExpanded
 */
export interface LogActionCollectionDossierLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionCollectionDossierLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionCollectionDossierLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionCollectionDossierLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDevis
 */
export interface LogActionDevis {
    /**
     * 
     * @type {number}
     * @memberof LogActionDevis
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevis
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionDevis
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevis
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevis
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevis
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevis
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDevisJsonld
 */
export interface LogActionDevisJsonld {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionDevisJsonld
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionDevisJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonld
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDevisJsonldLogRead
 */
export interface LogActionDevisJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisJsonldLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionDevisJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDevisJsonldLogReadExpanded
 */
export interface LogActionDevisJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisJsonldLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionDevisJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisJsonldLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDevisLogRead
 */
export interface LogActionDevisLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionDevisLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDevisLogReadExpanded
 */
export interface LogActionDevisLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionDevisLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionDevisLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDevisLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDossier
 */
export interface LogActionDossier {
    /**
     * 
     * @type {number}
     * @memberof LogActionDossier
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossier
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossier
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionDossier
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossier
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossier
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossier
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossier
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDossierJsonld
 */
export interface LogActionDossierJsonld {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionDossierJsonld
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonld
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionDossierJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonld
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDossierJsonldLogRead
 */
export interface LogActionDossierJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonldLogRead
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonldLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionDossierJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDossierJsonldLogReadExpanded
 */
export interface LogActionDossierJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonldLogReadExpanded
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierJsonldLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionDossierJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierJsonldLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDossierLogRead
 */
export interface LogActionDossierLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogRead
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionDossierLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionDossierLogReadExpanded
 */
export interface LogActionDossierLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogReadExpanded
     */
    'idCollectionDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionDossierLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionDossierLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionDossierLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionFacture
 */
export interface LogActionFacture {
    /**
     * 
     * @type {number}
     * @memberof LogActionFacture
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionFacture
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionFacture
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionFacture
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFacture
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFacture
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFacture
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionFactureJsonld
 */
export interface LogActionFactureJsonld {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionFactureJsonld
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionFactureJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonld
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionFactureJsonldLogRead
 */
export interface LogActionFactureJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureJsonldLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionFactureJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionFactureJsonldLogReadExpanded
 */
export interface LogActionFactureJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureJsonldLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionFactureJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureJsonldLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionFactureLogRead
 */
export interface LogActionFactureLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionFactureLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionFactureLogReadExpanded
 */
export interface LogActionFactureLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionFactureLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionFactureLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionFactureLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryJsonldLogRead
 */
export interface LogActionMapCategoryJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionMapCategoryJsonldLogRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogRead
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryJsonldLogReadExpanded
 */
export interface LogActionMapCategoryJsonldLogReadExpanded {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionMapCategoryJsonldLogReadExpanded
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryJsonldLogReadExpanded
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryLogRead
 */
export interface LogActionMapCategoryLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryLogRead
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionMapCategoryLogReadExpanded
 */
export interface LogActionMapCategoryLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionMapCategoryLogReadExpanded
     */
    'category'?: string;
}
/**
 * 
 * @export
 * @interface LogActionTiers
 */
export interface LogActionTiers {
    /**
     * 
     * @type {number}
     * @memberof LogActionTiers
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiers
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionTiers
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiers
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiers
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiers
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiers
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionTiersJsonld
 */
export interface LogActionTiersJsonld {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionTiersJsonld
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionTiersJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonld
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionTiersJsonldLogRead
 */
export interface LogActionTiersJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersJsonldLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionTiersJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionTiersJsonldLogReadExpanded
 */
export interface LogActionTiersJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersJsonldLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionTiersJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersJsonldLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionTiersLogRead
 */
export interface LogActionTiersLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionTiersLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionTiersLogReadExpanded
 */
export interface LogActionTiersLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionTiersLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionTiersLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTiersLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionType
 */
export interface LogActionType {
    /**
     * 
     * @type {string}
     * @memberof LogActionType
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionType
     */
    'visibility'?: number;
    /**
     * 
     * @type {string}
     * @memberof LogActionType
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogActionType
     */
    'logCategories'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LogActionType
     */
    'actionType'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionTypeJsonld
 */
export interface LogActionTypeJsonld {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionTypeJsonld
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonld
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionTypeJsonld
     */
    'visibility'?: number;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonld
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LogActionTypeJsonld
     */
    'logCategories'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonld
     */
    'actionType'?: string | null;
}
/**
 * 
 * @export
 * @interface LogActionTypeJsonldLogRead
 */
export interface LogActionTypeJsonldLogRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionTypeJsonldLogRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogRead
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryJsonldLogRead>}
     * @memberof LogActionTypeJsonldLogRead
     */
    'logCategories'?: Array<LogActionMapCategoryJsonldLogRead>;
}
/**
 * 
 * @export
 * @interface LogActionTypeJsonldLogReadExpanded
 */
export interface LogActionTypeJsonldLogReadExpanded {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryJsonldLogReadExpanded>}
     * @memberof LogActionTypeJsonldLogReadExpanded
     */
    'logCategories'?: Array<LogActionMapCategoryJsonldLogReadExpanded>;
}
/**
 * 
 * @export
 * @interface LogActionTypeLogRead
 */
export interface LogActionTypeLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogRead
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogRead
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryLogRead>}
     * @memberof LogActionTypeLogRead
     */
    'logCategories'?: Array<LogActionMapCategoryLogRead>;
}
/**
 * 
 * @export
 * @interface LogActionTypeLogReadExpanded
 */
export interface LogActionTypeLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogReadExpanded
     */
    'actionTypeLibelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionTypeLogReadExpanded
     */
    'tagMail'?: string | null;
    /**
     * 
     * @type {Array<LogActionMapCategoryLogReadExpanded>}
     * @memberof LogActionTypeLogReadExpanded
     */
    'logCategories'?: Array<LogActionMapCategoryLogReadExpanded>;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateur
 */
export interface LogActionUtilisateur {
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateur
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateur
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionType}
     * @memberof LogActionUtilisateur
     */
    'actionType'?: LogActionType;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateur
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateur
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateur
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateur
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurJsonld
 */
export interface LogActionUtilisateurJsonld {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof LogActionUtilisateurJsonld
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurJsonld
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurJsonld
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonld}
     * @memberof LogActionUtilisateurJsonld
     */
    'actionType'?: LogActionTypeJsonld;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonld
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurJsonldLogRead
 */
export interface LogActionUtilisateurJsonldLogRead {
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogRead}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'actionType'?: LogActionTypeJsonldLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurJsonldLogReadExpanded
 */
export interface LogActionUtilisateurJsonldLogReadExpanded {
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeJsonldLogReadExpanded}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'actionType'?: LogActionTypeJsonldLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurJsonldLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurLogRead
 */
export interface LogActionUtilisateurLogRead {
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogRead
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogRead}
     * @memberof LogActionUtilisateurLogRead
     */
    'actionType'?: LogActionTypeLogRead;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogRead
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogRead
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogRead
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface LogActionUtilisateurLogReadExpanded
 */
export interface LogActionUtilisateurLogReadExpanded {
    /**
     * 
     * @type {number}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'entityId'?: number;
    /**
     * 
     * @type {LogActionTypeLogReadExpanded}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'actionType'?: LogActionTypeLogReadExpanded;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'logMessage'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'data'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'idUserKeycloak'?: string;
    /**
     * 
     * @type {string}
     * @memberof LogActionUtilisateurLogReadExpanded
     */
    'date'?: string;
}
/**
 * 
 * @export
 * @interface PanierPaiementJsonldLienpaiementpanierCreate
 */
export interface PanierPaiementJsonldLienpaiementpanierCreate {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    '@type'?: string;
    /**
     * identifiant du panier à payer
     * @type {number}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    'id': number | null;
    /**
     * Adresse mail pour le mail de validation
     * @type {string}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    'customerEmail'?: string;
    /**
     * Url de retour si paiement OK
     * @type {string}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    'normalReturnUrl'?: string;
    /**
     * Url de retour si paiement KO
     * @type {string}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    'cancelResponseUrl': string;
    /**
     * identifiant de l\'origine
     * @type {number}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    'origine': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    'collections'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    'factures'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PanierPaiementJsonldLienpaiementpanierCreate
     */
    'dossiers'?: Array<number>;
}
/**
 * 
 * @export
 * @interface PanierPaiementJsonldLienpanierrecouvrementCreate
 */
export interface PanierPaiementJsonldLienpanierrecouvrementCreate {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementCreate
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementCreate
     */
    '@type'?: string;
    /**
     * LeanPay internal client ID
     * @type {string}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementCreate
     */
    'clientId'?: string;
    /**
     * Id du client facturé
     * @type {string}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementCreate
     */
    'clientExternalId'?: string;
    /**
     * Document tag ID (when portal is scoped to a specific document tag)
     * @type {string}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementCreate
     */
    'documentTagId'?: string | null;
    /**
     * Human-readable label of the document tag
     * @type {string}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementCreate
     */
    'documentTagLabel'?: string | null;
}
/**
 * 
 * @export
 * @interface PanierPaiementJsonldLienpanierrecouvrementRead
 */
export interface PanierPaiementJsonldLienpanierrecouvrementRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldLienpanierrecouvrementRead
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface PanierPaiementJsonldPanierCreate
 */
export interface PanierPaiementJsonldPanierCreate {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof PanierPaiementJsonldPanierCreate
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierCreate
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierCreate
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PanierPaiementJsonldPanierCreate
     */
    'collections'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PanierPaiementJsonldPanierCreate
     */
    'factures'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PanierPaiementJsonldPanierCreate
     */
    'dossiers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PanierPaiementJsonldPanierLienRead
 */
export interface PanierPaiementJsonldPanierLienRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof PanierPaiementJsonldPanierLienRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierLienRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierLienRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PanierPaiementJsonldPanierLienRead
     */
    'id'?: number;
    /**
     * Get the value of lien
     * @type {Text}
     * @memberof PanierPaiementJsonldPanierLienRead
     */
    'lien'?: Text;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierLienRead
     */
    'dateCrea'?: string;
    /**
     * 
     * @type {Array<TblCollectionDossierJsonldPanierLienRead>}
     * @memberof PanierPaiementJsonldPanierLienRead
     */
    'collections'?: Array<TblCollectionDossierJsonldPanierLienRead>;
    /**
     * 
     * @type {Array<TblFacture2JsonldPanierLienRead>}
     * @memberof PanierPaiementJsonldPanierLienRead
     */
    'factures'?: Array<TblFacture2JsonldPanierLienRead>;
    /**
     * 
     * @type {Array<TblDossier2JsonldPanierLienRead>}
     * @memberof PanierPaiementJsonldPanierLienRead
     */
    'dossiers'?: Array<TblDossier2JsonldPanierLienRead>;
}
/**
 * 
 * @export
 * @interface PanierPaiementJsonldPanierRead
 */
export interface PanierPaiementJsonldPanierRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof PanierPaiementJsonldPanierRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PanierPaiementJsonldPanierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierRead
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierRead
     */
    'fdosDateCrea'?: string;
    /**
     * 
     * @type {Array<TblCollectionDossierJsonldPanierRead>}
     * @memberof PanierPaiementJsonldPanierRead
     */
    'collections'?: Array<TblCollectionDossierJsonldPanierRead>;
    /**
     * 
     * @type {Array<TblFacture2JsonldPanierRead>}
     * @memberof PanierPaiementJsonldPanierRead
     */
    'factures'?: Array<TblFacture2JsonldPanierRead>;
    /**
     * 
     * @type {Array<TblDossier2JsonldPanierRead>}
     * @memberof PanierPaiementJsonldPanierRead
     */
    'dossiers'?: Array<TblDossier2JsonldPanierRead>;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof PanierPaiementJsonldPanierRead
     */
    'ttcRestant'?: Decimal;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof PanierPaiementJsonldPanierRead
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierRead
     */
    'lien'?: string;
}
/**
 * 
 * @export
 * @interface PanierPaiementJsonldPanierunitaireRead
 */
export interface PanierPaiementJsonldPanierunitaireRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof PanierPaiementJsonldPanierunitaireRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierunitaireRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementJsonldPanierunitaireRead
     */
    '@type'?: string;
    /**
     * 
     * @type {TblPanierReglementJsonldPanierunitaireRead}
     * @memberof PanierPaiementJsonldPanierunitaireRead
     */
    'panier'?: TblPanierReglementJsonldPanierunitaireRead;
}
/**
 * 
 * @export
 * @interface PanierPaiementLienpaiementpanierCreate
 */
export interface PanierPaiementLienpaiementpanierCreate {
    /**
     * identifiant du panier à payer
     * @type {number}
     * @memberof PanierPaiementLienpaiementpanierCreate
     */
    'id': number | null;
    /**
     * Adresse mail pour le mail de validation
     * @type {string}
     * @memberof PanierPaiementLienpaiementpanierCreate
     */
    'customerEmail'?: string;
    /**
     * Url de retour si paiement OK
     * @type {string}
     * @memberof PanierPaiementLienpaiementpanierCreate
     */
    'normalReturnUrl'?: string;
    /**
     * Url de retour si paiement KO
     * @type {string}
     * @memberof PanierPaiementLienpaiementpanierCreate
     */
    'cancelResponseUrl': string;
    /**
     * identifiant de l\'origine
     * @type {number}
     * @memberof PanierPaiementLienpaiementpanierCreate
     */
    'origine': number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PanierPaiementLienpaiementpanierCreate
     */
    'collections'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PanierPaiementLienpaiementpanierCreate
     */
    'factures'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PanierPaiementLienpaiementpanierCreate
     */
    'dossiers'?: Array<number>;
}
/**
 * 
 * @export
 * @interface PanierPaiementLienpanierrecouvrementCreate
 */
export interface PanierPaiementLienpanierrecouvrementCreate {
    /**
     * LeanPay internal client ID
     * @type {string}
     * @memberof PanierPaiementLienpanierrecouvrementCreate
     */
    'clientId'?: string;
    /**
     * Id du client facturé
     * @type {string}
     * @memberof PanierPaiementLienpanierrecouvrementCreate
     */
    'clientExternalId'?: string;
    /**
     * Document tag ID (when portal is scoped to a specific document tag)
     * @type {string}
     * @memberof PanierPaiementLienpanierrecouvrementCreate
     */
    'documentTagId'?: string | null;
    /**
     * Human-readable label of the document tag
     * @type {string}
     * @memberof PanierPaiementLienpanierrecouvrementCreate
     */
    'documentTagLabel'?: string | null;
}
/**
 * 
 * @export
 * @interface PanierPaiementLienpanierrecouvrementRead
 */
export interface PanierPaiementLienpanierrecouvrementRead {
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementLienpanierrecouvrementRead
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface PanierPaiementPanierCreate
 */
export interface PanierPaiementPanierCreate {
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementPanierCreate
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PanierPaiementPanierCreate
     */
    'collections'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PanierPaiementPanierCreate
     */
    'factures'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PanierPaiementPanierCreate
     */
    'dossiers'?: Array<string>;
}
/**
 * 
 * @export
 * @interface PanierPaiementPanierLienRead
 */
export interface PanierPaiementPanierLienRead {
    /**
     * 
     * @type {number}
     * @memberof PanierPaiementPanierLienRead
     */
    'id'?: number;
    /**
     * Get the value of lien
     * @type {Text}
     * @memberof PanierPaiementPanierLienRead
     */
    'lien'?: Text;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementPanierLienRead
     */
    'dateCrea'?: string;
    /**
     * 
     * @type {Array<TblCollectionDossierPanierLienRead>}
     * @memberof PanierPaiementPanierLienRead
     */
    'collections'?: Array<TblCollectionDossierPanierLienRead>;
    /**
     * 
     * @type {Array<TblFacture2PanierLienRead>}
     * @memberof PanierPaiementPanierLienRead
     */
    'factures'?: Array<TblFacture2PanierLienRead>;
    /**
     * 
     * @type {Array<TblDossier2PanierLienRead>}
     * @memberof PanierPaiementPanierLienRead
     */
    'dossiers'?: Array<TblDossier2PanierLienRead>;
}
/**
 * 
 * @export
 * @interface PanierPaiementPanierRead
 */
export interface PanierPaiementPanierRead {
    /**
     * 
     * @type {number}
     * @memberof PanierPaiementPanierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementPanierRead
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementPanierRead
     */
    'fdosDateCrea'?: string;
    /**
     * 
     * @type {Array<TblCollectionDossierPanierRead>}
     * @memberof PanierPaiementPanierRead
     */
    'collections'?: Array<TblCollectionDossierPanierRead>;
    /**
     * 
     * @type {Array<TblFacture2PanierRead>}
     * @memberof PanierPaiementPanierRead
     */
    'factures'?: Array<TblFacture2PanierRead>;
    /**
     * 
     * @type {Array<TblDossier2PanierRead>}
     * @memberof PanierPaiementPanierRead
     */
    'dossiers'?: Array<TblDossier2PanierRead>;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof PanierPaiementPanierRead
     */
    'ttcRestant'?: Decimal;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof PanierPaiementPanierRead
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PanierPaiementPanierRead
     */
    'lien'?: string;
}
/**
 * 
 * @export
 * @interface PanierPaiementPanierunitaireRead
 */
export interface PanierPaiementPanierunitaireRead {
    /**
     * 
     * @type {TblPanierReglementPanierunitaireRead}
     * @memberof PanierPaiementPanierunitaireRead
     */
    'panier'?: TblPanierReglementPanierunitaireRead;
}
/**
 * 
 * @export
 * @interface PrestationTarifDTODonneesFacturationRead
 */
export interface PrestationTarifDTODonneesFacturationRead {
    /**
     * 
     * @type {number}
     * @memberof PrestationTarifDTODonneesFacturationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationTarifDTODonneesFacturationRead
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface PrestationTarifDTOJsonldDonneesFacturationRead
 */
export interface PrestationTarifDTOJsonldDonneesFacturationRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof PrestationTarifDTOJsonldDonneesFacturationRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof PrestationTarifDTOJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof PrestationTarifDTOJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PrestationTarifDTOJsonldDonneesFacturationRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrestationTarifDTOJsonldDonneesFacturationRead
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface ProvisionTarifDTODonneesFacturationRead
 */
export interface ProvisionTarifDTODonneesFacturationRead {
    /**
     * 
     * @type {string}
     * @memberof ProvisionTarifDTODonneesFacturationRead
     */
    'ttc'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProvisionTarifDTODonneesFacturationRead
     */
    'ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface ProvisionTarifDTOJsonldDonneesFacturationRead
 */
export interface ProvisionTarifDTOJsonldDonneesFacturationRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof ProvisionTarifDTOJsonldDonneesFacturationRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof ProvisionTarifDTOJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProvisionTarifDTOJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProvisionTarifDTOJsonldDonneesFacturationRead
     */
    'ttc'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProvisionTarifDTOJsonldDonneesFacturationRead
     */
    'ids'?: Array<number>;
}
/**
 * 
 * @export
 * @interface ReductionTarifDTODonneesFacturationRead
 */
export interface ReductionTarifDTODonneesFacturationRead {
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'rubFac'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'unite'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'quantite'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'prixBase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'montant'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'htReference'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'affiche'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'tauxTva'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'ttc'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'formalite'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'idAnnonce'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'cegidCompte'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'cegidSp1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'cegidSp2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'cegidTl1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'cegidTl2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'dossier'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReductionTarifDTODonneesFacturationRead
     */
    'idDrt'?: number;
}
/**
 * 
 * @export
 * @interface ReductionTarifDTOJsonldDonneesFacturationRead
 */
export interface ReductionTarifDTOJsonldDonneesFacturationRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'rubFac'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'unite'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'quantite'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'prixBase'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'montant'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'htReference'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'affiche'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'tauxTva'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'ttc'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'formalite'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'idAnnonce'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'cegidCompte'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'cegidSp1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'cegidSp2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'cegidTl1'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'cegidTl2'?: string;
    /**
     * 
     * @type {string}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'dossier'?: string;
    /**
     * 
     * @type {number}
     * @memberof ReductionTarifDTOJsonldDonneesFacturationRead
     */
    'idDrt'?: number;
}
/**
 * 
 * @export
 * @interface RemisesDesArticlesDePrestationFormalit
 */
export interface RemisesDesArticlesDePrestationFormalit {
    /**
     * 
     * @type {Array<number>}
     * @memberof RemisesDesArticlesDePrestationFormalit
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface RemisesDesArticlesDePrestationFormalitJsonld
 */
export interface RemisesDesArticlesDePrestationFormalitJsonld {
    /**
     * 
     * @type {string}
     * @memberof RemisesDesArticlesDePrestationFormalitJsonld
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RemisesDesArticlesDePrestationFormalitJsonld
     */
    '@type'?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof RemisesDesArticlesDePrestationFormalitJsonld
     */
    'ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface RemisesInvisiblesCumuleesTarifDTODonneesFacturationRead
 */
export interface RemisesInvisiblesCumuleesTarifDTODonneesFacturationRead {
    /**
     * 
     * @type {string}
     * @memberof RemisesInvisiblesCumuleesTarifDTODonneesFacturationRead
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof RemisesInvisiblesCumuleesTarifDTODonneesFacturationRead
     */
    'ttc'?: string;
}
/**
 * 
 * @export
 * @interface RemisesInvisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
 */
export interface RemisesInvisiblesCumuleesTarifDTOJsonldDonneesFacturationRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof RemisesInvisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof RemisesInvisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RemisesInvisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RemisesInvisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof RemisesInvisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
     */
    'ttc'?: string;
}
/**
 * 
 * @export
 * @interface RemisesVisiblesCumuleesTarifDTODonneesFacturationRead
 */
export interface RemisesVisiblesCumuleesTarifDTODonneesFacturationRead {
    /**
     * 
     * @type {string}
     * @memberof RemisesVisiblesCumuleesTarifDTODonneesFacturationRead
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof RemisesVisiblesCumuleesTarifDTODonneesFacturationRead
     */
    'ttc'?: string;
}
/**
 * 
 * @export
 * @interface RemisesVisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
 */
export interface RemisesVisiblesCumuleesTarifDTOJsonldDonneesFacturationRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof RemisesVisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof RemisesVisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof RemisesVisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof RemisesVisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
     */
    'ht'?: string;
    /**
     * 
     * @type {string}
     * @memberof RemisesVisiblesCumuleesTarifDTOJsonldDonneesFacturationRead
     */
    'ttc'?: string;
}
/**
 * 
 * @export
 * @interface TBLFactArticlesCategorieJsonldLigneDevisALRead
 */
export interface TBLFactArticlesCategorieJsonldLigneDevisALRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TBLFactArticlesCategorieJsonldLigneDevisALRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TBLFactArticlesCategorieJsonldLigneDevisALRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TBLFactArticlesCategorieJsonldLigneDevisALRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TBLFactArticlesCategorieJsonldLigneDevisALRead
     */
    'idCatArticle'?: number;
}
/**
 * 
 * @export
 * @interface TBLFactArticlesCategorieLigneDevisALRead
 */
export interface TBLFactArticlesCategorieLigneDevisALRead {
    /**
     * 
     * @type {number}
     * @memberof TBLFactArticlesCategorieLigneDevisALRead
     */
    'idCatArticle'?: number;
}
/**
 * 
 * @export
 * @interface TauxTvaDTODonneesFacturationRead
 */
export interface TauxTvaDTODonneesFacturationRead {
    /**
     * 
     * @type {string}
     * @memberof TauxTvaDTODonneesFacturationRead
     */
    'codeTva'?: string;
    /**
     * 
     * @type {string}
     * @memberof TauxTvaDTODonneesFacturationRead
     */
    'tauxTva'?: string;
}
/**
 * 
 * @export
 * @interface TauxTvaDTOJsonldDonneesFacturationRead
 */
export interface TauxTvaDTOJsonldDonneesFacturationRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TauxTvaDTOJsonldDonneesFacturationRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TauxTvaDTOJsonldDonneesFacturationRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TauxTvaDTOJsonldDonneesFacturationRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TauxTvaDTOJsonldDonneesFacturationRead
     */
    'codeTva'?: string;
    /**
     * 
     * @type {string}
     * @memberof TauxTvaDTOJsonldDonneesFacturationRead
     */
    'tauxTva'?: string;
}
/**
 * 
 * @export
 * @interface TblCollectionDossierJsonldPanierLienRead
 */
export interface TblCollectionDossierJsonldPanierLienRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblCollectionDossierJsonldPanierLienRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierLienRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierLienRead
     */
    '@type'?: string;
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblCollectionDossierJsonldPanierLienRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierLienRead
     */
    'numero'?: string | null;
    /**
     * Get the value of acompteAttendu
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierLienRead
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {Decimal}
     * @memberof TblCollectionDossierJsonldPanierLienRead
     */
    'acompteAttenduRestant'?: Decimal;
    /**
     * 
     * @type {Array<FproDossierJsonldPanierLienRead>}
     * @memberof TblCollectionDossierJsonldPanierLienRead
     */
    'dossiers'?: Array<FproDossierJsonldPanierLienRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierLienRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblCollectionDossierJsonldPanierRead
 */
export interface TblCollectionDossierJsonldPanierRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblCollectionDossierJsonldPanierRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierRead
     */
    '@type'?: string;
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblCollectionDossierJsonldPanierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {Decimal}
     * @memberof TblCollectionDossierJsonldPanierRead
     */
    'acompteAttenduRestant'?: Decimal;
    /**
     * 
     * @type {Array<FproDossierJsonldPanierRead>}
     * @memberof TblCollectionDossierJsonldPanierRead
     */
    'dossiers'?: Array<FproDossierJsonldPanierRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblCollectionDossierJsonldPanierunitaireRead
 */
export interface TblCollectionDossierJsonldPanierunitaireRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblCollectionDossierJsonldPanierunitaireRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierunitaireRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierunitaireRead
     */
    '@type'?: string;
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblCollectionDossierJsonldPanierunitaireRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierunitaireRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {Decimal}
     * @memberof TblCollectionDossierJsonldPanierunitaireRead
     */
    'acompteAttenduRestant'?: Decimal;
    /**
     * 
     * @type {Array<FproDossierJsonldPanierunitaireRead>}
     * @memberof TblCollectionDossierJsonldPanierunitaireRead
     */
    'dossiers'?: Array<FproDossierJsonldPanierunitaireRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblCollectionDossierJsonldPanierunitaireRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblCollectionDossierPanierLienRead
 */
export interface TblCollectionDossierPanierLienRead {
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblCollectionDossierPanierLienRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierPanierLienRead
     */
    'numero'?: string | null;
    /**
     * Get the value of acompteAttendu
     * @type {string}
     * @memberof TblCollectionDossierPanierLienRead
     */
    'acompteAttendu'?: string | null;
    /**
     * 
     * @type {Decimal}
     * @memberof TblCollectionDossierPanierLienRead
     */
    'acompteAttenduRestant'?: Decimal;
    /**
     * 
     * @type {Array<FproDossierPanierLienRead>}
     * @memberof TblCollectionDossierPanierLienRead
     */
    'dossiers'?: Array<FproDossierPanierLienRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblCollectionDossierPanierLienRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblCollectionDossierPanierRead
 */
export interface TblCollectionDossierPanierRead {
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblCollectionDossierPanierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierPanierRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {Decimal}
     * @memberof TblCollectionDossierPanierRead
     */
    'acompteAttenduRestant'?: Decimal;
    /**
     * 
     * @type {Array<FproDossierPanierRead>}
     * @memberof TblCollectionDossierPanierRead
     */
    'dossiers'?: Array<FproDossierPanierRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblCollectionDossierPanierRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblCollectionDossierPanierunitaireRead
 */
export interface TblCollectionDossierPanierunitaireRead {
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblCollectionDossierPanierunitaireRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblCollectionDossierPanierunitaireRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {Decimal}
     * @memberof TblCollectionDossierPanierunitaireRead
     */
    'acompteAttenduRestant'?: Decimal;
    /**
     * 
     * @type {Array<FproDossierPanierunitaireRead>}
     * @memberof TblCollectionDossierPanierunitaireRead
     */
    'dossiers'?: Array<FproDossierPanierunitaireRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblCollectionDossierPanierunitaireRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblDefDomaineJsonldLigneDevisALRead
 */
export interface TblDefDomaineJsonldLigneDevisALRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblDefDomaineJsonldLigneDevisALRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblDefDomaineJsonldLigneDevisALRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDefDomaineJsonldLigneDevisALRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblDefDomaineJsonldLigneDevisALRead
     */
    'ddmId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblDefDomaineJsonldLigneDevisALRead
     */
    'ddmLibelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblDefDomaineLigneDevisALRead
 */
export interface TblDefDomaineLigneDevisALRead {
    /**
     * 
     * @type {number}
     * @memberof TblDefDomaineLigneDevisALRead
     */
    'ddmId'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblDefDomaineLigneDevisALRead
     */
    'ddmLibelle'?: string | null;
}
/**
 * 
 * @export
 * @interface TblDevisDevisLignesRead
 */
export interface TblDevisDevisLignesRead {
    /**
     * 
     * @type {number}
     * @memberof TblDevisDevisLignesRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblDevisDevisLignesRead
     */
    'dossierAl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisDevisLignesRead
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {object}
     * @memberof TblDevisDevisLignesRead
     */
    'societe'?: object;
    /**
     * 
     * @type {string}
     * @memberof TblDevisDevisLignesRead
     */
    'prescripteur'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDevisDevisLignesRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisDevisLignesRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDevisDevisLignesRead
     */
    'auteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisDevisLignesRead
     */
    'totalHt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisDevisLignesRead
     */
    'totalTva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisDevisLignesRead
     */
    'totalTtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisDevisLignesRead
     */
    'file'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblDevisDevisLignesRead
     */
    'actif'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblDevisDevisLignesRead
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblDevisDevisLignesRead
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblDevisJsonldDevisLignesRead
 */
export interface TblDevisJsonldDevisLignesRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'dossierAl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {TblSocieteJsonldDevisLignesRead}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'societe'?: TblSocieteJsonldDevisLignesRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'prescripteur'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'auteur'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'totalHt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'totalTva'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'totalTtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'file'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'actif'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'demo'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblDevisJsonldDevisLignesRead
     */
    'deleted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TblDevisLignesDevisRead
 */
export interface TblDevisLignesDevisRead {
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesDevisRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesDevisRead
     */
    'numero'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'rubfac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'unite'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesDevisRead
     */
    'quantite'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'prixBase'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesDevisRead
     */
    'numeroTva'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesDevisRead
     */
    'tauxTva'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'tva'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblDevisLignesDevisRead
     */
    'affiche'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'compte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'cegidCompte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'cegidSp1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'cegidSp2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'cegidTl1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'cegidTl2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'cegidTl3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'dep'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesDevisRead
     */
    'jal'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesDevisRead
     */
    'idAnnonce'?: number | null;
}
/**
 * 
 * @export
 * @interface TblDevisLignesJsonldDevisRead
 */
export interface TblDevisLignesJsonldDevisRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'numero'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'rubfac'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'unite'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'quantite'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'prixBase'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'numeroTva'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'tauxTva'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'ht'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'tva'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'affiche'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'compte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'cegidCompte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'cegidSp1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'cegidSp2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'cegidTl1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'cegidTl2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'cegidTl3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'dep'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'jal'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblDevisLignesJsonldDevisRead
     */
    'idAnnonce'?: number | null;
}
/**
 * 
 * @export
 * @interface TblDossier2JsonldPanierLienRead
 */
export interface TblDossier2JsonldPanierLienRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblDossier2JsonldPanierLienRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPanierLienRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPanierLienRead
     */
    '@type'?: string;
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblDossier2JsonldPanierLienRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2JsonldPanierLienRead
     */
    'numero'?: number | null;
    /**
     * Get the value of ttc
     * @type {Decimal}
     * @memberof TblDossier2JsonldPanierLienRead
     */
    'ttc'?: Decimal;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblDossier2JsonldPanierLienRead
     */
    'ttcRestant'?: Decimal;
    /**
     * 
     * @type {Array<TblPrestaJsonldPanierLienRead>}
     * @memberof TblDossier2JsonldPanierLienRead
     */
    'prestations'?: Array<TblPrestaJsonldPanierLienRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblDossier2JsonldPanierLienRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblDossier2JsonldPanierRead
 */
export interface TblDossier2JsonldPanierRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblDossier2JsonldPanierRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPanierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPanierRead
     */
    '@type'?: string;
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblDossier2JsonldPanierRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2JsonldPanierRead
     */
    'numero'?: number | null;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblDossier2JsonldPanierRead
     */
    'ttcRestant'?: Decimal;
    /**
     * 
     * @type {Array<TblPrestaJsonldPanierRead>}
     * @memberof TblDossier2JsonldPanierRead
     */
    'prestations'?: Array<TblPrestaJsonldPanierRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblDossier2JsonldPanierRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblDossier2JsonldPanierunitaireRead
 */
export interface TblDossier2JsonldPanierunitaireRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblDossier2JsonldPanierunitaireRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPanierunitaireRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblDossier2JsonldPanierunitaireRead
     */
    '@type'?: string;
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblDossier2JsonldPanierunitaireRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2JsonldPanierunitaireRead
     */
    'numero'?: number | null;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblDossier2JsonldPanierunitaireRead
     */
    'ttcRestant'?: Decimal;
    /**
     * 
     * @type {Array<TblPrestaJsonldPanierunitaireRead>}
     * @memberof TblDossier2JsonldPanierunitaireRead
     */
    'prestations'?: Array<TblPrestaJsonldPanierunitaireRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblDossier2JsonldPanierunitaireRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblDossier2PanierLienRead
 */
export interface TblDossier2PanierLienRead {
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblDossier2PanierLienRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2PanierLienRead
     */
    'numero'?: number | null;
    /**
     * Get the value of ttc
     * @type {Decimal}
     * @memberof TblDossier2PanierLienRead
     */
    'ttc'?: Decimal;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblDossier2PanierLienRead
     */
    'ttcRestant'?: Decimal;
    /**
     * 
     * @type {Array<TblPrestaPanierLienRead>}
     * @memberof TblDossier2PanierLienRead
     */
    'prestations'?: Array<TblPrestaPanierLienRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblDossier2PanierLienRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblDossier2PanierRead
 */
export interface TblDossier2PanierRead {
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblDossier2PanierRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2PanierRead
     */
    'numero'?: number | null;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblDossier2PanierRead
     */
    'ttcRestant'?: Decimal;
    /**
     * 
     * @type {Array<TblPrestaPanierRead>}
     * @memberof TblDossier2PanierRead
     */
    'prestations'?: Array<TblPrestaPanierRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblDossier2PanierRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblDossier2PanierunitaireRead
 */
export interface TblDossier2PanierunitaireRead {
    /**
     * identifiant de la collection
     * @type {number}
     * @memberof TblDossier2PanierunitaireRead
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblDossier2PanierunitaireRead
     */
    'numero'?: number | null;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblDossier2PanierunitaireRead
     */
    'ttcRestant'?: Decimal;
    /**
     * 
     * @type {Array<TblPrestaPanierunitaireRead>}
     * @memberof TblDossier2PanierunitaireRead
     */
    'prestations'?: Array<TblPrestaPanierunitaireRead>;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblDossier2PanierunitaireRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblFactArticlesJsonldFactureReadTimestampableBlameambleGroup
 */
export interface TblFactArticlesJsonldFactureReadTimestampableBlameambleGroup {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblFactArticlesJsonldFactureReadTimestampableBlameambleGroup
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldFactureReadTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldFactureReadTimestampableBlameambleGroup
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TblFactArticlesJsonldLigneDevisALRead
 */
export interface TblFactArticlesJsonldLigneDevisALRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblFactArticlesJsonldLigneDevisALRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldLigneDevisALRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldLigneDevisALRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesJsonldLigneDevisALRead
     */
    'idarticle'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldLigneDevisALRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesJsonldLigneDevisALRead
     */
    'rubArticle'?: string | null;
    /**
     * 
     * @type {TblDefDomaineJsonldLigneDevisALRead}
     * @memberof TblFactArticlesJsonldLigneDevisALRead
     */
    'ddm'?: TblDefDomaineJsonldLigneDevisALRead;
    /**
     * 
     * @type {TBLFactArticlesCategorieJsonldLigneDevisALRead}
     * @memberof TblFactArticlesJsonldLigneDevisALRead
     */
    'idCatArticle'?: TBLFactArticlesCategorieJsonldLigneDevisALRead | null;
    /**
     * 
     * @type {Array<TblFactArticlesJsonldLigneDevisALRead>}
     * @memberof TblFactArticlesJsonldLigneDevisALRead
     */
    'articlesLinked'?: Array<TblFactArticlesJsonldLigneDevisALRead>;
}
/**
 * 
 * @export
 * @interface TblFactArticlesLigneDevisALRead
 */
export interface TblFactArticlesLigneDevisALRead {
    /**
     * 
     * @type {number}
     * @memberof TblFactArticlesLigneDevisALRead
     */
    'idarticle'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesLigneDevisALRead
     */
    'libelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFactArticlesLigneDevisALRead
     */
    'rubArticle'?: string | null;
    /**
     * 
     * @type {TblDefDomaineLigneDevisALRead}
     * @memberof TblFactArticlesLigneDevisALRead
     */
    'ddm'?: TblDefDomaineLigneDevisALRead;
    /**
     * 
     * @type {TBLFactArticlesCategorieLigneDevisALRead}
     * @memberof TblFactArticlesLigneDevisALRead
     */
    'idCatArticle'?: TBLFactArticlesCategorieLigneDevisALRead | null;
    /**
     * 
     * @type {Array<TblFactArticlesLigneDevisALRead>}
     * @memberof TblFactArticlesLigneDevisALRead
     */
    'articlesLinked'?: Array<TblFactArticlesLigneDevisALRead>;
}
/**
 * 
 * @export
 * @interface TblFacture2JsonldPanierLienRead
 */
export interface TblFacture2JsonldPanierLienRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    '@type'?: string;
    /**
     * identifiant de la facture
     * @type {number}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    'dateFacture'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    'totalTtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    'montantPaiementRecu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    'cegidLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    'dateEcheanceFacture'?: string | null;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    'ttcRestant'?: Decimal;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblFacture2JsonldPanierLienRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblFacture2JsonldPanierRead
 */
export interface TblFacture2JsonldPanierRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblFacture2JsonldPanierRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierRead
     */
    '@type'?: string;
    /**
     * identifiant de la facture
     * @type {number}
     * @memberof TblFacture2JsonldPanierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {TblDossier2JsonldPanierRead}
     * @memberof TblFacture2JsonldPanierRead
     */
    'dossierAl'?: TblDossier2JsonldPanierRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierRead
     */
    'dateFacture'?: string;
    /**
     * 
     * @type {Array<TblCollectionDossierJsonldPanierRead>}
     * @memberof TblFacture2JsonldPanierRead
     */
    'collections'?: Array<TblCollectionDossierJsonldPanierRead>;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblFacture2JsonldPanierRead
     */
    'ttcRestant'?: Decimal;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblFacture2JsonldPanierRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblFacture2JsonldPanierunitaireRead
 */
export interface TblFacture2JsonldPanierunitaireRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    '@type'?: string;
    /**
     * identifiant de la facture
     * @type {number}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {TblDossier2JsonldPanierunitaireRead}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    'dossierAl'?: TblDossier2JsonldPanierunitaireRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    'dateFacture'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    'dateEcheanceFacture'?: string | null;
    /**
     * 
     * @type {Array<TblCollectionDossierJsonldPanierunitaireRead>}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    'collections'?: Array<TblCollectionDossierJsonldPanierunitaireRead>;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    'ttcRestant'?: Decimal;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblFacture2JsonldPanierunitaireRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblFacture2PanierLienRead
 */
export interface TblFacture2PanierLienRead {
    /**
     * identifiant de la facture
     * @type {number}
     * @memberof TblFacture2PanierLienRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierLienRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierLienRead
     */
    'dateFacture'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierLienRead
     */
    'totalTtc'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierLienRead
     */
    'montantPaiementRecu'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierLienRead
     */
    'cegidLibelle'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierLienRead
     */
    'dateEcheanceFacture'?: string | null;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblFacture2PanierLienRead
     */
    'ttcRestant'?: Decimal;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblFacture2PanierLienRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblFacture2PanierRead
 */
export interface TblFacture2PanierRead {
    /**
     * identifiant de la facture
     * @type {number}
     * @memberof TblFacture2PanierRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {TblDossier2PanierRead}
     * @memberof TblFacture2PanierRead
     */
    'dossierAl'?: TblDossier2PanierRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierRead
     */
    'dateFacture'?: string;
    /**
     * 
     * @type {Array<TblCollectionDossierPanierRead>}
     * @memberof TblFacture2PanierRead
     */
    'collections'?: Array<TblCollectionDossierPanierRead>;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblFacture2PanierRead
     */
    'ttcRestant'?: Decimal;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblFacture2PanierRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblFacture2PanierunitaireRead
 */
export interface TblFacture2PanierunitaireRead {
    /**
     * identifiant de la facture
     * @type {number}
     * @memberof TblFacture2PanierunitaireRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierunitaireRead
     */
    'numero'?: string | null;
    /**
     * 
     * @type {TblDossier2PanierunitaireRead}
     * @memberof TblFacture2PanierunitaireRead
     */
    'dossierAl'?: TblDossier2PanierunitaireRead | null;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierunitaireRead
     */
    'dateFacture'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFacture2PanierunitaireRead
     */
    'dateEcheanceFacture'?: string | null;
    /**
     * 
     * @type {Array<TblCollectionDossierPanierunitaireRead>}
     * @memberof TblFacture2PanierunitaireRead
     */
    'collections'?: Array<TblCollectionDossierPanierunitaireRead>;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblFacture2PanierunitaireRead
     */
    'ttcRestant'?: Decimal;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblFacture2PanierunitaireRead
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface TblFligneFactureCreate
 */
export interface TblFligneFactureCreate {
    /**
     * Get the value of idFproPrestaFormArt
     * @type {string}
     * @memberof TblFligneFactureCreate
     */
    'idFproPrestaFormArt'?: string | null;
}
/**
 * 
 * @export
 * @interface TblFligneFactureReadTimestampableBlameambleGroup
 */
export interface TblFligneFactureReadTimestampableBlameambleGroup {
    /**
     * 
     * @type {number}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * Numero de la ligne (permet de jouer sur l\'ordre d\'apparition dans le pdf)
     * @type {number}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'numeroLigne'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'jal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'rubriqueFacturation': string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'libelle': string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'unite': string | null;
    /**
     * 
     * @type {number}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'quantite': number | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'prixBase': string | null;
    /**
     * 
     * @type {number}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'tauxTva': number | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'montant'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'debours'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'compte'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'affiche'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'flux'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'formalite'?: boolean | null;
    /**
     * 
     * @type {object}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'idAnnonce'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'factureDiverse'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'cegidCompte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'cegidSp1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'cegidSp2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'cegidTl1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'cegidTl2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'cegidTl3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'dprTypeTarif'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'idTat'?: number;
    /**
     * 
     * @type {object}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'idArticle'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'rrrAvoInterdit'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'htReference'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'dnidVersionPresta'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'idDrt'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'rrrPaye'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'datePaiementRrr'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'rrrRefuse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'rrrAvoTraite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'dateTraitementRrrAvo'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'tarifLogoEnteteV3'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'rrrAvoReferenceTheorique'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'rrrAvoReferenceReel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'tauxRrrAvoReel'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'dateRrrAvoReel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'idUserRrrAvoReel'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'cmdDrtIdDetails'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblFligneFactureReadTimestampableBlameambleGroup
     */
    'articleDossierKey'?: string | null;
}
/**
 * 
 * @export
 * @interface TblFligneJsonldFactureCreate
 */
export interface TblFligneJsonldFactureCreate {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblFligneJsonldFactureCreate
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureCreate
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureCreate
     */
    '@type'?: string;
    /**
     * Get the value of idFproPrestaFormArt
     * @type {string}
     * @memberof TblFligneJsonldFactureCreate
     */
    'idFproPrestaFormArt'?: string | null;
}
/**
 * 
 * @export
 * @interface TblFligneJsonldFactureReadTimestampableBlameambleGroup
 */
export interface TblFligneJsonldFactureReadTimestampableBlameambleGroup {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'id'?: number;
    /**
     * Numero de la ligne (permet de jouer sur l\'ordre d\'apparition dans le pdf)
     * @type {number}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'numeroLigne'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'jal'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'rubriqueFacturation': string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'libelle': string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'unite': string | null;
    /**
     * 
     * @type {number}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'quantite': number | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'prixBase': string | null;
    /**
     * 
     * @type {number}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'tauxTva': number | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'montant'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'debours'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'compte'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'affiche'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'flux'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'formalite'?: boolean | null;
    /**
     * 
     * @type {TblPrestaJsonldFactureReadTimestampableBlameambleGroup}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'idAnnonce'?: TblPrestaJsonldFactureReadTimestampableBlameambleGroup | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'factureDiverse'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidCompte'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidSp1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidSp2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidTl1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidTl2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'cegidTl3'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'dossier'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'dprTypeTarif'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'idTat'?: number;
    /**
     * 
     * @type {TblFactArticlesJsonldFactureReadTimestampableBlameambleGroup}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'idArticle'?: TblFactArticlesJsonldFactureReadTimestampableBlameambleGroup;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'rrrAvoInterdit'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'htReference'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'dnidVersionPresta'?: number;
    /**
     * 
     * @type {number}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'idDrt'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'rrrPaye'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'datePaiementRrr'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'rrrRefuse'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'rrrAvoTraite'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateTraitementRrrAvo'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'tarifLogoEnteteV3'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'rrrAvoReferenceTheorique'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'rrrAvoReferenceReel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'tauxRrrAvoReel'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'dateRrrAvoReel'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'idUserRrrAvoReel'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'cmdDrtIdDetails'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TblFligneJsonldFactureReadTimestampableBlameambleGroup
     */
    'articleDossierKey'?: string | null;
}
/**
 * 
 * @export
 * @interface TblPanierReglementJsonldPanierunitaireRead
 */
export interface TblPanierReglementJsonldPanierunitaireRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    '@type'?: string;
    /**
     * 
     * @type {number}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    'fdosDateCrea'?: string;
    /**
     * 
     * @type {Array<TblCollectionDossierJsonldPanierunitaireRead>}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    'collections'?: Array<TblCollectionDossierJsonldPanierunitaireRead>;
    /**
     * 
     * @type {Array<TblFacture2JsonldPanierunitaireRead>}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    'factures'?: Array<TblFacture2JsonldPanierunitaireRead>;
    /**
     * 
     * @type {Array<TblDossier2JsonldPanierunitaireRead>}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    'dossiers'?: Array<TblDossier2JsonldPanierunitaireRead>;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    'ttcRestant'?: Decimal;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblPanierReglementJsonldPanierunitaireRead
     */
    'lien'?: string;
}
/**
 * 
 * @export
 * @interface TblPanierReglementPanierunitaireRead
 */
export interface TblPanierReglementPanierunitaireRead {
    /**
     * 
     * @type {number}
     * @memberof TblPanierReglementPanierunitaireRead
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof TblPanierReglementPanierunitaireRead
     */
    'infoComp'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TblPanierReglementPanierunitaireRead
     */
    'fdosDateCrea'?: string;
    /**
     * 
     * @type {Array<TblCollectionDossierPanierunitaireRead>}
     * @memberof TblPanierReglementPanierunitaireRead
     */
    'collections'?: Array<TblCollectionDossierPanierunitaireRead>;
    /**
     * 
     * @type {Array<TblFacture2PanierunitaireRead>}
     * @memberof TblPanierReglementPanierunitaireRead
     */
    'factures'?: Array<TblFacture2PanierunitaireRead>;
    /**
     * 
     * @type {Array<TblDossier2PanierunitaireRead>}
     * @memberof TblPanierReglementPanierunitaireRead
     */
    'dossiers'?: Array<TblDossier2PanierunitaireRead>;
    /**
     * Get the value of ttcRestant
     * @type {Decimal}
     * @memberof TblPanierReglementPanierunitaireRead
     */
    'ttcRestant'?: Decimal;
    /**
     * Get the value of uuid
     * @type {string}
     * @memberof TblPanierReglementPanierunitaireRead
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblPanierReglementPanierunitaireRead
     */
    'lien'?: string;
}
/**
 * 
 * @export
 * @interface TblPrestaJsonldFactureReadTimestampableBlameambleGroup
 */
export interface TblPrestaJsonldFactureReadTimestampableBlameambleGroup {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblPrestaJsonldFactureReadTimestampableBlameambleGroup
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldFactureReadTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldFactureReadTimestampableBlameambleGroup
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TblPrestaJsonldPanierLienRead
 */
export interface TblPrestaJsonldPanierLienRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblPrestaJsonldPanierLienRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldPanierLienRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldPanierLienRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldPanierLienRead
     */
    'numero'?: string | null;
}
/**
 * 
 * @export
 * @interface TblPrestaJsonldPanierRead
 */
export interface TblPrestaJsonldPanierRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblPrestaJsonldPanierRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldPanierRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldPanierRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldPanierRead
     */
    'numero'?: string | null;
}
/**
 * 
 * @export
 * @interface TblPrestaJsonldPanierunitaireRead
 */
export interface TblPrestaJsonldPanierunitaireRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblPrestaJsonldPanierunitaireRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldPanierunitaireRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldPanierunitaireRead
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblPrestaJsonldPanierunitaireRead
     */
    'numero'?: string | null;
}
/**
 * 
 * @export
 * @interface TblPrestaPanierLienRead
 */
export interface TblPrestaPanierLienRead {
    /**
     * 
     * @type {string}
     * @memberof TblPrestaPanierLienRead
     */
    'numero'?: string | null;
}
/**
 * 
 * @export
 * @interface TblPrestaPanierRead
 */
export interface TblPrestaPanierRead {
    /**
     * 
     * @type {string}
     * @memberof TblPrestaPanierRead
     */
    'numero'?: string | null;
}
/**
 * 
 * @export
 * @interface TblPrestaPanierunitaireRead
 */
export interface TblPrestaPanierunitaireRead {
    /**
     * 
     * @type {string}
     * @memberof TblPrestaPanierunitaireRead
     */
    'numero'?: string | null;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsFactureReadTimestampableBlameambleGroup
 */
export interface TblReglement2DetailsFactureReadTimestampableBlameambleGroup {
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsFactureReadTimestampableBlameambleGroup
     */
    'ttc'?: string;
}
/**
 * 
 * @export
 * @interface TblReglement2DetailsJsonldFactureReadTimestampableBlameambleGroup
 */
export interface TblReglement2DetailsJsonldFactureReadTimestampableBlameambleGroup {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblReglement2DetailsJsonldFactureReadTimestampableBlameambleGroup
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldFactureReadTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldFactureReadTimestampableBlameambleGroup
     */
    '@type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblReglement2DetailsJsonldFactureReadTimestampableBlameambleGroup
     */
    'ttc'?: string;
}
/**
 * 
 * @export
 * @interface TblSocieteJsonldDevisLignesRead
 */
export interface TblSocieteJsonldDevisLignesRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblSocieteJsonldDevisLignesRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblSocieteJsonldDevisLignesRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblSocieteJsonldDevisLignesRead
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TblSocieteJsonldDevisRead
 */
export interface TblSocieteJsonldDevisRead {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblSocieteJsonldDevisRead
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblSocieteJsonldDevisRead
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblSocieteJsonldDevisRead
     */
    '@type'?: string;
}
/**
 * 
 * @export
 * @interface TblSocieteJsonldFactureReadTimestampableBlameambleGroup
 */
export interface TblSocieteJsonldFactureReadTimestampableBlameambleGroup {
    /**
     * 
     * @type {AjustementDePrestationFormalitJsonldContext}
     * @memberof TblSocieteJsonldFactureReadTimestampableBlameambleGroup
     */
    '@context'?: AjustementDePrestationFormalitJsonldContext;
    /**
     * 
     * @type {string}
     * @memberof TblSocieteJsonldFactureReadTimestampableBlameambleGroup
     */
    '@id'?: string;
    /**
     * 
     * @type {string}
     * @memberof TblSocieteJsonldFactureReadTimestampableBlameambleGroup
     */
    '@type'?: string;
}

/**
 * ActionLoggerApi - axios parameter creator
 * @export
 */
export const ActionLoggerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste les logs filtré par visibilité
         * @param {string} entityId LogActionCollectionDossier identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionCollectionDossierClientEntityIdGetCollection: async (entityId: string, xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionCollectionDossierClientEntityIdGetCollection', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-collection-dossier-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionCollectionDossier resource.
         * @summary Ajout des logs callback via communication provider
         * @param {LogActionCollectionDossierJsonld} logActionCollectionDossierJsonld The new LogActionCollectionDossier resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionCollectionDossiersFormatPost: async (logActionCollectionDossierJsonld: LogActionCollectionDossierJsonld, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionCollectionDossierJsonld' is not null or undefined
            assertParamExists('apiLogActionCollectionDossiersFormatPost', 'logActionCollectionDossierJsonld', logActionCollectionDossierJsonld)
            const localVarPath = `/facturation/log_action_collection_dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionCollectionDossierJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste les logs filtré par visibilité
         * @param {string} entityId LogActionDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDevisClientEntityIdGetCollection: async (entityId: string, xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionDevisClientEntityIdGetCollection', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-devis-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionDevis resource.
         * @summary Ajout des logs callback via communication provider
         * @param {LogActionDevisJsonld} logActionDevisJsonld The new LogActionDevis resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDevisFormatPost: async (logActionDevisJsonld: LogActionDevisJsonld, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionDevisJsonld' is not null or undefined
            assertParamExists('apiLogActionDevisFormatPost', 'logActionDevisJsonld', logActionDevisJsonld)
            const localVarPath = `/facturation/log_action_devis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionDevisJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste les logs filtré par visibilité
         * @param {string} entityId LogActionFacture identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionFactureClientEntityIdGetCollection: async (entityId: string, xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionFactureClientEntityIdGetCollection', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-facture-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionFacture resource.
         * @summary Ajout des logs callback via communication provider
         * @param {LogActionFactureJsonld} logActionFactureJsonld The new LogActionFacture resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionFacturesFormatPost: async (logActionFactureJsonld: LogActionFactureJsonld, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionFactureJsonld' is not null or undefined
            assertParamExists('apiLogActionFacturesFormatPost', 'logActionFactureJsonld', logActionFactureJsonld)
            const localVarPath = `/facturation/log_action_factures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionFactureJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste les logs filtré par visibilité
         * @param {string} entityId LogActionTiers identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionTiersClientEntityIdGetCollection: async (entityId: string, xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionTiersClientEntityIdGetCollection', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-tiers-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionTiers resource.
         * @summary Ajout des logs callback via communication provider
         * @param {LogActionTiersJsonld} logActionTiersJsonld The new LogActionTiers resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionTiersFormatPost: async (logActionTiersJsonld: LogActionTiersJsonld, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionTiersJsonld' is not null or undefined
            assertParamExists('apiLogActionTiersFormatPost', 'logActionTiersJsonld', logActionTiersJsonld)
            const localVarPath = `/facturation/log_action_tiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionTiersJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste les logs filtré par visibilité
         * @param {string} entityId LogActionUtilisateur identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionUtilisateurClientEntityIdGetCollection: async (entityId: string, xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionUtilisateurClientEntityIdGetCollection', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-utilisateur-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionUtilisateur resource.
         * @summary Ajout des logs callback via communication provider
         * @param {LogActionUtilisateurJsonld} logActionUtilisateurJsonld The new LogActionUtilisateur resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionUtilisateursFormatPost: async (logActionUtilisateurJsonld: LogActionUtilisateurJsonld, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionUtilisateurJsonld' is not null or undefined
            assertParamExists('apiLogActionUtilisateursFormatPost', 'logActionUtilisateurJsonld', logActionUtilisateurJsonld)
            const localVarPath = `/facturation/log_action_utilisateurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionUtilisateurJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs lié à une catégorie (admin)
         * @param {string} category LogActionMapCategory identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerByCategory: async (category: string, xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('getActionLoggerByCategory', 'category', category)
            const localVarPath = `/facturation/log-action-category/{category}`
                .replace(`{${"category"}}`, encodeURIComponent(String(category)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerCategory: async (xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/log-action-category`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionCollectionDossier identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerCollectionDossier: async (entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getActionLoggerCollectionDossier', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-collection-dossier/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerDevis: async (entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getActionLoggerDevis', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-devis/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionDossier identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerDossier: async (entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getActionLoggerDossier', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-dossier/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionFacture identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerFacture: async (entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getActionLoggerFacture', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-facture/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionTiers identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerTiers: async (entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getActionLoggerTiers', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-tiers/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionUtilisateur identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerUtilisateur: async (entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getActionLoggerUtilisateur', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-utilisateur/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (withTech !== undefined) {
                localVarQueryParameter['with-tech'] = withTech;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActionLoggerApi - functional programming interface
 * @export
 */
export const ActionLoggerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActionLoggerApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste les logs filtré par visibilité
         * @param {string} entityId LogActionCollectionDossier identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionCollectionDossierClientEntityIdGetCollection(entityId: string, xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionCollectionDossierClientEntityIdGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionCollectionDossierClientEntityIdGetCollection(entityId, xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionCollectionDossierClientEntityIdGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionCollectionDossier resource.
         * @summary Ajout des logs callback via communication provider
         * @param {LogActionCollectionDossierJsonld} logActionCollectionDossierJsonld The new LogActionCollectionDossier resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionCollectionDossiersFormatPost(logActionCollectionDossierJsonld: LogActionCollectionDossierJsonld, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionCollectionDossierJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionCollectionDossiersFormatPost(logActionCollectionDossierJsonld, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionCollectionDossiersFormatPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste les logs filtré par visibilité
         * @param {string} entityId LogActionDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionDevisClientEntityIdGetCollection(entityId: string, xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionDevisClientEntityIdGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionDevisClientEntityIdGetCollection(entityId, xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionDevisClientEntityIdGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionDevis resource.
         * @summary Ajout des logs callback via communication provider
         * @param {LogActionDevisJsonld} logActionDevisJsonld The new LogActionDevis resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionDevisFormatPost(logActionDevisJsonld: LogActionDevisJsonld, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionDevisJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionDevisFormatPost(logActionDevisJsonld, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionDevisFormatPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste les logs filtré par visibilité
         * @param {string} entityId LogActionFacture identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionFactureClientEntityIdGetCollection(entityId: string, xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionFactureClientEntityIdGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionFactureClientEntityIdGetCollection(entityId, xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionFactureClientEntityIdGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionFacture resource.
         * @summary Ajout des logs callback via communication provider
         * @param {LogActionFactureJsonld} logActionFactureJsonld The new LogActionFacture resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionFacturesFormatPost(logActionFactureJsonld: LogActionFactureJsonld, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionFactureJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionFacturesFormatPost(logActionFactureJsonld, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionFacturesFormatPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste les logs filtré par visibilité
         * @param {string} entityId LogActionTiers identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionTiersClientEntityIdGetCollection(entityId: string, xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionTiersClientEntityIdGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionTiersClientEntityIdGetCollection(entityId, xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionTiersClientEntityIdGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionTiers resource.
         * @summary Ajout des logs callback via communication provider
         * @param {LogActionTiersJsonld} logActionTiersJsonld The new LogActionTiers resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionTiersFormatPost(logActionTiersJsonld: LogActionTiersJsonld, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionTiersJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionTiersFormatPost(logActionTiersJsonld, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionTiersFormatPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste les logs filtré par visibilité
         * @param {string} entityId LogActionUtilisateur identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionUtilisateurClientEntityIdGetCollection(entityId: string, xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionUtilisateurClientEntityIdGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionUtilisateurClientEntityIdGetCollection(entityId, xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionUtilisateurClientEntityIdGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionUtilisateur resource.
         * @summary Ajout des logs callback via communication provider
         * @param {LogActionUtilisateurJsonld} logActionUtilisateurJsonld The new LogActionUtilisateur resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionUtilisateursFormatPost(logActionUtilisateurJsonld: LogActionUtilisateurJsonld, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionUtilisateurJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionUtilisateursFormatPost(logActionUtilisateurJsonld, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.apiLogActionUtilisateursFormatPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs lié à une catégorie (admin)
         * @param {string} category LogActionMapCategory identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLoggerByCategory(category: string, xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionLoggerCategory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLoggerByCategory(category, xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.getActionLoggerByCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLoggerCategory(xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionLoggerCategory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLoggerCategory(xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.getActionLoggerCategory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionCollectionDossier identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLoggerCollectionDossier(entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionLoggerCollectionDossier200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLoggerCollectionDossier(entityId, xIdSociete, withTech, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.getActionLoggerCollectionDossier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLoggerDevis(entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionLoggerDevis200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLoggerDevis(entityId, xIdSociete, withTech, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.getActionLoggerDevis']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionDossier identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLoggerDossier(entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionLoggerDossier200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLoggerDossier(entityId, xIdSociete, withTech, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.getActionLoggerDossier']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionFacture identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLoggerFacture(entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionLoggerFacture200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLoggerFacture(entityId, xIdSociete, withTech, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.getActionLoggerFacture']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionTiers identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLoggerTiers(entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionLoggerTiers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLoggerTiers(entityId, xIdSociete, withTech, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.getActionLoggerTiers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste tous les logs
         * @param {string} entityId LogActionUtilisateur identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {boolean} [withTech] Boolean pour remonter les logs technique
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActionLoggerUtilisateur(entityId: string, xIdSociete?: number, withTech?: boolean, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActionLoggerUtilisateur200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActionLoggerUtilisateur(entityId, xIdSociete, withTech, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActionLoggerApi.getActionLoggerUtilisateur']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActionLoggerApi - factory interface
 * @export
 */
export const ActionLoggerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActionLoggerApiFp(configuration)
    return {
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste les logs filtré par visibilité
         * @param {ActionLoggerApiApiLogActionCollectionDossierClientEntityIdGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionCollectionDossierClientEntityIdGetCollection(requestParameters: ActionLoggerApiApiLogActionCollectionDossierClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionCollectionDossierClientEntityIdGetCollection200Response> {
            return localVarFp.apiLogActionCollectionDossierClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionCollectionDossier resource.
         * @summary Ajout des logs callback via communication provider
         * @param {ActionLoggerApiApiLogActionCollectionDossiersFormatPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionCollectionDossiersFormatPost(requestParameters: ActionLoggerApiApiLogActionCollectionDossiersFormatPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionCollectionDossierJsonld> {
            return localVarFp.apiLogActionCollectionDossiersFormatPost(requestParameters.logActionCollectionDossierJsonld, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste les logs filtré par visibilité
         * @param {ActionLoggerApiApiLogActionDevisClientEntityIdGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDevisClientEntityIdGetCollection(requestParameters: ActionLoggerApiApiLogActionDevisClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionDevisClientEntityIdGetCollection200Response> {
            return localVarFp.apiLogActionDevisClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionDevis resource.
         * @summary Ajout des logs callback via communication provider
         * @param {ActionLoggerApiApiLogActionDevisFormatPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDevisFormatPost(requestParameters: ActionLoggerApiApiLogActionDevisFormatPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionDevisJsonld> {
            return localVarFp.apiLogActionDevisFormatPost(requestParameters.logActionDevisJsonld, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste les logs filtré par visibilité
         * @param {ActionLoggerApiApiLogActionFactureClientEntityIdGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionFactureClientEntityIdGetCollection(requestParameters: ActionLoggerApiApiLogActionFactureClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionFactureClientEntityIdGetCollection200Response> {
            return localVarFp.apiLogActionFactureClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionFacture resource.
         * @summary Ajout des logs callback via communication provider
         * @param {ActionLoggerApiApiLogActionFacturesFormatPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionFacturesFormatPost(requestParameters: ActionLoggerApiApiLogActionFacturesFormatPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionFactureJsonld> {
            return localVarFp.apiLogActionFacturesFormatPost(requestParameters.logActionFactureJsonld, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste les logs filtré par visibilité
         * @param {ActionLoggerApiApiLogActionTiersClientEntityIdGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionTiersClientEntityIdGetCollection(requestParameters: ActionLoggerApiApiLogActionTiersClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionTiersClientEntityIdGetCollection200Response> {
            return localVarFp.apiLogActionTiersClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionTiers resource.
         * @summary Ajout des logs callback via communication provider
         * @param {ActionLoggerApiApiLogActionTiersFormatPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionTiersFormatPost(requestParameters: ActionLoggerApiApiLogActionTiersFormatPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionTiersJsonld> {
            return localVarFp.apiLogActionTiersFormatPost(requestParameters.logActionTiersJsonld, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste les logs filtré par visibilité
         * @param {ActionLoggerApiApiLogActionUtilisateurClientEntityIdGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionUtilisateurClientEntityIdGetCollection(requestParameters: ActionLoggerApiApiLogActionUtilisateurClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionUtilisateurClientEntityIdGetCollection200Response> {
            return localVarFp.apiLogActionUtilisateurClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionUtilisateur resource.
         * @summary Ajout des logs callback via communication provider
         * @param {ActionLoggerApiApiLogActionUtilisateursFormatPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionUtilisateursFormatPost(requestParameters: ActionLoggerApiApiLogActionUtilisateursFormatPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionUtilisateurJsonld> {
            return localVarFp.apiLogActionUtilisateursFormatPost(requestParameters.logActionUtilisateurJsonld, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs lié à une catégorie (admin)
         * @param {ActionLoggerApiGetActionLoggerByCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerByCategory(requestParameters: ActionLoggerApiGetActionLoggerByCategoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActionLoggerCategory200Response> {
            return localVarFp.getActionLoggerByCategory(requestParameters.category, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionMapCategory resources.
         * @summary Liste tous les logs
         * @param {ActionLoggerApiGetActionLoggerCategoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerCategory(requestParameters: ActionLoggerApiGetActionLoggerCategoryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetActionLoggerCategory200Response> {
            return localVarFp.getActionLoggerCategory(requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionCollectionDossier resources.
         * @summary Liste tous les logs
         * @param {ActionLoggerApiGetActionLoggerCollectionDossierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerCollectionDossier(requestParameters: ActionLoggerApiGetActionLoggerCollectionDossierRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActionLoggerCollectionDossier200Response> {
            return localVarFp.getActionLoggerCollectionDossier(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionDevis resources.
         * @summary Liste tous les logs
         * @param {ActionLoggerApiGetActionLoggerDevisRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerDevis(requestParameters: ActionLoggerApiGetActionLoggerDevisRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActionLoggerDevis200Response> {
            return localVarFp.getActionLoggerDevis(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Liste tous les logs
         * @param {ActionLoggerApiGetActionLoggerDossierRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerDossier(requestParameters: ActionLoggerApiGetActionLoggerDossierRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActionLoggerDossier200Response> {
            return localVarFp.getActionLoggerDossier(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionFacture resources.
         * @summary Liste tous les logs
         * @param {ActionLoggerApiGetActionLoggerFactureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerFacture(requestParameters: ActionLoggerApiGetActionLoggerFactureRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActionLoggerFacture200Response> {
            return localVarFp.getActionLoggerFacture(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionTiers resources.
         * @summary Liste tous les logs
         * @param {ActionLoggerApiGetActionLoggerTiersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerTiers(requestParameters: ActionLoggerApiGetActionLoggerTiersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActionLoggerTiers200Response> {
            return localVarFp.getActionLoggerTiers(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the collection of LogActionUtilisateur resources.
         * @summary Liste tous les logs
         * @param {ActionLoggerApiGetActionLoggerUtilisateurRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActionLoggerUtilisateur(requestParameters: ActionLoggerApiGetActionLoggerUtilisateurRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActionLoggerUtilisateur200Response> {
            return localVarFp.getActionLoggerUtilisateur(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLogActionCollectionDossierClientEntityIdGetCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionCollectionDossierClientEntityIdGetCollectionRequest
 */
export interface ActionLoggerApiApiLogActionCollectionDossierClientEntityIdGetCollectionRequest {
    /**
     * LogActionCollectionDossier identifier
     * @type {string}
     * @memberof ActionLoggerApiApiLogActionCollectionDossierClientEntityIdGetCollection
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionCollectionDossierClientEntityIdGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionCollectionDossierClientEntityIdGetCollection
     */
    readonly page?: number
}

/**
 * Request parameters for apiLogActionCollectionDossiersFormatPost operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionCollectionDossiersFormatPostRequest
 */
export interface ActionLoggerApiApiLogActionCollectionDossiersFormatPostRequest {
    /**
     * The new LogActionCollectionDossier resource
     * @type {LogActionCollectionDossierJsonld}
     * @memberof ActionLoggerApiApiLogActionCollectionDossiersFormatPost
     */
    readonly logActionCollectionDossierJsonld: LogActionCollectionDossierJsonld

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionCollectionDossiersFormatPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiLogActionDevisClientEntityIdGetCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionDevisClientEntityIdGetCollectionRequest
 */
export interface ActionLoggerApiApiLogActionDevisClientEntityIdGetCollectionRequest {
    /**
     * LogActionDevis identifier
     * @type {string}
     * @memberof ActionLoggerApiApiLogActionDevisClientEntityIdGetCollection
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDevisClientEntityIdGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDevisClientEntityIdGetCollection
     */
    readonly page?: number
}

/**
 * Request parameters for apiLogActionDevisFormatPost operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionDevisFormatPostRequest
 */
export interface ActionLoggerApiApiLogActionDevisFormatPostRequest {
    /**
     * The new LogActionDevis resource
     * @type {LogActionDevisJsonld}
     * @memberof ActionLoggerApiApiLogActionDevisFormatPost
     */
    readonly logActionDevisJsonld: LogActionDevisJsonld

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionDevisFormatPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiLogActionFactureClientEntityIdGetCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionFactureClientEntityIdGetCollectionRequest
 */
export interface ActionLoggerApiApiLogActionFactureClientEntityIdGetCollectionRequest {
    /**
     * LogActionFacture identifier
     * @type {string}
     * @memberof ActionLoggerApiApiLogActionFactureClientEntityIdGetCollection
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionFactureClientEntityIdGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionFactureClientEntityIdGetCollection
     */
    readonly page?: number
}

/**
 * Request parameters for apiLogActionFacturesFormatPost operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionFacturesFormatPostRequest
 */
export interface ActionLoggerApiApiLogActionFacturesFormatPostRequest {
    /**
     * The new LogActionFacture resource
     * @type {LogActionFactureJsonld}
     * @memberof ActionLoggerApiApiLogActionFacturesFormatPost
     */
    readonly logActionFactureJsonld: LogActionFactureJsonld

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionFacturesFormatPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiLogActionTiersClientEntityIdGetCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionTiersClientEntityIdGetCollectionRequest
 */
export interface ActionLoggerApiApiLogActionTiersClientEntityIdGetCollectionRequest {
    /**
     * LogActionTiers identifier
     * @type {string}
     * @memberof ActionLoggerApiApiLogActionTiersClientEntityIdGetCollection
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionTiersClientEntityIdGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionTiersClientEntityIdGetCollection
     */
    readonly page?: number
}

/**
 * Request parameters for apiLogActionTiersFormatPost operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionTiersFormatPostRequest
 */
export interface ActionLoggerApiApiLogActionTiersFormatPostRequest {
    /**
     * The new LogActionTiers resource
     * @type {LogActionTiersJsonld}
     * @memberof ActionLoggerApiApiLogActionTiersFormatPost
     */
    readonly logActionTiersJsonld: LogActionTiersJsonld

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionTiersFormatPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiLogActionUtilisateurClientEntityIdGetCollection operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionUtilisateurClientEntityIdGetCollectionRequest
 */
export interface ActionLoggerApiApiLogActionUtilisateurClientEntityIdGetCollectionRequest {
    /**
     * LogActionUtilisateur identifier
     * @type {string}
     * @memberof ActionLoggerApiApiLogActionUtilisateurClientEntityIdGetCollection
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionUtilisateurClientEntityIdGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionUtilisateurClientEntityIdGetCollection
     */
    readonly page?: number
}

/**
 * Request parameters for apiLogActionUtilisateursFormatPost operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiApiLogActionUtilisateursFormatPostRequest
 */
export interface ActionLoggerApiApiLogActionUtilisateursFormatPostRequest {
    /**
     * The new LogActionUtilisateur resource
     * @type {LogActionUtilisateurJsonld}
     * @memberof ActionLoggerApiApiLogActionUtilisateursFormatPost
     */
    readonly logActionUtilisateurJsonld: LogActionUtilisateurJsonld

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiApiLogActionUtilisateursFormatPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for getActionLoggerByCategory operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiGetActionLoggerByCategoryRequest
 */
export interface ActionLoggerApiGetActionLoggerByCategoryRequest {
    /**
     * LogActionMapCategory identifier
     * @type {string}
     * @memberof ActionLoggerApiGetActionLoggerByCategory
     */
    readonly category: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerByCategory
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerByCategory
     */
    readonly page?: number
}

/**
 * Request parameters for getActionLoggerCategory operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiGetActionLoggerCategoryRequest
 */
export interface ActionLoggerApiGetActionLoggerCategoryRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerCategory
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerCategory
     */
    readonly page?: number
}

/**
 * Request parameters for getActionLoggerCollectionDossier operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiGetActionLoggerCollectionDossierRequest
 */
export interface ActionLoggerApiGetActionLoggerCollectionDossierRequest {
    /**
     * LogActionCollectionDossier identifier
     * @type {string}
     * @memberof ActionLoggerApiGetActionLoggerCollectionDossier
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerCollectionDossier
     */
    readonly xIdSociete?: number

    /**
     * Boolean pour remonter les logs technique
     * @type {boolean}
     * @memberof ActionLoggerApiGetActionLoggerCollectionDossier
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerCollectionDossier
     */
    readonly page?: number
}

/**
 * Request parameters for getActionLoggerDevis operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiGetActionLoggerDevisRequest
 */
export interface ActionLoggerApiGetActionLoggerDevisRequest {
    /**
     * LogActionDevis identifier
     * @type {string}
     * @memberof ActionLoggerApiGetActionLoggerDevis
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerDevis
     */
    readonly xIdSociete?: number

    /**
     * Boolean pour remonter les logs technique
     * @type {boolean}
     * @memberof ActionLoggerApiGetActionLoggerDevis
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerDevis
     */
    readonly page?: number
}

/**
 * Request parameters for getActionLoggerDossier operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiGetActionLoggerDossierRequest
 */
export interface ActionLoggerApiGetActionLoggerDossierRequest {
    /**
     * LogActionDossier identifier
     * @type {string}
     * @memberof ActionLoggerApiGetActionLoggerDossier
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerDossier
     */
    readonly xIdSociete?: number

    /**
     * Boolean pour remonter les logs technique
     * @type {boolean}
     * @memberof ActionLoggerApiGetActionLoggerDossier
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerDossier
     */
    readonly page?: number
}

/**
 * Request parameters for getActionLoggerFacture operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiGetActionLoggerFactureRequest
 */
export interface ActionLoggerApiGetActionLoggerFactureRequest {
    /**
     * LogActionFacture identifier
     * @type {string}
     * @memberof ActionLoggerApiGetActionLoggerFacture
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerFacture
     */
    readonly xIdSociete?: number

    /**
     * Boolean pour remonter les logs technique
     * @type {boolean}
     * @memberof ActionLoggerApiGetActionLoggerFacture
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerFacture
     */
    readonly page?: number
}

/**
 * Request parameters for getActionLoggerTiers operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiGetActionLoggerTiersRequest
 */
export interface ActionLoggerApiGetActionLoggerTiersRequest {
    /**
     * LogActionTiers identifier
     * @type {string}
     * @memberof ActionLoggerApiGetActionLoggerTiers
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerTiers
     */
    readonly xIdSociete?: number

    /**
     * Boolean pour remonter les logs technique
     * @type {boolean}
     * @memberof ActionLoggerApiGetActionLoggerTiers
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerTiers
     */
    readonly page?: number
}

/**
 * Request parameters for getActionLoggerUtilisateur operation in ActionLoggerApi.
 * @export
 * @interface ActionLoggerApiGetActionLoggerUtilisateurRequest
 */
export interface ActionLoggerApiGetActionLoggerUtilisateurRequest {
    /**
     * LogActionUtilisateur identifier
     * @type {string}
     * @memberof ActionLoggerApiGetActionLoggerUtilisateur
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerUtilisateur
     */
    readonly xIdSociete?: number

    /**
     * Boolean pour remonter les logs technique
     * @type {boolean}
     * @memberof ActionLoggerApiGetActionLoggerUtilisateur
     */
    readonly withTech?: boolean

    /**
     * The collection page number
     * @type {number}
     * @memberof ActionLoggerApiGetActionLoggerUtilisateur
     */
    readonly page?: number
}

/**
 * ActionLoggerApi - object-oriented interface
 * @export
 * @class ActionLoggerApi
 * @extends {BaseAPI}
 */
export class ActionLoggerApi extends BaseAPI {
    /**
     * Retrieves the collection of LogActionCollectionDossier resources.
     * @summary Liste les logs filtré par visibilité
     * @param {ActionLoggerApiApiLogActionCollectionDossierClientEntityIdGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionCollectionDossierClientEntityIdGetCollection(requestParameters: ActionLoggerApiApiLogActionCollectionDossierClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionCollectionDossierClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionCollectionDossier resource.
     * @summary Ajout des logs callback via communication provider
     * @param {ActionLoggerApiApiLogActionCollectionDossiersFormatPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionCollectionDossiersFormatPost(requestParameters: ActionLoggerApiApiLogActionCollectionDossiersFormatPostRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionCollectionDossiersFormatPost(requestParameters.logActionCollectionDossierJsonld, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionDevis resources.
     * @summary Liste les logs filtré par visibilité
     * @param {ActionLoggerApiApiLogActionDevisClientEntityIdGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionDevisClientEntityIdGetCollection(requestParameters: ActionLoggerApiApiLogActionDevisClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionDevisClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionDevis resource.
     * @summary Ajout des logs callback via communication provider
     * @param {ActionLoggerApiApiLogActionDevisFormatPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionDevisFormatPost(requestParameters: ActionLoggerApiApiLogActionDevisFormatPostRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionDevisFormatPost(requestParameters.logActionDevisJsonld, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionFacture resources.
     * @summary Liste les logs filtré par visibilité
     * @param {ActionLoggerApiApiLogActionFactureClientEntityIdGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionFactureClientEntityIdGetCollection(requestParameters: ActionLoggerApiApiLogActionFactureClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionFactureClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionFacture resource.
     * @summary Ajout des logs callback via communication provider
     * @param {ActionLoggerApiApiLogActionFacturesFormatPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionFacturesFormatPost(requestParameters: ActionLoggerApiApiLogActionFacturesFormatPostRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionFacturesFormatPost(requestParameters.logActionFactureJsonld, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionTiers resources.
     * @summary Liste les logs filtré par visibilité
     * @param {ActionLoggerApiApiLogActionTiersClientEntityIdGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionTiersClientEntityIdGetCollection(requestParameters: ActionLoggerApiApiLogActionTiersClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionTiersClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionTiers resource.
     * @summary Ajout des logs callback via communication provider
     * @param {ActionLoggerApiApiLogActionTiersFormatPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionTiersFormatPost(requestParameters: ActionLoggerApiApiLogActionTiersFormatPostRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionTiersFormatPost(requestParameters.logActionTiersJsonld, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionUtilisateur resources.
     * @summary Liste les logs filtré par visibilité
     * @param {ActionLoggerApiApiLogActionUtilisateurClientEntityIdGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionUtilisateurClientEntityIdGetCollection(requestParameters: ActionLoggerApiApiLogActionUtilisateurClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionUtilisateurClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionUtilisateur resource.
     * @summary Ajout des logs callback via communication provider
     * @param {ActionLoggerApiApiLogActionUtilisateursFormatPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public apiLogActionUtilisateursFormatPost(requestParameters: ActionLoggerApiApiLogActionUtilisateursFormatPostRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).apiLogActionUtilisateursFormatPost(requestParameters.logActionUtilisateurJsonld, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionMapCategory resources.
     * @summary Liste tous les logs lié à une catégorie (admin)
     * @param {ActionLoggerApiGetActionLoggerByCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public getActionLoggerByCategory(requestParameters: ActionLoggerApiGetActionLoggerByCategoryRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).getActionLoggerByCategory(requestParameters.category, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionMapCategory resources.
     * @summary Liste tous les logs
     * @param {ActionLoggerApiGetActionLoggerCategoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public getActionLoggerCategory(requestParameters: ActionLoggerApiGetActionLoggerCategoryRequest = {}, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).getActionLoggerCategory(requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionCollectionDossier resources.
     * @summary Liste tous les logs
     * @param {ActionLoggerApiGetActionLoggerCollectionDossierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public getActionLoggerCollectionDossier(requestParameters: ActionLoggerApiGetActionLoggerCollectionDossierRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).getActionLoggerCollectionDossier(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionDevis resources.
     * @summary Liste tous les logs
     * @param {ActionLoggerApiGetActionLoggerDevisRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public getActionLoggerDevis(requestParameters: ActionLoggerApiGetActionLoggerDevisRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).getActionLoggerDevis(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionDossier resources.
     * @summary Liste tous les logs
     * @param {ActionLoggerApiGetActionLoggerDossierRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public getActionLoggerDossier(requestParameters: ActionLoggerApiGetActionLoggerDossierRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).getActionLoggerDossier(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionFacture resources.
     * @summary Liste tous les logs
     * @param {ActionLoggerApiGetActionLoggerFactureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public getActionLoggerFacture(requestParameters: ActionLoggerApiGetActionLoggerFactureRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).getActionLoggerFacture(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionTiers resources.
     * @summary Liste tous les logs
     * @param {ActionLoggerApiGetActionLoggerTiersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public getActionLoggerTiers(requestParameters: ActionLoggerApiGetActionLoggerTiersRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).getActionLoggerTiers(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the collection of LogActionUtilisateur resources.
     * @summary Liste tous les logs
     * @param {ActionLoggerApiGetActionLoggerUtilisateurRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActionLoggerApi
     */
    public getActionLoggerUtilisateur(requestParameters: ActionLoggerApiGetActionLoggerUtilisateurRequest, options?: RawAxiosRequestConfig) {
        return ActionLoggerApiFp(this.configuration).getActionLoggerUtilisateur(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.withTech, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AjustementDePrestationFormalitApi - axios parameter creator
 * @export
 */
export const AjustementDePrestationFormalitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Ajuster la prestation pour atteindre le montant de la provision si + ou - 15€
         * @summary Ajuster la prestation pour atteindre le montant de la provision
         * @param {AjustementDePrestationFormalitJsonldAjustementCreate} ajustementDePrestationFormalitJsonldAjustementCreate The new Ajustement de prestation formalité resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAjustementArticlesPrestationPost: async (ajustementDePrestationFormalitJsonldAjustementCreate: AjustementDePrestationFormalitJsonldAjustementCreate, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ajustementDePrestationFormalitJsonldAjustementCreate' is not null or undefined
            assertParamExists('apiAjustementArticlesPrestationPost', 'ajustementDePrestationFormalitJsonldAjustementCreate', ajustementDePrestationFormalitJsonldAjustementCreate)
            const localVarPath = `/facturation/ajustement-articles-prestation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ajustementDePrestationFormalitJsonldAjustementCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AjustementDePrestationFormalitApi - functional programming interface
 * @export
 */
export const AjustementDePrestationFormalitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AjustementDePrestationFormalitApiAxiosParamCreator(configuration)
    return {
        /**
         * Ajuster la prestation pour atteindre le montant de la provision si + ou - 15€
         * @summary Ajuster la prestation pour atteindre le montant de la provision
         * @param {AjustementDePrestationFormalitJsonldAjustementCreate} ajustementDePrestationFormalitJsonldAjustementCreate The new Ajustement de prestation formalité resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAjustementArticlesPrestationPost(ajustementDePrestationFormalitJsonldAjustementCreate: AjustementDePrestationFormalitJsonldAjustementCreate, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AjustementDePrestationFormalitJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAjustementArticlesPrestationPost(ajustementDePrestationFormalitJsonldAjustementCreate, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AjustementDePrestationFormalitApi.apiAjustementArticlesPrestationPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AjustementDePrestationFormalitApi - factory interface
 * @export
 */
export const AjustementDePrestationFormalitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AjustementDePrestationFormalitApiFp(configuration)
    return {
        /**
         * Ajuster la prestation pour atteindre le montant de la provision si + ou - 15€
         * @summary Ajuster la prestation pour atteindre le montant de la provision
         * @param {AjustementDePrestationFormalitApiApiAjustementArticlesPrestationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAjustementArticlesPrestationPost(requestParameters: AjustementDePrestationFormalitApiApiAjustementArticlesPrestationPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<AjustementDePrestationFormalitJsonld> {
            return localVarFp.apiAjustementArticlesPrestationPost(requestParameters.ajustementDePrestationFormalitJsonldAjustementCreate, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiAjustementArticlesPrestationPost operation in AjustementDePrestationFormalitApi.
 * @export
 * @interface AjustementDePrestationFormalitApiApiAjustementArticlesPrestationPostRequest
 */
export interface AjustementDePrestationFormalitApiApiAjustementArticlesPrestationPostRequest {
    /**
     * The new Ajustement de prestation formalité resource
     * @type {AjustementDePrestationFormalitJsonldAjustementCreate}
     * @memberof AjustementDePrestationFormalitApiApiAjustementArticlesPrestationPost
     */
    readonly ajustementDePrestationFormalitJsonldAjustementCreate: AjustementDePrestationFormalitJsonldAjustementCreate

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof AjustementDePrestationFormalitApiApiAjustementArticlesPrestationPost
     */
    readonly xIdSociete?: number
}

/**
 * AjustementDePrestationFormalitApi - object-oriented interface
 * @export
 * @class AjustementDePrestationFormalitApi
 * @extends {BaseAPI}
 */
export class AjustementDePrestationFormalitApi extends BaseAPI {
    /**
     * Ajuster la prestation pour atteindre le montant de la provision si + ou - 15€
     * @summary Ajuster la prestation pour atteindre le montant de la provision
     * @param {AjustementDePrestationFormalitApiApiAjustementArticlesPrestationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AjustementDePrestationFormalitApi
     */
    public apiAjustementArticlesPrestationPost(requestParameters: AjustementDePrestationFormalitApiApiAjustementArticlesPrestationPostRequest, options?: RawAxiosRequestConfig) {
        return AjustementDePrestationFormalitApiFp(this.configuration).apiAjustementArticlesPrestationPost(requestParameters.ajustementDePrestationFormalitJsonldAjustementCreate, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArticlesEtRemisesDesDossiersDeFormalitApi - axios parameter creator
 * @export
 */
export const ArticlesEtRemisesDesDossiersDeFormalitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les articles et les réductions possibles un dossier de formalité
         * @summary Lister les articles et les réductions possibles un dossier de formalité
         * @param {Array<number>} ids Identifiants des dossiers de formalité
         * @param {Array<number>} idsSelected Identifiants des dossiers à prendre en compte pour le total
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReductionArticlesDossierGetCollection: async (ids: Array<number>, idsSelected: Array<number>, xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiReductionArticlesDossierGetCollection', 'ids', ids)
            // verify required parameter 'idsSelected' is not null or undefined
            assertParamExists('apiReductionArticlesDossierGetCollection', 'idsSelected', idsSelected)
            const localVarPath = `/facturation/reduction-articles-dossier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (idsSelected) {
                localVarQueryParameter['idsSelected'] = idsSelected.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArticlesEtRemisesDesDossiersDeFormalitApi - functional programming interface
 * @export
 */
export const ArticlesEtRemisesDesDossiersDeFormalitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArticlesEtRemisesDesDossiersDeFormalitApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les articles et les réductions possibles un dossier de formalité
         * @summary Lister les articles et les réductions possibles un dossier de formalité
         * @param {Array<number>} ids Identifiants des dossiers de formalité
         * @param {Array<number>} idsSelected Identifiants des dossiers à prendre en compte pour le total
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReductionArticlesDossierGetCollection(ids: Array<number>, idsSelected: Array<number>, xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiReductionArticlesDossierGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReductionArticlesDossierGetCollection(ids, idsSelected, xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticlesEtRemisesDesDossiersDeFormalitApi.apiReductionArticlesDossierGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArticlesEtRemisesDesDossiersDeFormalitApi - factory interface
 * @export
 */
export const ArticlesEtRemisesDesDossiersDeFormalitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArticlesEtRemisesDesDossiersDeFormalitApiFp(configuration)
    return {
        /**
         * Lister les articles et les réductions possibles un dossier de formalité
         * @summary Lister les articles et les réductions possibles un dossier de formalité
         * @param {ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReductionArticlesDossierGetCollection(requestParameters: ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiReductionArticlesDossierGetCollection200Response> {
            return localVarFp.apiReductionArticlesDossierGetCollection(requestParameters.ids, requestParameters.idsSelected, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiReductionArticlesDossierGetCollection operation in ArticlesEtRemisesDesDossiersDeFormalitApi.
 * @export
 * @interface ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollectionRequest
 */
export interface ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollectionRequest {
    /**
     * Identifiants des dossiers de formalité
     * @type {Array<number>}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollection
     */
    readonly ids: Array<number>

    /**
     * Identifiants des dossiers à prendre en compte pour le total
     * @type {Array<number>}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollection
     */
    readonly idsSelected: Array<number>

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollection
     */
    readonly page?: number
}

/**
 * ArticlesEtRemisesDesDossiersDeFormalitApi - object-oriented interface
 * @export
 * @class ArticlesEtRemisesDesDossiersDeFormalitApi
 * @extends {BaseAPI}
 */
export class ArticlesEtRemisesDesDossiersDeFormalitApi extends BaseAPI {
    /**
     * Lister les articles et les réductions possibles un dossier de formalité
     * @summary Lister les articles et les réductions possibles un dossier de formalité
     * @param {ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticlesEtRemisesDesDossiersDeFormalitApi
     */
    public apiReductionArticlesDossierGetCollection(requestParameters: ArticlesEtRemisesDesDossiersDeFormalitApiApiReductionArticlesDossierGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return ArticlesEtRemisesDesDossiersDeFormalitApiFp(this.configuration).apiReductionArticlesDossierGetCollection(requestParameters.ids, requestParameters.idsSelected, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DevisFormalitApi - axios parameter creator
 * @export
 */
export const DevisFormalitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Créer un devis pour une ou plusieurs collection
         * @summary Créer un devis pour une ou plusieurs collection
         * @param {DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate} devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate The new Devis Formalité resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisCollectionsPost: async (devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate: DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate' is not null or undefined
            assertParamExists('apiDevisCollectionsPost', 'devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate', devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate)
            const localVarPath = `/facturation/devis-collections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des devis
         * @summary Obtenir la liste des devis
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [collectionsId] 
         * @param {Array<number>} [collectionsId2] 
         * @param {number} [prescripteurId] 
         * @param {Array<number>} [prescripteurId2] 
         * @param {number} [societeId] 
         * @param {Array<number>} [societeId2] 
         * @param {number} [dossierId] 
         * @param {Array<number>} [dossierId2] 
         * @param {number} [lignesIdAnnonce] 
         * @param {Array<number>} [lignesIdAnnonce2] 
         * @param {boolean} [deleted] 
         * @param {boolean} [actif] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisFormaliteGetCollection: async (xIdSociete?: number, page?: number, collectionsId?: number, collectionsId2?: Array<number>, prescripteurId?: number, prescripteurId2?: Array<number>, societeId?: number, societeId2?: Array<number>, dossierId?: number, dossierId2?: Array<number>, lignesIdAnnonce?: number, lignesIdAnnonce2?: Array<number>, deleted?: boolean, actif?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/devis-formalite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (collectionsId !== undefined) {
                localVarQueryParameter['collections.id'] = collectionsId;
            }

            if (collectionsId2) {
                localVarQueryParameter['collections.id[]'] = collectionsId2;
            }

            if (prescripteurId !== undefined) {
                localVarQueryParameter['prescripteur.id'] = prescripteurId;
            }

            if (prescripteurId2) {
                localVarQueryParameter['prescripteur.id[]'] = prescripteurId2;
            }

            if (societeId !== undefined) {
                localVarQueryParameter['societe.id'] = societeId;
            }

            if (societeId2) {
                localVarQueryParameter['societe.id[]'] = societeId2;
            }

            if (dossierId !== undefined) {
                localVarQueryParameter['dossier.id'] = dossierId;
            }

            if (dossierId2) {
                localVarQueryParameter['dossier.id[]'] = dossierId2;
            }

            if (lignesIdAnnonce !== undefined) {
                localVarQueryParameter['lignes.idAnnonce'] = lignesIdAnnonce;
            }

            if (lignesIdAnnonce2) {
                localVarQueryParameter['lignes.idAnnonce[]'] = lignesIdAnnonce2;
            }

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (actif !== undefined) {
                localVarQueryParameter['actif'] = actif;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer un devis
         * @summary Supprimer un devis
         * @param {string} id TblDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisFormaliteIdDelete: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDevisFormaliteIdDelete', 'id', id)
            const localVarPath = `/facturation/devis-formalite/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un devis
         * @summary Récupérer les informations d\'un devis
         * @param {string} id TblDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisFormaliteIdGet: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDevisFormaliteIdGet', 'id', id)
            const localVarPath = `/facturation/devis-formalite/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer le pdf d\'un devis
         * @summary Récupérer le pdf d\'un devis
         * @param {string} id TblDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisFormaliteIdPdfGet: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDevisFormaliteIdPdfGet', 'id', id)
            const localVarPath = `/facturation/devis-formalite/{id}/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer un devis
         * @summary Créer un devis
         * @param {DevisFormalitDevisCreateDtoJsonldDevisCreate} devisFormalitDevisCreateDtoJsonldDevisCreate The new Devis Formalité resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisFormalitePost: async (devisFormalitDevisCreateDtoJsonldDevisCreate: DevisFormalitDevisCreateDtoJsonldDevisCreate, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'devisFormalitDevisCreateDtoJsonldDevisCreate' is not null or undefined
            assertParamExists('apiDevisFormalitePost', 'devisFormalitDevisCreateDtoJsonldDevisCreate', devisFormalitDevisCreateDtoJsonldDevisCreate)
            const localVarPath = `/facturation/devis-formalite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(devisFormalitDevisCreateDtoJsonldDevisCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevisFormalitApi - functional programming interface
 * @export
 */
export const DevisFormalitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevisFormalitApiAxiosParamCreator(configuration)
    return {
        /**
         * Créer un devis pour une ou plusieurs collection
         * @summary Créer un devis pour une ou plusieurs collection
         * @param {DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate} devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate The new Devis Formalité resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDevisCollectionsPost(devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate: DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevisFormalitJsonldDevisRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDevisCollectionsPost(devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisFormalitApi.apiDevisCollectionsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtenir la liste des devis
         * @summary Obtenir la liste des devis
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [collectionsId] 
         * @param {Array<number>} [collectionsId2] 
         * @param {number} [prescripteurId] 
         * @param {Array<number>} [prescripteurId2] 
         * @param {number} [societeId] 
         * @param {Array<number>} [societeId2] 
         * @param {number} [dossierId] 
         * @param {Array<number>} [dossierId2] 
         * @param {number} [lignesIdAnnonce] 
         * @param {Array<number>} [lignesIdAnnonce2] 
         * @param {boolean} [deleted] 
         * @param {boolean} [actif] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDevisFormaliteGetCollection(xIdSociete?: number, page?: number, collectionsId?: number, collectionsId2?: Array<number>, prescripteurId?: number, prescripteurId2?: Array<number>, societeId?: number, societeId2?: Array<number>, dossierId?: number, dossierId2?: Array<number>, lignesIdAnnonce?: number, lignesIdAnnonce2?: Array<number>, deleted?: boolean, actif?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDevisFormaliteGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDevisFormaliteGetCollection(xIdSociete, page, collectionsId, collectionsId2, prescripteurId, prescripteurId2, societeId, societeId2, dossierId, dossierId2, lignesIdAnnonce, lignesIdAnnonce2, deleted, actif, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisFormalitApi.apiDevisFormaliteGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer un devis
         * @summary Supprimer un devis
         * @param {string} id TblDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDevisFormaliteIdDelete(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDevisFormaliteIdDelete(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisFormalitApi.apiDevisFormaliteIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un devis
         * @summary Récupérer les informations d\'un devis
         * @param {string} id TblDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDevisFormaliteIdGet(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevisFormalitJsonldDevisRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDevisFormaliteIdGet(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisFormalitApi.apiDevisFormaliteIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer le pdf d\'un devis
         * @summary Récupérer le pdf d\'un devis
         * @param {string} id TblDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDevisFormaliteIdPdfGet(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDevisFormaliteIdPdfGet(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisFormalitApi.apiDevisFormaliteIdPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer un devis
         * @summary Créer un devis
         * @param {DevisFormalitDevisCreateDtoJsonldDevisCreate} devisFormalitDevisCreateDtoJsonldDevisCreate The new Devis Formalité resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDevisFormalitePost(devisFormalitDevisCreateDtoJsonldDevisCreate: DevisFormalitDevisCreateDtoJsonldDevisCreate, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevisFormalitJsonldDevisRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDevisFormalitePost(devisFormalitDevisCreateDtoJsonldDevisCreate, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisFormalitApi.apiDevisFormalitePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevisFormalitApi - factory interface
 * @export
 */
export const DevisFormalitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevisFormalitApiFp(configuration)
    return {
        /**
         * Créer un devis pour une ou plusieurs collection
         * @summary Créer un devis pour une ou plusieurs collection
         * @param {DevisFormalitApiApiDevisCollectionsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisCollectionsPost(requestParameters: DevisFormalitApiApiDevisCollectionsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevisFormalitJsonldDevisRead> {
            return localVarFp.apiDevisCollectionsPost(requestParameters.devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtenir la liste des devis
         * @summary Obtenir la liste des devis
         * @param {DevisFormalitApiApiDevisFormaliteGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisFormaliteGetCollection(requestParameters: DevisFormalitApiApiDevisFormaliteGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiDevisFormaliteGetCollection200Response> {
            return localVarFp.apiDevisFormaliteGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.collectionsId, requestParameters.collectionsId2, requestParameters.prescripteurId, requestParameters.prescripteurId2, requestParameters.societeId, requestParameters.societeId2, requestParameters.dossierId, requestParameters.dossierId2, requestParameters.lignesIdAnnonce, requestParameters.lignesIdAnnonce2, requestParameters.deleted, requestParameters.actif, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer un devis
         * @summary Supprimer un devis
         * @param {DevisFormalitApiApiDevisFormaliteIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisFormaliteIdDelete(requestParameters: DevisFormalitApiApiDevisFormaliteIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiDevisFormaliteIdDelete(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un devis
         * @summary Récupérer les informations d\'un devis
         * @param {DevisFormalitApiApiDevisFormaliteIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisFormaliteIdGet(requestParameters: DevisFormalitApiApiDevisFormaliteIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevisFormalitJsonldDevisRead> {
            return localVarFp.apiDevisFormaliteIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer le pdf d\'un devis
         * @summary Récupérer le pdf d\'un devis
         * @param {DevisFormalitApiApiDevisFormaliteIdPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisFormaliteIdPdfGet(requestParameters: DevisFormalitApiApiDevisFormaliteIdPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiDevisFormaliteIdPdfGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer un devis
         * @summary Créer un devis
         * @param {DevisFormalitApiApiDevisFormalitePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisFormalitePost(requestParameters: DevisFormalitApiApiDevisFormalitePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevisFormalitJsonldDevisRead> {
            return localVarFp.apiDevisFormalitePost(requestParameters.devisFormalitDevisCreateDtoJsonldDevisCreate, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDevisCollectionsPost operation in DevisFormalitApi.
 * @export
 * @interface DevisFormalitApiApiDevisCollectionsPostRequest
 */
export interface DevisFormalitApiApiDevisCollectionsPostRequest {
    /**
     * The new Devis Formalité resource
     * @type {DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate}
     * @memberof DevisFormalitApiApiDevisCollectionsPost
     */
    readonly devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate: DevisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DevisFormalitApiApiDevisCollectionsPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiDevisFormaliteGetCollection operation in DevisFormalitApi.
 * @export
 * @interface DevisFormalitApiApiDevisFormaliteGetCollectionRequest
 */
export interface DevisFormalitApiApiDevisFormaliteGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly collectionsId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly collectionsId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly prescripteurId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly prescripteurId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly societeId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly societeId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly dossierId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly dossierId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly lignesIdAnnonce?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly lignesIdAnnonce2?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly deleted?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof DevisFormalitApiApiDevisFormaliteGetCollection
     */
    readonly actif?: boolean
}

/**
 * Request parameters for apiDevisFormaliteIdDelete operation in DevisFormalitApi.
 * @export
 * @interface DevisFormalitApiApiDevisFormaliteIdDeleteRequest
 */
export interface DevisFormalitApiApiDevisFormaliteIdDeleteRequest {
    /**
     * TblDevis identifier
     * @type {string}
     * @memberof DevisFormalitApiApiDevisFormaliteIdDelete
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormaliteIdDelete
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiDevisFormaliteIdGet operation in DevisFormalitApi.
 * @export
 * @interface DevisFormalitApiApiDevisFormaliteIdGetRequest
 */
export interface DevisFormalitApiApiDevisFormaliteIdGetRequest {
    /**
     * TblDevis identifier
     * @type {string}
     * @memberof DevisFormalitApiApiDevisFormaliteIdGet
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormaliteIdGet
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiDevisFormaliteIdPdfGet operation in DevisFormalitApi.
 * @export
 * @interface DevisFormalitApiApiDevisFormaliteIdPdfGetRequest
 */
export interface DevisFormalitApiApiDevisFormaliteIdPdfGetRequest {
    /**
     * TblDevis identifier
     * @type {string}
     * @memberof DevisFormalitApiApiDevisFormaliteIdPdfGet
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormaliteIdPdfGet
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiDevisFormalitePost operation in DevisFormalitApi.
 * @export
 * @interface DevisFormalitApiApiDevisFormalitePostRequest
 */
export interface DevisFormalitApiApiDevisFormalitePostRequest {
    /**
     * The new Devis Formalité resource
     * @type {DevisFormalitDevisCreateDtoJsonldDevisCreate}
     * @memberof DevisFormalitApiApiDevisFormalitePost
     */
    readonly devisFormalitDevisCreateDtoJsonldDevisCreate: DevisFormalitDevisCreateDtoJsonldDevisCreate

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DevisFormalitApiApiDevisFormalitePost
     */
    readonly xIdSociete?: number
}

/**
 * DevisFormalitApi - object-oriented interface
 * @export
 * @class DevisFormalitApi
 * @extends {BaseAPI}
 */
export class DevisFormalitApi extends BaseAPI {
    /**
     * Créer un devis pour une ou plusieurs collection
     * @summary Créer un devis pour une ou plusieurs collection
     * @param {DevisFormalitApiApiDevisCollectionsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisFormalitApi
     */
    public apiDevisCollectionsPost(requestParameters: DevisFormalitApiApiDevisCollectionsPostRequest, options?: RawAxiosRequestConfig) {
        return DevisFormalitApiFp(this.configuration).apiDevisCollectionsPost(requestParameters.devisFormalitDevisbyCollectionCreateDtoJsonldDevisCollectionCreate, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtenir la liste des devis
     * @summary Obtenir la liste des devis
     * @param {DevisFormalitApiApiDevisFormaliteGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisFormalitApi
     */
    public apiDevisFormaliteGetCollection(requestParameters: DevisFormalitApiApiDevisFormaliteGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DevisFormalitApiFp(this.configuration).apiDevisFormaliteGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.collectionsId, requestParameters.collectionsId2, requestParameters.prescripteurId, requestParameters.prescripteurId2, requestParameters.societeId, requestParameters.societeId2, requestParameters.dossierId, requestParameters.dossierId2, requestParameters.lignesIdAnnonce, requestParameters.lignesIdAnnonce2, requestParameters.deleted, requestParameters.actif, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer un devis
     * @summary Supprimer un devis
     * @param {DevisFormalitApiApiDevisFormaliteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisFormalitApi
     */
    public apiDevisFormaliteIdDelete(requestParameters: DevisFormalitApiApiDevisFormaliteIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return DevisFormalitApiFp(this.configuration).apiDevisFormaliteIdDelete(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un devis
     * @summary Récupérer les informations d\'un devis
     * @param {DevisFormalitApiApiDevisFormaliteIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisFormalitApi
     */
    public apiDevisFormaliteIdGet(requestParameters: DevisFormalitApiApiDevisFormaliteIdGetRequest, options?: RawAxiosRequestConfig) {
        return DevisFormalitApiFp(this.configuration).apiDevisFormaliteIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer le pdf d\'un devis
     * @summary Récupérer le pdf d\'un devis
     * @param {DevisFormalitApiApiDevisFormaliteIdPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisFormalitApi
     */
    public apiDevisFormaliteIdPdfGet(requestParameters: DevisFormalitApiApiDevisFormaliteIdPdfGetRequest, options?: RawAxiosRequestConfig) {
        return DevisFormalitApiFp(this.configuration).apiDevisFormaliteIdPdfGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer un devis
     * @summary Créer un devis
     * @param {DevisFormalitApiApiDevisFormalitePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisFormalitApi
     */
    public apiDevisFormalitePost(requestParameters: DevisFormalitApiApiDevisFormalitePostRequest, options?: RawAxiosRequestConfig) {
        return DevisFormalitApiFp(this.configuration).apiDevisFormalitePost(requestParameters.devisFormalitDevisCreateDtoJsonldDevisCreate, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DevisLignesAnnonceLgaleApi - axios parameter creator
 * @export
 */
export const DevisLignesAnnonceLgaleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des lignes d\'un devis d\'annonce légale
         * @summary Obtenir la liste des lignes d\'un devis d\'annonce légale
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [idAnnonce] 
         * @param {Array<number>} [idAnnonce2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLigneDevisAnnonceLegaleGetCollection: async (xIdSociete?: number, page?: number, idAnnonce?: number, idAnnonce2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/ligne-devis-annonce-legale`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (idAnnonce !== undefined) {
                localVarQueryParameter['idAnnonce'] = idAnnonce;
            }

            if (idAnnonce2) {
                localVarQueryParameter['idAnnonce[]'] = idAnnonce2;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer une ligne d\'un devis d\'annonce légale
         * @summary Récupérer une ligne d\'un devis d\'annonce légale
         * @param {string} id TblLigneDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLigneDevisAnnonceLegaleIdGet: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLigneDevisAnnonceLegaleIdGet', 'id', id)
            const localVarPath = `/facturation/ligne-devis-annonce-legale/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevisLignesAnnonceLgaleApi - functional programming interface
 * @export
 */
export const DevisLignesAnnonceLgaleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevisLignesAnnonceLgaleApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des lignes d\'un devis d\'annonce légale
         * @summary Obtenir la liste des lignes d\'un devis d\'annonce légale
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [idAnnonce] 
         * @param {Array<number>} [idAnnonce2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLigneDevisAnnonceLegaleGetCollection(xIdSociete?: number, page?: number, idAnnonce?: number, idAnnonce2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLigneDevisAnnonceLegaleGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLigneDevisAnnonceLegaleGetCollection(xIdSociete, page, idAnnonce, idAnnonce2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisLignesAnnonceLgaleApi.apiLigneDevisAnnonceLegaleGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer une ligne d\'un devis d\'annonce légale
         * @summary Récupérer une ligne d\'un devis d\'annonce légale
         * @param {string} id TblLigneDevis identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLigneDevisAnnonceLegaleIdGet(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevisLignesAnnonceLGaleJsonldLigneDevisALRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLigneDevisAnnonceLegaleIdGet(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisLignesAnnonceLgaleApi.apiLigneDevisAnnonceLegaleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevisLignesAnnonceLgaleApi - factory interface
 * @export
 */
export const DevisLignesAnnonceLgaleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevisLignesAnnonceLgaleApiFp(configuration)
    return {
        /**
         * Obtenir la liste des lignes d\'un devis d\'annonce légale
         * @summary Obtenir la liste des lignes d\'un devis d\'annonce légale
         * @param {DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLigneDevisAnnonceLegaleGetCollection(requestParameters: DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiLigneDevisAnnonceLegaleGetCollection200Response> {
            return localVarFp.apiLigneDevisAnnonceLegaleGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.idAnnonce, requestParameters.idAnnonce2, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer une ligne d\'un devis d\'annonce légale
         * @summary Récupérer une ligne d\'un devis d\'annonce légale
         * @param {DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLigneDevisAnnonceLegaleIdGet(requestParameters: DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevisLignesAnnonceLGaleJsonldLigneDevisALRead> {
            return localVarFp.apiLigneDevisAnnonceLegaleIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLigneDevisAnnonceLegaleGetCollection operation in DevisLignesAnnonceLgaleApi.
 * @export
 * @interface DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleGetCollectionRequest
 */
export interface DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleGetCollection
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleGetCollection
     */
    readonly idAnnonce?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleGetCollection
     */
    readonly idAnnonce2?: Array<number>
}

/**
 * Request parameters for apiLigneDevisAnnonceLegaleIdGet operation in DevisLignesAnnonceLgaleApi.
 * @export
 * @interface DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleIdGetRequest
 */
export interface DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleIdGetRequest {
    /**
     * TblLigneDevis identifier
     * @type {string}
     * @memberof DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleIdGet
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleIdGet
     */
    readonly xIdSociete?: number
}

/**
 * DevisLignesAnnonceLgaleApi - object-oriented interface
 * @export
 * @class DevisLignesAnnonceLgaleApi
 * @extends {BaseAPI}
 */
export class DevisLignesAnnonceLgaleApi extends BaseAPI {
    /**
     * Obtenir la liste des lignes d\'un devis d\'annonce légale
     * @summary Obtenir la liste des lignes d\'un devis d\'annonce légale
     * @param {DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisLignesAnnonceLgaleApi
     */
    public apiLigneDevisAnnonceLegaleGetCollection(requestParameters: DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DevisLignesAnnonceLgaleApiFp(this.configuration).apiLigneDevisAnnonceLegaleGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.idAnnonce, requestParameters.idAnnonce2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer une ligne d\'un devis d\'annonce légale
     * @summary Récupérer une ligne d\'un devis d\'annonce légale
     * @param {DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisLignesAnnonceLgaleApi
     */
    public apiLigneDevisAnnonceLegaleIdGet(requestParameters: DevisLignesAnnonceLgaleApiApiLigneDevisAnnonceLegaleIdGetRequest, options?: RawAxiosRequestConfig) {
        return DevisLignesAnnonceLgaleApiFp(this.configuration).apiLigneDevisAnnonceLegaleIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DevisLignesFormalitApi - axios parameter creator
 * @export
 */
export const DevisLignesFormalitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des lignes d\'un devis
         * @summary Obtenir la liste des lignes d\'un devis
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {string} [rubfac] 
         * @param {Array<string>} [rubfac2] 
         * @param {number} [devisId] 
         * @param {Array<number>} [devisId2] 
         * @param {number} [idAnnonce] 
         * @param {Array<number>} [idAnnonce2] 
         * @param {number} [devisDossierId] 
         * @param {Array<number>} [devisDossierId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisLigneGetCollection: async (xIdSociete?: number, page?: number, rubfac?: string, rubfac2?: Array<string>, devisId?: number, devisId2?: Array<number>, idAnnonce?: number, idAnnonce2?: Array<number>, devisDossierId?: number, devisDossierId2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/devis-ligne`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (rubfac !== undefined) {
                localVarQueryParameter['rubfac'] = rubfac;
            }

            if (rubfac2) {
                localVarQueryParameter['rubfac[]'] = rubfac2;
            }

            if (devisId !== undefined) {
                localVarQueryParameter['devis.id'] = devisId;
            }

            if (devisId2) {
                localVarQueryParameter['devis.id[]'] = devisId2;
            }

            if (idAnnonce !== undefined) {
                localVarQueryParameter['idAnnonce'] = idAnnonce;
            }

            if (idAnnonce2) {
                localVarQueryParameter['idAnnonce[]'] = idAnnonce2;
            }

            if (devisDossierId !== undefined) {
                localVarQueryParameter['devis.dossier.id'] = devisDossierId;
            }

            if (devisDossierId2) {
                localVarQueryParameter['devis.dossier.id[]'] = devisDossierId2;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer une ligne d\'un devis
         * @summary Récupérer une ligne d\'un devis
         * @param {string} id TblDevisLignes identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisLigneIdGet: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDevisLigneIdGet', 'id', id)
            const localVarPath = `/facturation/devis-ligne/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevisLignesFormalitApi - functional programming interface
 * @export
 */
export const DevisLignesFormalitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevisLignesFormalitApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des lignes d\'un devis
         * @summary Obtenir la liste des lignes d\'un devis
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {string} [rubfac] 
         * @param {Array<string>} [rubfac2] 
         * @param {number} [devisId] 
         * @param {Array<number>} [devisId2] 
         * @param {number} [idAnnonce] 
         * @param {Array<number>} [idAnnonce2] 
         * @param {number} [devisDossierId] 
         * @param {Array<number>} [devisDossierId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDevisLigneGetCollection(xIdSociete?: number, page?: number, rubfac?: string, rubfac2?: Array<string>, devisId?: number, devisId2?: Array<number>, idAnnonce?: number, idAnnonce2?: Array<number>, devisDossierId?: number, devisDossierId2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDevisLigneGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDevisLigneGetCollection(xIdSociete, page, rubfac, rubfac2, devisId, devisId2, idAnnonce, idAnnonce2, devisDossierId, devisDossierId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisLignesFormalitApi.apiDevisLigneGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer une ligne d\'un devis
         * @summary Récupérer une ligne d\'un devis
         * @param {string} id TblDevisLignes identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDevisLigneIdGet(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DevisLignesFormalitJsonldDevisLignesRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDevisLigneIdGet(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevisLignesFormalitApi.apiDevisLigneIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevisLignesFormalitApi - factory interface
 * @export
 */
export const DevisLignesFormalitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevisLignesFormalitApiFp(configuration)
    return {
        /**
         * Obtenir la liste des lignes d\'un devis
         * @summary Obtenir la liste des lignes d\'un devis
         * @param {DevisLignesFormalitApiApiDevisLigneGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisLigneGetCollection(requestParameters: DevisLignesFormalitApiApiDevisLigneGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiDevisLigneGetCollection200Response> {
            return localVarFp.apiDevisLigneGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.rubfac, requestParameters.rubfac2, requestParameters.devisId, requestParameters.devisId2, requestParameters.idAnnonce, requestParameters.idAnnonce2, requestParameters.devisDossierId, requestParameters.devisDossierId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer une ligne d\'un devis
         * @summary Récupérer une ligne d\'un devis
         * @param {DevisLignesFormalitApiApiDevisLigneIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDevisLigneIdGet(requestParameters: DevisLignesFormalitApiApiDevisLigneIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<DevisLignesFormalitJsonldDevisLignesRead> {
            return localVarFp.apiDevisLigneIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDevisLigneGetCollection operation in DevisLignesFormalitApi.
 * @export
 * @interface DevisLignesFormalitApiApiDevisLigneGetCollectionRequest
 */
export interface DevisLignesFormalitApiApiDevisLigneGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DevisLignesFormalitApiApiDevisLigneGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof DevisLignesFormalitApiApiDevisLigneGetCollection
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof DevisLignesFormalitApiApiDevisLigneGetCollection
     */
    readonly rubfac?: string

    /**
     * 
     * @type {Array<string>}
     * @memberof DevisLignesFormalitApiApiDevisLigneGetCollection
     */
    readonly rubfac2?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitApiApiDevisLigneGetCollection
     */
    readonly devisId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisLignesFormalitApiApiDevisLigneGetCollection
     */
    readonly devisId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitApiApiDevisLigneGetCollection
     */
    readonly idAnnonce?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisLignesFormalitApiApiDevisLigneGetCollection
     */
    readonly idAnnonce2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof DevisLignesFormalitApiApiDevisLigneGetCollection
     */
    readonly devisDossierId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof DevisLignesFormalitApiApiDevisLigneGetCollection
     */
    readonly devisDossierId2?: Array<number>
}

/**
 * Request parameters for apiDevisLigneIdGet operation in DevisLignesFormalitApi.
 * @export
 * @interface DevisLignesFormalitApiApiDevisLigneIdGetRequest
 */
export interface DevisLignesFormalitApiApiDevisLigneIdGetRequest {
    /**
     * TblDevisLignes identifier
     * @type {string}
     * @memberof DevisLignesFormalitApiApiDevisLigneIdGet
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof DevisLignesFormalitApiApiDevisLigneIdGet
     */
    readonly xIdSociete?: number
}

/**
 * DevisLignesFormalitApi - object-oriented interface
 * @export
 * @class DevisLignesFormalitApi
 * @extends {BaseAPI}
 */
export class DevisLignesFormalitApi extends BaseAPI {
    /**
     * Obtenir la liste des lignes d\'un devis
     * @summary Obtenir la liste des lignes d\'un devis
     * @param {DevisLignesFormalitApiApiDevisLigneGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisLignesFormalitApi
     */
    public apiDevisLigneGetCollection(requestParameters: DevisLignesFormalitApiApiDevisLigneGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return DevisLignesFormalitApiFp(this.configuration).apiDevisLigneGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.rubfac, requestParameters.rubfac2, requestParameters.devisId, requestParameters.devisId2, requestParameters.idAnnonce, requestParameters.idAnnonce2, requestParameters.devisDossierId, requestParameters.devisDossierId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer une ligne d\'un devis
     * @summary Récupérer une ligne d\'un devis
     * @param {DevisLignesFormalitApiApiDevisLigneIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevisLignesFormalitApi
     */
    public apiDevisLigneIdGet(requestParameters: DevisLignesFormalitApiApiDevisLigneIdGetRequest, options?: RawAxiosRequestConfig) {
        return DevisLignesFormalitApiFp(this.configuration).apiDevisLigneIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FacturationFormalitApi - axios parameter creator
 * @export
 */
export const FacturationFormalitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les dossiers de formalité facturables suivant une liste de départ
         * @summary Lister les dossiers de formalité facturables
         * @param {Array<number>} ids Identifiants des dossiers de formalité
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossierFormaliteGetCollection: async (ids: Array<number>, xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiDossierFormaliteGetCollection', 'ids', ids)
            const localVarPath = `/facturation/dossier-formalite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FacturationFormalitApi - functional programming interface
 * @export
 */
export const FacturationFormalitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FacturationFormalitApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les dossiers de formalité facturables suivant une liste de départ
         * @summary Lister les dossiers de formalité facturables
         * @param {Array<number>} ids Identifiants des dossiers de formalité
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossierFormaliteGetCollection(ids: Array<number>, xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossierFormaliteGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossierFormaliteGetCollection(ids, xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FacturationFormalitApi.apiDossierFormaliteGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FacturationFormalitApi - factory interface
 * @export
 */
export const FacturationFormalitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FacturationFormalitApiFp(configuration)
    return {
        /**
         * Lister les dossiers de formalité facturables suivant une liste de départ
         * @summary Lister les dossiers de formalité facturables
         * @param {FacturationFormalitApiApiDossierFormaliteGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossierFormaliteGetCollection(requestParameters: FacturationFormalitApiApiDossierFormaliteGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossierFormaliteGetCollection200Response> {
            return localVarFp.apiDossierFormaliteGetCollection(requestParameters.ids, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossierFormaliteGetCollection operation in FacturationFormalitApi.
 * @export
 * @interface FacturationFormalitApiApiDossierFormaliteGetCollectionRequest
 */
export interface FacturationFormalitApiApiDossierFormaliteGetCollectionRequest {
    /**
     * Identifiants des dossiers de formalité
     * @type {Array<number>}
     * @memberof FacturationFormalitApiApiDossierFormaliteGetCollection
     */
    readonly ids: Array<number>

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FacturationFormalitApiApiDossierFormaliteGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FacturationFormalitApiApiDossierFormaliteGetCollection
     */
    readonly page?: number
}

/**
 * FacturationFormalitApi - object-oriented interface
 * @export
 * @class FacturationFormalitApi
 * @extends {BaseAPI}
 */
export class FacturationFormalitApi extends BaseAPI {
    /**
     * Lister les dossiers de formalité facturables suivant une liste de départ
     * @summary Lister les dossiers de formalité facturables
     * @param {FacturationFormalitApiApiDossierFormaliteGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FacturationFormalitApi
     */
    public apiDossierFormaliteGetCollection(requestParameters: FacturationFormalitApiApiDossierFormaliteGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return FacturationFormalitApiFp(this.configuration).apiDossierFormaliteGetCollection(requestParameters.ids, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FactureApi - axios parameter creator
 * @export
 */
export const FactureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des factures d\'un dossier
         * @summary Obtenir la liste des factures d\'un dossier
         * @param {string} dossier FproDossier identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {string} [dossierNumero] 
         * @param {number} [collectionsId] 
         * @param {Array<number>} [collectionsId2] 
         * @param {number} [dossierId] 
         * @param {Array<number>} [dossierId2] 
         * @param {number} [dossierPrescripteurId] 
         * @param {Array<number>} [dossierPrescripteurId2] 
         * @param {boolean} [deleted] 
         * @param {boolean} [factureEnPreparation] 
         * @param {ApiDossiersDossierFacturesGetCollectionOrderFactureEnPreparationEnum} [orderFactureEnPreparation] 
         * @param {ApiDossiersDossierFacturesGetCollectionOrderPayeEnum} [orderPaye] 
         * @param {ApiDossiersDossierFacturesGetCollectionOrderDateEcheanceFactureEnum} [orderDateEcheanceFacture] 
         * @param {ApiDossiersDossierFacturesGetCollectionOrderNumeroEnum} [orderNumero] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierFacturesGetCollection: async (dossier: string, xIdSociete?: number, page?: number, dossierNumero?: string, collectionsId?: number, collectionsId2?: Array<number>, dossierId?: number, dossierId2?: Array<number>, dossierPrescripteurId?: number, dossierPrescripteurId2?: Array<number>, deleted?: boolean, factureEnPreparation?: boolean, orderFactureEnPreparation?: ApiDossiersDossierFacturesGetCollectionOrderFactureEnPreparationEnum, orderPaye?: ApiDossiersDossierFacturesGetCollectionOrderPayeEnum, orderDateEcheanceFacture?: ApiDossiersDossierFacturesGetCollectionOrderDateEcheanceFactureEnum, orderNumero?: ApiDossiersDossierFacturesGetCollectionOrderNumeroEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dossier' is not null or undefined
            assertParamExists('apiDossiersDossierFacturesGetCollection', 'dossier', dossier)
            const localVarPath = `/facturation/dossiers/{dossier}/factures`
                .replace(`{${"dossier"}}`, encodeURIComponent(String(dossier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (dossierNumero !== undefined) {
                localVarQueryParameter['dossier.numero'] = dossierNumero;
            }

            if (collectionsId !== undefined) {
                localVarQueryParameter['collections.id'] = collectionsId;
            }

            if (collectionsId2) {
                localVarQueryParameter['collections.id[]'] = collectionsId2;
            }

            if (dossierId !== undefined) {
                localVarQueryParameter['dossier.id'] = dossierId;
            }

            if (dossierId2) {
                localVarQueryParameter['dossier.id[]'] = dossierId2;
            }

            if (dossierPrescripteurId !== undefined) {
                localVarQueryParameter['dossier.prescripteur.id'] = dossierPrescripteurId;
            }

            if (dossierPrescripteurId2) {
                localVarQueryParameter['dossier.prescripteur.id[]'] = dossierPrescripteurId2;
            }

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (factureEnPreparation !== undefined) {
                localVarQueryParameter['factureEnPreparation'] = factureEnPreparation;
            }

            if (orderFactureEnPreparation !== undefined) {
                localVarQueryParameter['order[factureEnPreparation]'] = orderFactureEnPreparation;
            }

            if (orderPaye !== undefined) {
                localVarQueryParameter['order[paye]'] = orderPaye;
            }

            if (orderDateEcheanceFacture !== undefined) {
                localVarQueryParameter['order[dateEcheanceFacture]'] = orderDateEcheanceFacture;
            }

            if (orderNumero !== undefined) {
                localVarQueryParameter['order[numero]'] = orderNumero;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des factures
         * @summary Obtenir la liste des factures
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {string} [dossierNumero] 
         * @param {number} [collectionsId] 
         * @param {Array<number>} [collectionsId2] 
         * @param {number} [dossierId] 
         * @param {Array<number>} [dossierId2] 
         * @param {number} [dossierPrescripteurId] 
         * @param {Array<number>} [dossierPrescripteurId2] 
         * @param {boolean} [deleted] 
         * @param {boolean} [factureEnPreparation] 
         * @param {ApiFacturesGetCollectionOrderFactureEnPreparationEnum} [orderFactureEnPreparation] 
         * @param {ApiFacturesGetCollectionOrderPayeEnum} [orderPaye] 
         * @param {ApiFacturesGetCollectionOrderDateEcheanceFactureEnum} [orderDateEcheanceFacture] 
         * @param {ApiFacturesGetCollectionOrderNumeroEnum} [orderNumero] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesGetCollection: async (xIdSociete?: number, page?: number, dossierNumero?: string, collectionsId?: number, collectionsId2?: Array<number>, dossierId?: number, dossierId2?: Array<number>, dossierPrescripteurId?: number, dossierPrescripteurId2?: Array<number>, deleted?: boolean, factureEnPreparation?: boolean, orderFactureEnPreparation?: ApiFacturesGetCollectionOrderFactureEnPreparationEnum, orderPaye?: ApiFacturesGetCollectionOrderPayeEnum, orderDateEcheanceFacture?: ApiFacturesGetCollectionOrderDateEcheanceFactureEnum, orderNumero?: ApiFacturesGetCollectionOrderNumeroEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/factures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (dossierNumero !== undefined) {
                localVarQueryParameter['dossier.numero'] = dossierNumero;
            }

            if (collectionsId !== undefined) {
                localVarQueryParameter['collections.id'] = collectionsId;
            }

            if (collectionsId2) {
                localVarQueryParameter['collections.id[]'] = collectionsId2;
            }

            if (dossierId !== undefined) {
                localVarQueryParameter['dossier.id'] = dossierId;
            }

            if (dossierId2) {
                localVarQueryParameter['dossier.id[]'] = dossierId2;
            }

            if (dossierPrescripteurId !== undefined) {
                localVarQueryParameter['dossier.prescripteur.id'] = dossierPrescripteurId;
            }

            if (dossierPrescripteurId2) {
                localVarQueryParameter['dossier.prescripteur.id[]'] = dossierPrescripteurId2;
            }

            if (deleted !== undefined) {
                localVarQueryParameter['deleted'] = deleted;
            }

            if (factureEnPreparation !== undefined) {
                localVarQueryParameter['factureEnPreparation'] = factureEnPreparation;
            }

            if (orderFactureEnPreparation !== undefined) {
                localVarQueryParameter['order[factureEnPreparation]'] = orderFactureEnPreparation;
            }

            if (orderPaye !== undefined) {
                localVarQueryParameter['order[paye]'] = orderPaye;
            }

            if (orderDateEcheanceFacture !== undefined) {
                localVarQueryParameter['order[dateEcheanceFacture]'] = orderDateEcheanceFacture;
            }

            if (orderNumero !== undefined) {
                localVarQueryParameter['order[numero]'] = orderNumero;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer un avoir pour la facture
         * @summary Créer un avoir pour la facture
         * @param {string} id TblFacture2 identifier
         * @param {FactureJsonld} factureJsonld The updated Facture resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesIdAvoirPut: async (id: string, factureJsonld: FactureJsonld, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFacturesIdAvoirPut', 'id', id)
            // verify required parameter 'factureJsonld' is not null or undefined
            assertParamExists('apiFacturesIdAvoirPut', 'factureJsonld', factureJsonld)
            const localVarPath = `/facturation/factures/{id}/avoir`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factureJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Supprimer une facture
         * @summary Supprimer une facture
         * @param {string} id TblFacture2 identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesIdDelete: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFacturesIdDelete', 'id', id)
            const localVarPath = `/facturation/factures/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une facture
         * @summary Récupérer les informations d\'une facture
         * @param {string} id TblFacture2 identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesIdGet: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFacturesIdGet', 'id', id)
            const localVarPath = `/facturation/factures/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer le pdf d\'une facture
         * @summary Récupérer le pdf d\'une facture
         * @param {string} id TblFacture2 identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesIdPdfGet: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFacturesIdPdfGet', 'id', id)
            const localVarPath = `/facturation/factures/{id}/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Valider une facture
         * @summary Valider une facture
         * @param {string} id TblFacture2 identifier
         * @param {FactureJsonld} factureJsonld The updated Facture resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesIdValidatePut: async (id: string, factureJsonld: FactureJsonld, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiFacturesIdValidatePut', 'id', id)
            // verify required parameter 'factureJsonld' is not null or undefined
            assertParamExists('apiFacturesIdValidatePut', 'factureJsonld', factureJsonld)
            const localVarPath = `/facturation/factures/{id}/validate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factureJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer une facture
         * @summary Créer une facture
         * @param {FactureJsonldFactureCreate} factureJsonldFactureCreate The new Facture resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesPost: async (factureJsonldFactureCreate: FactureJsonldFactureCreate, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factureJsonldFactureCreate' is not null or undefined
            assertParamExists('apiFacturesPost', 'factureJsonldFactureCreate', factureJsonldFactureCreate)
            const localVarPath = `/facturation/factures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factureJsonldFactureCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer un proforma
         * @summary Créer un proforma
         * @param {FactureJsonldFactureCreate} factureJsonldFactureCreate The new Facture resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProformaPost: async (factureJsonldFactureCreate: FactureJsonldFactureCreate, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factureJsonldFactureCreate' is not null or undefined
            assertParamExists('apiProformaPost', 'factureJsonldFactureCreate', factureJsonldFactureCreate)
            const localVarPath = `/facturation/proforma`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factureJsonldFactureCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FactureApi - functional programming interface
 * @export
 */
export const FactureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FactureApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des factures d\'un dossier
         * @summary Obtenir la liste des factures d\'un dossier
         * @param {string} dossier FproDossier identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {string} [dossierNumero] 
         * @param {number} [collectionsId] 
         * @param {Array<number>} [collectionsId2] 
         * @param {number} [dossierId] 
         * @param {Array<number>} [dossierId2] 
         * @param {number} [dossierPrescripteurId] 
         * @param {Array<number>} [dossierPrescripteurId2] 
         * @param {boolean} [deleted] 
         * @param {boolean} [factureEnPreparation] 
         * @param {ApiDossiersDossierFacturesGetCollectionOrderFactureEnPreparationEnum} [orderFactureEnPreparation] 
         * @param {ApiDossiersDossierFacturesGetCollectionOrderPayeEnum} [orderPaye] 
         * @param {ApiDossiersDossierFacturesGetCollectionOrderDateEcheanceFactureEnum} [orderDateEcheanceFacture] 
         * @param {ApiDossiersDossierFacturesGetCollectionOrderNumeroEnum} [orderNumero] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDossiersDossierFacturesGetCollection(dossier: string, xIdSociete?: number, page?: number, dossierNumero?: string, collectionsId?: number, collectionsId2?: Array<number>, dossierId?: number, dossierId2?: Array<number>, dossierPrescripteurId?: number, dossierPrescripteurId2?: Array<number>, deleted?: boolean, factureEnPreparation?: boolean, orderFactureEnPreparation?: ApiDossiersDossierFacturesGetCollectionOrderFactureEnPreparationEnum, orderPaye?: ApiDossiersDossierFacturesGetCollectionOrderPayeEnum, orderDateEcheanceFacture?: ApiDossiersDossierFacturesGetCollectionOrderDateEcheanceFactureEnum, orderNumero?: ApiDossiersDossierFacturesGetCollectionOrderNumeroEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDossiersDossierFacturesGetCollection(dossier, xIdSociete, page, dossierNumero, collectionsId, collectionsId2, dossierId, dossierId2, dossierPrescripteurId, dossierPrescripteurId2, deleted, factureEnPreparation, orderFactureEnPreparation, orderPaye, orderDateEcheanceFacture, orderNumero, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureApi.apiDossiersDossierFacturesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtenir la liste des factures
         * @summary Obtenir la liste des factures
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {string} [dossierNumero] 
         * @param {number} [collectionsId] 
         * @param {Array<number>} [collectionsId2] 
         * @param {number} [dossierId] 
         * @param {Array<number>} [dossierId2] 
         * @param {number} [dossierPrescripteurId] 
         * @param {Array<number>} [dossierPrescripteurId2] 
         * @param {boolean} [deleted] 
         * @param {boolean} [factureEnPreparation] 
         * @param {ApiFacturesGetCollectionOrderFactureEnPreparationEnum} [orderFactureEnPreparation] 
         * @param {ApiFacturesGetCollectionOrderPayeEnum} [orderPaye] 
         * @param {ApiFacturesGetCollectionOrderDateEcheanceFactureEnum} [orderDateEcheanceFacture] 
         * @param {ApiFacturesGetCollectionOrderNumeroEnum} [orderNumero] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFacturesGetCollection(xIdSociete?: number, page?: number, dossierNumero?: string, collectionsId?: number, collectionsId2?: Array<number>, dossierId?: number, dossierId2?: Array<number>, dossierPrescripteurId?: number, dossierPrescripteurId2?: Array<number>, deleted?: boolean, factureEnPreparation?: boolean, orderFactureEnPreparation?: ApiFacturesGetCollectionOrderFactureEnPreparationEnum, orderPaye?: ApiFacturesGetCollectionOrderPayeEnum, orderDateEcheanceFacture?: ApiFacturesGetCollectionOrderDateEcheanceFactureEnum, orderNumero?: ApiFacturesGetCollectionOrderNumeroEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiDossiersDossierFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFacturesGetCollection(xIdSociete, page, dossierNumero, collectionsId, collectionsId2, dossierId, dossierId2, dossierPrescripteurId, dossierPrescripteurId2, deleted, factureEnPreparation, orderFactureEnPreparation, orderPaye, orderDateEcheanceFacture, orderNumero, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureApi.apiFacturesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer un avoir pour la facture
         * @summary Créer un avoir pour la facture
         * @param {string} id TblFacture2 identifier
         * @param {FactureJsonld} factureJsonld The updated Facture resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFacturesIdAvoirPut(id: string, factureJsonld: FactureJsonld, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactureJsonldFactureReadTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFacturesIdAvoirPut(id, factureJsonld, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureApi.apiFacturesIdAvoirPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Supprimer une facture
         * @summary Supprimer une facture
         * @param {string} id TblFacture2 identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFacturesIdDelete(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFacturesIdDelete(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureApi.apiFacturesIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une facture
         * @summary Récupérer les informations d\'une facture
         * @param {string} id TblFacture2 identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFacturesIdGet(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactureJsonldFactureReadTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFacturesIdGet(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureApi.apiFacturesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer le pdf d\'une facture
         * @summary Récupérer le pdf d\'une facture
         * @param {string} id TblFacture2 identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFacturesIdPdfGet(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFacturesIdPdfGet(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureApi.apiFacturesIdPdfGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Valider une facture
         * @summary Valider une facture
         * @param {string} id TblFacture2 identifier
         * @param {FactureJsonld} factureJsonld The updated Facture resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFacturesIdValidatePut(id: string, factureJsonld: FactureJsonld, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactureJsonldFactureReadTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFacturesIdValidatePut(id, factureJsonld, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureApi.apiFacturesIdValidatePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer une facture
         * @summary Créer une facture
         * @param {FactureJsonldFactureCreate} factureJsonldFactureCreate The new Facture resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiFacturesPost(factureJsonldFactureCreate: FactureJsonldFactureCreate, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactureJsonldFactureReadTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiFacturesPost(factureJsonldFactureCreate, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureApi.apiFacturesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer un proforma
         * @summary Créer un proforma
         * @param {FactureJsonldFactureCreate} factureJsonldFactureCreate The new Facture resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProformaPost(factureJsonldFactureCreate: FactureJsonldFactureCreate, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactureJsonldFactureReadTimestampableBlameambleGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProformaPost(factureJsonldFactureCreate, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureApi.apiProformaPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FactureApi - factory interface
 * @export
 */
export const FactureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FactureApiFp(configuration)
    return {
        /**
         * Obtenir la liste des factures d\'un dossier
         * @summary Obtenir la liste des factures d\'un dossier
         * @param {FactureApiApiDossiersDossierFacturesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDossiersDossierFacturesGetCollection(requestParameters: FactureApiApiDossiersDossierFacturesGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierFacturesGetCollection200Response> {
            return localVarFp.apiDossiersDossierFacturesGetCollection(requestParameters.dossier, requestParameters.xIdSociete, requestParameters.page, requestParameters.dossierNumero, requestParameters.collectionsId, requestParameters.collectionsId2, requestParameters.dossierId, requestParameters.dossierId2, requestParameters.dossierPrescripteurId, requestParameters.dossierPrescripteurId2, requestParameters.deleted, requestParameters.factureEnPreparation, requestParameters.orderFactureEnPreparation, requestParameters.orderPaye, requestParameters.orderDateEcheanceFacture, requestParameters.orderNumero, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtenir la liste des factures
         * @summary Obtenir la liste des factures
         * @param {FactureApiApiFacturesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesGetCollection(requestParameters: FactureApiApiFacturesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiDossiersDossierFacturesGetCollection200Response> {
            return localVarFp.apiFacturesGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.dossierNumero, requestParameters.collectionsId, requestParameters.collectionsId2, requestParameters.dossierId, requestParameters.dossierId2, requestParameters.dossierPrescripteurId, requestParameters.dossierPrescripteurId2, requestParameters.deleted, requestParameters.factureEnPreparation, requestParameters.orderFactureEnPreparation, requestParameters.orderPaye, requestParameters.orderDateEcheanceFacture, requestParameters.orderNumero, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer un avoir pour la facture
         * @summary Créer un avoir pour la facture
         * @param {FactureApiApiFacturesIdAvoirPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesIdAvoirPut(requestParameters: FactureApiApiFacturesIdAvoirPutRequest, options?: RawAxiosRequestConfig): AxiosPromise<FactureJsonldFactureReadTimestampableBlameambleGroup> {
            return localVarFp.apiFacturesIdAvoirPut(requestParameters.id, requestParameters.factureJsonld, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Supprimer une facture
         * @summary Supprimer une facture
         * @param {FactureApiApiFacturesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesIdDelete(requestParameters: FactureApiApiFacturesIdDeleteRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiFacturesIdDelete(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une facture
         * @summary Récupérer les informations d\'une facture
         * @param {FactureApiApiFacturesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesIdGet(requestParameters: FactureApiApiFacturesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FactureJsonldFactureReadTimestampableBlameambleGroup> {
            return localVarFp.apiFacturesIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer le pdf d\'une facture
         * @summary Récupérer le pdf d\'une facture
         * @param {FactureApiApiFacturesIdPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesIdPdfGet(requestParameters: FactureApiApiFacturesIdPdfGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.apiFacturesIdPdfGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Valider une facture
         * @summary Valider une facture
         * @param {FactureApiApiFacturesIdValidatePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesIdValidatePut(requestParameters: FactureApiApiFacturesIdValidatePutRequest, options?: RawAxiosRequestConfig): AxiosPromise<FactureJsonldFactureReadTimestampableBlameambleGroup> {
            return localVarFp.apiFacturesIdValidatePut(requestParameters.id, requestParameters.factureJsonld, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer une facture
         * @summary Créer une facture
         * @param {FactureApiApiFacturesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiFacturesPost(requestParameters: FactureApiApiFacturesPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FactureJsonldFactureReadTimestampableBlameambleGroup> {
            return localVarFp.apiFacturesPost(requestParameters.factureJsonldFactureCreate, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer un proforma
         * @summary Créer un proforma
         * @param {FactureApiApiProformaPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProformaPost(requestParameters: FactureApiApiProformaPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FactureJsonldFactureReadTimestampableBlameambleGroup> {
            return localVarFp.apiProformaPost(requestParameters.factureJsonldFactureCreate, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiDossiersDossierFacturesGetCollection operation in FactureApi.
 * @export
 * @interface FactureApiApiDossiersDossierFacturesGetCollectionRequest
 */
export interface FactureApiApiDossiersDossierFacturesGetCollectionRequest {
    /**
     * FproDossier identifier
     * @type {string}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly dossier: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly dossierNumero?: string

    /**
     * 
     * @type {number}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly collectionsId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly collectionsId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly dossierId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly dossierId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly dossierPrescripteurId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly dossierPrescripteurId2?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly deleted?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly factureEnPreparation?: boolean

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly orderFactureEnPreparation?: ApiDossiersDossierFacturesGetCollectionOrderFactureEnPreparationEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly orderPaye?: ApiDossiersDossierFacturesGetCollectionOrderPayeEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly orderDateEcheanceFacture?: ApiDossiersDossierFacturesGetCollectionOrderDateEcheanceFactureEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FactureApiApiDossiersDossierFacturesGetCollection
     */
    readonly orderNumero?: ApiDossiersDossierFacturesGetCollectionOrderNumeroEnum
}

/**
 * Request parameters for apiFacturesGetCollection operation in FactureApi.
 * @export
 * @interface FactureApiApiFacturesGetCollectionRequest
 */
export interface FactureApiApiFacturesGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly page?: number

    /**
     * 
     * @type {string}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly dossierNumero?: string

    /**
     * 
     * @type {number}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly collectionsId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly collectionsId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly dossierId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly dossierId2?: Array<number>

    /**
     * 
     * @type {number}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly dossierPrescripteurId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly dossierPrescripteurId2?: Array<number>

    /**
     * 
     * @type {boolean}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly deleted?: boolean

    /**
     * 
     * @type {boolean}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly factureEnPreparation?: boolean

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly orderFactureEnPreparation?: ApiFacturesGetCollectionOrderFactureEnPreparationEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly orderPaye?: ApiFacturesGetCollectionOrderPayeEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly orderDateEcheanceFacture?: ApiFacturesGetCollectionOrderDateEcheanceFactureEnum

    /**
     * 
     * @type {'asc' | 'desc'}
     * @memberof FactureApiApiFacturesGetCollection
     */
    readonly orderNumero?: ApiFacturesGetCollectionOrderNumeroEnum
}

/**
 * Request parameters for apiFacturesIdAvoirPut operation in FactureApi.
 * @export
 * @interface FactureApiApiFacturesIdAvoirPutRequest
 */
export interface FactureApiApiFacturesIdAvoirPutRequest {
    /**
     * TblFacture2 identifier
     * @type {string}
     * @memberof FactureApiApiFacturesIdAvoirPut
     */
    readonly id: string

    /**
     * The updated Facture resource
     * @type {FactureJsonld}
     * @memberof FactureApiApiFacturesIdAvoirPut
     */
    readonly factureJsonld: FactureJsonld

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureApiApiFacturesIdAvoirPut
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiFacturesIdDelete operation in FactureApi.
 * @export
 * @interface FactureApiApiFacturesIdDeleteRequest
 */
export interface FactureApiApiFacturesIdDeleteRequest {
    /**
     * TblFacture2 identifier
     * @type {string}
     * @memberof FactureApiApiFacturesIdDelete
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureApiApiFacturesIdDelete
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiFacturesIdGet operation in FactureApi.
 * @export
 * @interface FactureApiApiFacturesIdGetRequest
 */
export interface FactureApiApiFacturesIdGetRequest {
    /**
     * TblFacture2 identifier
     * @type {string}
     * @memberof FactureApiApiFacturesIdGet
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureApiApiFacturesIdGet
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiFacturesIdPdfGet operation in FactureApi.
 * @export
 * @interface FactureApiApiFacturesIdPdfGetRequest
 */
export interface FactureApiApiFacturesIdPdfGetRequest {
    /**
     * TblFacture2 identifier
     * @type {string}
     * @memberof FactureApiApiFacturesIdPdfGet
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureApiApiFacturesIdPdfGet
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiFacturesIdValidatePut operation in FactureApi.
 * @export
 * @interface FactureApiApiFacturesIdValidatePutRequest
 */
export interface FactureApiApiFacturesIdValidatePutRequest {
    /**
     * TblFacture2 identifier
     * @type {string}
     * @memberof FactureApiApiFacturesIdValidatePut
     */
    readonly id: string

    /**
     * The updated Facture resource
     * @type {FactureJsonld}
     * @memberof FactureApiApiFacturesIdValidatePut
     */
    readonly factureJsonld: FactureJsonld

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureApiApiFacturesIdValidatePut
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiFacturesPost operation in FactureApi.
 * @export
 * @interface FactureApiApiFacturesPostRequest
 */
export interface FactureApiApiFacturesPostRequest {
    /**
     * The new Facture resource
     * @type {FactureJsonldFactureCreate}
     * @memberof FactureApiApiFacturesPost
     */
    readonly factureJsonldFactureCreate: FactureJsonldFactureCreate

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureApiApiFacturesPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiProformaPost operation in FactureApi.
 * @export
 * @interface FactureApiApiProformaPostRequest
 */
export interface FactureApiApiProformaPostRequest {
    /**
     * The new Facture resource
     * @type {FactureJsonldFactureCreate}
     * @memberof FactureApiApiProformaPost
     */
    readonly factureJsonldFactureCreate: FactureJsonldFactureCreate

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureApiApiProformaPost
     */
    readonly xIdSociete?: number
}

/**
 * FactureApi - object-oriented interface
 * @export
 * @class FactureApi
 * @extends {BaseAPI}
 */
export class FactureApi extends BaseAPI {
    /**
     * Obtenir la liste des factures d\'un dossier
     * @summary Obtenir la liste des factures d\'un dossier
     * @param {FactureApiApiDossiersDossierFacturesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureApi
     */
    public apiDossiersDossierFacturesGetCollection(requestParameters: FactureApiApiDossiersDossierFacturesGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return FactureApiFp(this.configuration).apiDossiersDossierFacturesGetCollection(requestParameters.dossier, requestParameters.xIdSociete, requestParameters.page, requestParameters.dossierNumero, requestParameters.collectionsId, requestParameters.collectionsId2, requestParameters.dossierId, requestParameters.dossierId2, requestParameters.dossierPrescripteurId, requestParameters.dossierPrescripteurId2, requestParameters.deleted, requestParameters.factureEnPreparation, requestParameters.orderFactureEnPreparation, requestParameters.orderPaye, requestParameters.orderDateEcheanceFacture, requestParameters.orderNumero, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtenir la liste des factures
     * @summary Obtenir la liste des factures
     * @param {FactureApiApiFacturesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureApi
     */
    public apiFacturesGetCollection(requestParameters: FactureApiApiFacturesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FactureApiFp(this.configuration).apiFacturesGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.dossierNumero, requestParameters.collectionsId, requestParameters.collectionsId2, requestParameters.dossierId, requestParameters.dossierId2, requestParameters.dossierPrescripteurId, requestParameters.dossierPrescripteurId2, requestParameters.deleted, requestParameters.factureEnPreparation, requestParameters.orderFactureEnPreparation, requestParameters.orderPaye, requestParameters.orderDateEcheanceFacture, requestParameters.orderNumero, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer un avoir pour la facture
     * @summary Créer un avoir pour la facture
     * @param {FactureApiApiFacturesIdAvoirPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureApi
     */
    public apiFacturesIdAvoirPut(requestParameters: FactureApiApiFacturesIdAvoirPutRequest, options?: RawAxiosRequestConfig) {
        return FactureApiFp(this.configuration).apiFacturesIdAvoirPut(requestParameters.id, requestParameters.factureJsonld, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Supprimer une facture
     * @summary Supprimer une facture
     * @param {FactureApiApiFacturesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureApi
     */
    public apiFacturesIdDelete(requestParameters: FactureApiApiFacturesIdDeleteRequest, options?: RawAxiosRequestConfig) {
        return FactureApiFp(this.configuration).apiFacturesIdDelete(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une facture
     * @summary Récupérer les informations d\'une facture
     * @param {FactureApiApiFacturesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureApi
     */
    public apiFacturesIdGet(requestParameters: FactureApiApiFacturesIdGetRequest, options?: RawAxiosRequestConfig) {
        return FactureApiFp(this.configuration).apiFacturesIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer le pdf d\'une facture
     * @summary Récupérer le pdf d\'une facture
     * @param {FactureApiApiFacturesIdPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureApi
     */
    public apiFacturesIdPdfGet(requestParameters: FactureApiApiFacturesIdPdfGetRequest, options?: RawAxiosRequestConfig) {
        return FactureApiFp(this.configuration).apiFacturesIdPdfGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Valider une facture
     * @summary Valider une facture
     * @param {FactureApiApiFacturesIdValidatePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureApi
     */
    public apiFacturesIdValidatePut(requestParameters: FactureApiApiFacturesIdValidatePutRequest, options?: RawAxiosRequestConfig) {
        return FactureApiFp(this.configuration).apiFacturesIdValidatePut(requestParameters.id, requestParameters.factureJsonld, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer une facture
     * @summary Créer une facture
     * @param {FactureApiApiFacturesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureApi
     */
    public apiFacturesPost(requestParameters: FactureApiApiFacturesPostRequest, options?: RawAxiosRequestConfig) {
        return FactureApiFp(this.configuration).apiFacturesPost(requestParameters.factureJsonldFactureCreate, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer un proforma
     * @summary Créer un proforma
     * @param {FactureApiApiProformaPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureApi
     */
    public apiProformaPost(requestParameters: FactureApiApiProformaPostRequest, options?: RawAxiosRequestConfig) {
        return FactureApiFp(this.configuration).apiProformaPost(requestParameters.factureJsonldFactureCreate, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ApiDossiersDossierFacturesGetCollectionOrderFactureEnPreparationEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiDossiersDossierFacturesGetCollectionOrderFactureEnPreparationEnum = typeof ApiDossiersDossierFacturesGetCollectionOrderFactureEnPreparationEnum[keyof typeof ApiDossiersDossierFacturesGetCollectionOrderFactureEnPreparationEnum];
/**
 * @export
 */
export const ApiDossiersDossierFacturesGetCollectionOrderPayeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiDossiersDossierFacturesGetCollectionOrderPayeEnum = typeof ApiDossiersDossierFacturesGetCollectionOrderPayeEnum[keyof typeof ApiDossiersDossierFacturesGetCollectionOrderPayeEnum];
/**
 * @export
 */
export const ApiDossiersDossierFacturesGetCollectionOrderDateEcheanceFactureEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiDossiersDossierFacturesGetCollectionOrderDateEcheanceFactureEnum = typeof ApiDossiersDossierFacturesGetCollectionOrderDateEcheanceFactureEnum[keyof typeof ApiDossiersDossierFacturesGetCollectionOrderDateEcheanceFactureEnum];
/**
 * @export
 */
export const ApiDossiersDossierFacturesGetCollectionOrderNumeroEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiDossiersDossierFacturesGetCollectionOrderNumeroEnum = typeof ApiDossiersDossierFacturesGetCollectionOrderNumeroEnum[keyof typeof ApiDossiersDossierFacturesGetCollectionOrderNumeroEnum];
/**
 * @export
 */
export const ApiFacturesGetCollectionOrderFactureEnPreparationEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiFacturesGetCollectionOrderFactureEnPreparationEnum = typeof ApiFacturesGetCollectionOrderFactureEnPreparationEnum[keyof typeof ApiFacturesGetCollectionOrderFactureEnPreparationEnum];
/**
 * @export
 */
export const ApiFacturesGetCollectionOrderPayeEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiFacturesGetCollectionOrderPayeEnum = typeof ApiFacturesGetCollectionOrderPayeEnum[keyof typeof ApiFacturesGetCollectionOrderPayeEnum];
/**
 * @export
 */
export const ApiFacturesGetCollectionOrderDateEcheanceFactureEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiFacturesGetCollectionOrderDateEcheanceFactureEnum = typeof ApiFacturesGetCollectionOrderDateEcheanceFactureEnum[keyof typeof ApiFacturesGetCollectionOrderDateEcheanceFactureEnum];
/**
 * @export
 */
export const ApiFacturesGetCollectionOrderNumeroEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type ApiFacturesGetCollectionOrderNumeroEnum = typeof ApiFacturesGetCollectionOrderNumeroEnum[keyof typeof ApiFacturesGetCollectionOrderNumeroEnum];


/**
 * FactureOpenSearchApi - axios parameter creator
 * @export
 */
export const FactureOpenSearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Récupérer les informations d\'une facture indexée sur Open Search
         * @summary Récupérer les informations d\'une facture indexée sur Open Search
         * @param {string} id Facture identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFactureIdGet: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiOpensearchFactureIdGet', 'id', id)
            const localVarPath = `/facturation/opensearch/facture/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les clients des factures indexées sur Open Search
         * @summary Lister les clients des factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesClientsGetCollection: async (xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/opensearch/factures-clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (ddmId) {
                localVarQueryParameter['ddmId[]'] = ddmId;
            }

            if (prescripteurId !== undefined) {
                localVarQueryParameter['prescripteurId'] = prescripteurId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les collections de factures indexées sur Open Search
         * @summary Lister les collections de factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesCollectionGetCollection: async (xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/opensearch/factures-collection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (ddmId) {
                localVarQueryParameter['ddmId[]'] = ddmId;
            }

            if (prescripteurId !== undefined) {
                localVarQueryParameter['prescripteurId'] = prescripteurId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les domaines des factures indexées sur Open Search
         * @summary Lister les domaines des factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesDomainesGetCollection: async (xIdSociete?: number, page?: number, itemsPerPage?: number, prescripteurId?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/opensearch/factures-domaines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (prescripteurId !== undefined) {
                localVarQueryParameter['prescripteurId'] = prescripteurId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les dossiers ayant des collection de dossier liés aux factures indexées sur Open Search
         * @summary Lister les dossiers ayant des collection de dossier liés aux factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesDossiersCollectionCommandeGetCollection: async (xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/opensearch/factures-dossiers-collection-commande`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (ddmId) {
                localVarQueryParameter['ddmId[]'] = ddmId;
            }

            if (prescripteurId !== undefined) {
                localVarQueryParameter['prescripteurId'] = prescripteurId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les dossiers liés aux factures indexées sur Open Search
         * @summary Lister les dossiers liés aux factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesDossiersGetCollection: async (xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/opensearch/factures-dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (ddmId) {
                localVarQueryParameter['ddmId[]'] = ddmId;
            }

            if (prescripteurId !== undefined) {
                localVarQueryParameter['prescripteurId'] = prescripteurId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les factures indexés sur Open Search
         * @summary Lister les factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {number} [id] Filter invoices list by id
         * @param {Array<number>} [clientId] Filter invoices list by client ids
         * @param {Array<string>} [factureNumero] Filter invoices list by factureNumero
         * @param {Array<string>} [dossierNumero] Filter invoices list by invoice dossierNumero
         * @param {Array<string>} [reference] Filter invoices list by invoice references
         * @param {Array<string>} [status] Filter invoices list by invoice status
         * @param {Array<string>} [type] Filter invoices list by invoice type
         * @param {string} [dateDecheanceFactureDebut] Filter invoices list by invoice deadline
         * @param {string} [dateDecheanceFactureFin] Filter invoices list by invoice deadline
         * @param {string} [dateFactureDebut] Filter invoices list by invoice deadline
         * @param {string} [dateFactureFin] Filter invoices list by invoice deadline
         * @param {boolean} [enPreparation] Display - hide  proforma invoices
         * @param {boolean} [fGroupee] Display - hide monthly invoices
         * @param {boolean} [fPayee] Display - hide payed invoices
         * @param {number} [totalTTC] Filter invoices list by total TTC
         * @param {Array<number>} [dossierCollectionId] Filter invoices list by dossier Collection Ids (dossier collection)
         * @param {string} [orderFactureNumero] Sort facture by factureNumero
         * @param {string} [orderReference] Sort facture by reference dossier
         * @param {string} [orderSocieteFacturee] Sort facture by societeFacturee
         * @param {string} [orderdateDateEcheanceFacture] Sort facture by dateEcheanceFacture
         * @param {string} [orderTypeFormalite] Sort facture by type Formalite
         * @param {string} [orderTotalTtc] Sort facture by totalTTC
         * @param {string} [orderdateDateFacture] Sort facture by dateFacture
         * @param {string} [orderMontantPaiementRecu] Sort facture by montantPaiementRecu
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesGetCollection: async (xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, id?: number, clientId?: Array<number>, factureNumero?: Array<string>, dossierNumero?: Array<string>, reference?: Array<string>, status?: Array<string>, type?: Array<string>, dateDecheanceFactureDebut?: string, dateDecheanceFactureFin?: string, dateFactureDebut?: string, dateFactureFin?: string, enPreparation?: boolean, fGroupee?: boolean, fPayee?: boolean, totalTTC?: number, dossierCollectionId?: Array<number>, orderFactureNumero?: string, orderReference?: string, orderSocieteFacturee?: string, orderdateDateEcheanceFacture?: string, orderTypeFormalite?: string, orderTotalTtc?: string, orderdateDateFacture?: string, orderMontantPaiementRecu?: string, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/opensearch/factures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (ddmId) {
                localVarQueryParameter['ddmId[]'] = ddmId;
            }

            if (prescripteurId !== undefined) {
                localVarQueryParameter['prescripteurId'] = prescripteurId;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (clientId) {
                localVarQueryParameter['clientId[]'] = clientId;
            }

            if (factureNumero) {
                localVarQueryParameter['factureNumero[]'] = factureNumero;
            }

            if (dossierNumero) {
                localVarQueryParameter['dossierNumero[]'] = dossierNumero;
            }

            if (reference) {
                localVarQueryParameter['reference[]'] = reference;
            }

            if (status) {
                localVarQueryParameter['status[]'] = status;
            }

            if (type) {
                localVarQueryParameter['type[]'] = type;
            }

            if (dateDecheanceFactureDebut !== undefined) {
                localVarQueryParameter['dateDecheanceFactureDebut'] = dateDecheanceFactureDebut;
            }

            if (dateDecheanceFactureFin !== undefined) {
                localVarQueryParameter['dateDecheanceFactureFin'] = dateDecheanceFactureFin;
            }

            if (dateFactureDebut !== undefined) {
                localVarQueryParameter['dateFactureDebut'] = dateFactureDebut;
            }

            if (dateFactureFin !== undefined) {
                localVarQueryParameter['dateFactureFin'] = dateFactureFin;
            }

            if (enPreparation !== undefined) {
                localVarQueryParameter['enPreparation'] = enPreparation;
            }

            if (fGroupee !== undefined) {
                localVarQueryParameter['fGroupee'] = fGroupee;
            }

            if (fPayee !== undefined) {
                localVarQueryParameter['fPayee'] = fPayee;
            }

            if (totalTTC !== undefined) {
                localVarQueryParameter['totalTTC'] = totalTTC;
            }

            if (dossierCollectionId) {
                localVarQueryParameter['dossierCollectionId[]'] = dossierCollectionId;
            }

            if (orderFactureNumero !== undefined) {
                localVarQueryParameter['order[factureNumero]'] = orderFactureNumero;
            }

            if (orderReference !== undefined) {
                localVarQueryParameter['order[reference]'] = orderReference;
            }

            if (orderSocieteFacturee !== undefined) {
                localVarQueryParameter['order[societeFacturee]'] = orderSocieteFacturee;
            }

            if (orderdateDateEcheanceFacture !== undefined) {
                localVarQueryParameter['orderdate[dateEcheanceFacture]'] = orderdateDateEcheanceFacture;
            }

            if (orderTypeFormalite !== undefined) {
                localVarQueryParameter['order[typeFormalite]'] = orderTypeFormalite;
            }

            if (orderTotalTtc !== undefined) {
                localVarQueryParameter['order[totalTtc]'] = orderTotalTtc;
            }

            if (orderdateDateFacture !== undefined) {
                localVarQueryParameter['orderdate[dateFacture]'] = orderdateDateFacture;
            }

            if (orderMontantPaiementRecu !== undefined) {
                localVarQueryParameter['order[montantPaiementRecu]'] = orderMontantPaiementRecu;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Indexer un lot de factures sur Open Search
         * @summary Indexer un lot de factures sur Open Search
         * @param {FactureOpenSearchJsonldOpensearchFactureIndexBacth} factureOpenSearchJsonldOpensearchFactureIndexBacth The new Facture Open Search resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesIndexByIdsPost: async (factureOpenSearchJsonldOpensearchFactureIndexBacth: FactureOpenSearchJsonldOpensearchFactureIndexBacth, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'factureOpenSearchJsonldOpensearchFactureIndexBacth' is not null or undefined
            assertParamExists('apiOpensearchFacturesIndexByIdsPost', 'factureOpenSearchJsonldOpensearchFactureIndexBacth', factureOpenSearchJsonldOpensearchFactureIndexBacth)
            const localVarPath = `/facturation/opensearch/factures/index-by-ids`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(factureOpenSearchJsonldOpensearchFactureIndexBacth, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les prescripteurs des factures indexées sur Open Search
         * @summary Lister les prescripteurs des factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesPrescripteursGetCollection: async (xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/opensearch/factures-prescripteurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (ddmId) {
                localVarQueryParameter['ddmId[]'] = ddmId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lister les références liés aux factures indexées sur Open Search
         * @summary Lister les références liés aux factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesReferencesGetCollection: async (xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, q?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/opensearch/factures-references`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (itemsPerPage !== undefined) {
                localVarQueryParameter['itemsPerPage'] = itemsPerPage;
            }

            if (ddmId) {
                localVarQueryParameter['ddmId[]'] = ddmId;
            }

            if (prescripteurId !== undefined) {
                localVarQueryParameter['prescripteurId'] = prescripteurId;
            }

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FactureOpenSearchApi - functional programming interface
 * @export
 */
export const FactureOpenSearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FactureOpenSearchApiAxiosParamCreator(configuration)
    return {
        /**
         * Récupérer les informations d\'une facture indexée sur Open Search
         * @summary Récupérer les informations d\'une facture indexée sur Open Search
         * @param {string} id Facture identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFactureIdGet(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactureOpenSearchJsonldOpensearchFactureRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFactureIdGet(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureOpenSearchApi.apiOpensearchFactureIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les clients des factures indexées sur Open Search
         * @summary Lister les clients des factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFacturesClientsGetCollection(xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFacturesClientsGetCollection(xIdSociete, page, itemsPerPage, ddmId, prescripteurId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureOpenSearchApi.apiOpensearchFacturesClientsGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les collections de factures indexées sur Open Search
         * @summary Lister les collections de factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFacturesCollectionGetCollection(xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFacturesCollectionGetCollection(xIdSociete, page, itemsPerPage, ddmId, prescripteurId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureOpenSearchApi.apiOpensearchFacturesCollectionGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les domaines des factures indexées sur Open Search
         * @summary Lister les domaines des factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFacturesDomainesGetCollection(xIdSociete?: number, page?: number, itemsPerPage?: number, prescripteurId?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFacturesDomainesGetCollection(xIdSociete, page, itemsPerPage, prescripteurId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureOpenSearchApi.apiOpensearchFacturesDomainesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les dossiers ayant des collection de dossier liés aux factures indexées sur Open Search
         * @summary Lister les dossiers ayant des collection de dossier liés aux factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFacturesDossiersCollectionCommandeGetCollection(xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFacturesDossiersCollectionCommandeGetCollection(xIdSociete, page, itemsPerPage, ddmId, prescripteurId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureOpenSearchApi.apiOpensearchFacturesDossiersCollectionCommandeGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les dossiers liés aux factures indexées sur Open Search
         * @summary Lister les dossiers liés aux factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFacturesDossiersGetCollection(xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFacturesDossiersGetCollection(xIdSociete, page, itemsPerPage, ddmId, prescripteurId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureOpenSearchApi.apiOpensearchFacturesDossiersGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les factures indexés sur Open Search
         * @summary Lister les factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {number} [id] Filter invoices list by id
         * @param {Array<number>} [clientId] Filter invoices list by client ids
         * @param {Array<string>} [factureNumero] Filter invoices list by factureNumero
         * @param {Array<string>} [dossierNumero] Filter invoices list by invoice dossierNumero
         * @param {Array<string>} [reference] Filter invoices list by invoice references
         * @param {Array<string>} [status] Filter invoices list by invoice status
         * @param {Array<string>} [type] Filter invoices list by invoice type
         * @param {string} [dateDecheanceFactureDebut] Filter invoices list by invoice deadline
         * @param {string} [dateDecheanceFactureFin] Filter invoices list by invoice deadline
         * @param {string} [dateFactureDebut] Filter invoices list by invoice deadline
         * @param {string} [dateFactureFin] Filter invoices list by invoice deadline
         * @param {boolean} [enPreparation] Display - hide  proforma invoices
         * @param {boolean} [fGroupee] Display - hide monthly invoices
         * @param {boolean} [fPayee] Display - hide payed invoices
         * @param {number} [totalTTC] Filter invoices list by total TTC
         * @param {Array<number>} [dossierCollectionId] Filter invoices list by dossier Collection Ids (dossier collection)
         * @param {string} [orderFactureNumero] Sort facture by factureNumero
         * @param {string} [orderReference] Sort facture by reference dossier
         * @param {string} [orderSocieteFacturee] Sort facture by societeFacturee
         * @param {string} [orderdateDateEcheanceFacture] Sort facture by dateEcheanceFacture
         * @param {string} [orderTypeFormalite] Sort facture by type Formalite
         * @param {string} [orderTotalTtc] Sort facture by totalTTC
         * @param {string} [orderdateDateFacture] Sort facture by dateFacture
         * @param {string} [orderMontantPaiementRecu] Sort facture by montantPaiementRecu
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFacturesGetCollection(xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, id?: number, clientId?: Array<number>, factureNumero?: Array<string>, dossierNumero?: Array<string>, reference?: Array<string>, status?: Array<string>, type?: Array<string>, dateDecheanceFactureDebut?: string, dateDecheanceFactureFin?: string, dateFactureDebut?: string, dateFactureFin?: string, enPreparation?: boolean, fGroupee?: boolean, fPayee?: boolean, totalTTC?: number, dossierCollectionId?: Array<number>, orderFactureNumero?: string, orderReference?: string, orderSocieteFacturee?: string, orderdateDateEcheanceFacture?: string, orderTypeFormalite?: string, orderTotalTtc?: string, orderdateDateFacture?: string, orderMontantPaiementRecu?: string, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFacturesGetCollection(xIdSociete, page, itemsPerPage, ddmId, prescripteurId, id, clientId, factureNumero, dossierNumero, reference, status, type, dateDecheanceFactureDebut, dateDecheanceFactureFin, dateFactureDebut, dateFactureFin, enPreparation, fGroupee, fPayee, totalTTC, dossierCollectionId, orderFactureNumero, orderReference, orderSocieteFacturee, orderdateDateEcheanceFacture, orderTypeFormalite, orderTotalTtc, orderdateDateFacture, orderMontantPaiementRecu, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureOpenSearchApi.apiOpensearchFacturesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Indexer un lot de factures sur Open Search
         * @summary Indexer un lot de factures sur Open Search
         * @param {FactureOpenSearchJsonldOpensearchFactureIndexBacth} factureOpenSearchJsonldOpensearchFactureIndexBacth The new Facture Open Search resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFacturesIndexByIdsPost(factureOpenSearchJsonldOpensearchFactureIndexBacth: FactureOpenSearchJsonldOpensearchFactureIndexBacth, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FactureOpenSearchIndexBatchFactureResponseJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFacturesIndexByIdsPost(factureOpenSearchJsonldOpensearchFactureIndexBacth, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureOpenSearchApi.apiOpensearchFacturesIndexByIdsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les prescripteurs des factures indexées sur Open Search
         * @summary Lister les prescripteurs des factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFacturesPrescripteursGetCollection(xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFacturesPrescripteursGetCollection(xIdSociete, page, itemsPerPage, ddmId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureOpenSearchApi.apiOpensearchFacturesPrescripteursGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lister les références liés aux factures indexées sur Open Search
         * @summary Lister les références liés aux factures indexées sur Open Search
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [itemsPerPage] The number of items per page
         * @param {Array<number>} [ddmId] Filter invoices list by ddmIds
         * @param {number} [prescripteurId] Filter invoices list by prescripteur ids
         * @param {string} [q] Search term
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiOpensearchFacturesReferencesGetCollection(xIdSociete?: number, page?: number, itemsPerPage?: number, ddmId?: Array<number>, prescripteurId?: number, q?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiOpensearchFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiOpensearchFacturesReferencesGetCollection(xIdSociete, page, itemsPerPage, ddmId, prescripteurId, q, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FactureOpenSearchApi.apiOpensearchFacturesReferencesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FactureOpenSearchApi - factory interface
 * @export
 */
export const FactureOpenSearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FactureOpenSearchApiFp(configuration)
    return {
        /**
         * Récupérer les informations d\'une facture indexée sur Open Search
         * @summary Récupérer les informations d\'une facture indexée sur Open Search
         * @param {FactureOpenSearchApiApiOpensearchFactureIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFactureIdGet(requestParameters: FactureOpenSearchApiApiOpensearchFactureIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<FactureOpenSearchJsonldOpensearchFactureRead> {
            return localVarFp.apiOpensearchFactureIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les clients des factures indexées sur Open Search
         * @summary Lister les clients des factures indexées sur Open Search
         * @param {FactureOpenSearchApiApiOpensearchFacturesClientsGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesClientsGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesClientsGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchFacturesGetCollection200Response> {
            return localVarFp.apiOpensearchFacturesClientsGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les collections de factures indexées sur Open Search
         * @summary Lister les collections de factures indexées sur Open Search
         * @param {FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesCollectionGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchFacturesGetCollection200Response> {
            return localVarFp.apiOpensearchFacturesCollectionGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les domaines des factures indexées sur Open Search
         * @summary Lister les domaines des factures indexées sur Open Search
         * @param {FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesDomainesGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchFacturesGetCollection200Response> {
            return localVarFp.apiOpensearchFacturesDomainesGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les dossiers ayant des collection de dossier liés aux factures indexées sur Open Search
         * @summary Lister les dossiers ayant des collection de dossier liés aux factures indexées sur Open Search
         * @param {FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesDossiersCollectionCommandeGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchFacturesGetCollection200Response> {
            return localVarFp.apiOpensearchFacturesDossiersCollectionCommandeGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les dossiers liés aux factures indexées sur Open Search
         * @summary Lister les dossiers liés aux factures indexées sur Open Search
         * @param {FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesDossiersGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchFacturesGetCollection200Response> {
            return localVarFp.apiOpensearchFacturesDossiersGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les factures indexés sur Open Search
         * @summary Lister les factures indexées sur Open Search
         * @param {FactureOpenSearchApiApiOpensearchFacturesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchFacturesGetCollection200Response> {
            return localVarFp.apiOpensearchFacturesGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.id, requestParameters.clientId, requestParameters.factureNumero, requestParameters.dossierNumero, requestParameters.reference, requestParameters.status, requestParameters.type, requestParameters.dateDecheanceFactureDebut, requestParameters.dateDecheanceFactureFin, requestParameters.dateFactureDebut, requestParameters.dateFactureFin, requestParameters.enPreparation, requestParameters.fGroupee, requestParameters.fPayee, requestParameters.totalTTC, requestParameters.dossierCollectionId, requestParameters.orderFactureNumero, requestParameters.orderReference, requestParameters.orderSocieteFacturee, requestParameters.orderdateDateEcheanceFacture, requestParameters.orderTypeFormalite, requestParameters.orderTotalTtc, requestParameters.orderdateDateFacture, requestParameters.orderMontantPaiementRecu, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Indexer un lot de factures sur Open Search
         * @summary Indexer un lot de factures sur Open Search
         * @param {FactureOpenSearchApiApiOpensearchFacturesIndexByIdsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesIndexByIdsPost(requestParameters: FactureOpenSearchApiApiOpensearchFacturesIndexByIdsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<FactureOpenSearchIndexBatchFactureResponseJsonld> {
            return localVarFp.apiOpensearchFacturesIndexByIdsPost(requestParameters.factureOpenSearchJsonldOpensearchFactureIndexBacth, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les prescripteurs des factures indexées sur Open Search
         * @summary Lister les prescripteurs des factures indexées sur Open Search
         * @param {FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesPrescripteursGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchFacturesGetCollection200Response> {
            return localVarFp.apiOpensearchFacturesPrescripteursGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.q, options).then((request) => request(axios, basePath));
        },
        /**
         * Lister les références liés aux factures indexées sur Open Search
         * @summary Lister les références liés aux factures indexées sur Open Search
         * @param {FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiOpensearchFacturesReferencesGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiOpensearchFacturesGetCollection200Response> {
            return localVarFp.apiOpensearchFacturesReferencesGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiOpensearchFactureIdGet operation in FactureOpenSearchApi.
 * @export
 * @interface FactureOpenSearchApiApiOpensearchFactureIdGetRequest
 */
export interface FactureOpenSearchApiApiOpensearchFactureIdGetRequest {
    /**
     * Facture identifier
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFactureIdGet
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFactureIdGet
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiOpensearchFacturesClientsGetCollection operation in FactureOpenSearchApi.
 * @export
 * @interface FactureOpenSearchApiApiOpensearchFacturesClientsGetCollectionRequest
 */
export interface FactureOpenSearchApiApiOpensearchFacturesClientsGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesClientsGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesClientsGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesClientsGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter invoices list by ddmIds
     * @type {Array<number>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesClientsGetCollection
     */
    readonly ddmId?: Array<number>

    /**
     * Filter invoices list by prescripteur ids
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesClientsGetCollection
     */
    readonly prescripteurId?: number

    /**
     * Search term
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesClientsGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchFacturesCollectionGetCollection operation in FactureOpenSearchApi.
 * @export
 * @interface FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollectionRequest
 */
export interface FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter invoices list by ddmIds
     * @type {Array<number>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollection
     */
    readonly ddmId?: Array<number>

    /**
     * Filter invoices list by prescripteur ids
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollection
     */
    readonly prescripteurId?: number

    /**
     * Search term
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchFacturesDomainesGetCollection operation in FactureOpenSearchApi.
 * @export
 * @interface FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollectionRequest
 */
export interface FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter invoices list by prescripteur ids
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollection
     */
    readonly prescripteurId?: number

    /**
     * Search term
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchFacturesDossiersCollectionCommandeGetCollection operation in FactureOpenSearchApi.
 * @export
 * @interface FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollectionRequest
 */
export interface FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter invoices list by ddmIds
     * @type {Array<number>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollection
     */
    readonly ddmId?: Array<number>

    /**
     * Filter invoices list by prescripteur ids
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollection
     */
    readonly prescripteurId?: number

    /**
     * Search term
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchFacturesDossiersGetCollection operation in FactureOpenSearchApi.
 * @export
 * @interface FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollectionRequest
 */
export interface FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter invoices list by ddmIds
     * @type {Array<number>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollection
     */
    readonly ddmId?: Array<number>

    /**
     * Filter invoices list by prescripteur ids
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollection
     */
    readonly prescripteurId?: number

    /**
     * Search term
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchFacturesGetCollection operation in FactureOpenSearchApi.
 * @export
 * @interface FactureOpenSearchApiApiOpensearchFacturesGetCollectionRequest
 */
export interface FactureOpenSearchApiApiOpensearchFacturesGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter invoices list by ddmIds
     * @type {Array<number>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly ddmId?: Array<number>

    /**
     * Filter invoices list by prescripteur ids
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly prescripteurId?: number

    /**
     * Filter invoices list by id
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly id?: number

    /**
     * Filter invoices list by client ids
     * @type {Array<number>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly clientId?: Array<number>

    /**
     * Filter invoices list by factureNumero
     * @type {Array<string>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly factureNumero?: Array<string>

    /**
     * Filter invoices list by invoice dossierNumero
     * @type {Array<string>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly dossierNumero?: Array<string>

    /**
     * Filter invoices list by invoice references
     * @type {Array<string>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly reference?: Array<string>

    /**
     * Filter invoices list by invoice status
     * @type {Array<string>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly status?: Array<string>

    /**
     * Filter invoices list by invoice type
     * @type {Array<string>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly type?: Array<string>

    /**
     * Filter invoices list by invoice deadline
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly dateDecheanceFactureDebut?: string

    /**
     * Filter invoices list by invoice deadline
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly dateDecheanceFactureFin?: string

    /**
     * Filter invoices list by invoice deadline
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly dateFactureDebut?: string

    /**
     * Filter invoices list by invoice deadline
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly dateFactureFin?: string

    /**
     * Display - hide  proforma invoices
     * @type {boolean}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly enPreparation?: boolean

    /**
     * Display - hide monthly invoices
     * @type {boolean}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly fGroupee?: boolean

    /**
     * Display - hide payed invoices
     * @type {boolean}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly fPayee?: boolean

    /**
     * Filter invoices list by total TTC
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly totalTTC?: number

    /**
     * Filter invoices list by dossier Collection Ids (dossier collection)
     * @type {Array<number>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly dossierCollectionId?: Array<number>

    /**
     * Sort facture by factureNumero
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly orderFactureNumero?: string

    /**
     * Sort facture by reference dossier
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly orderReference?: string

    /**
     * Sort facture by societeFacturee
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly orderSocieteFacturee?: string

    /**
     * Sort facture by dateEcheanceFacture
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly orderdateDateEcheanceFacture?: string

    /**
     * Sort facture by type Formalite
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly orderTypeFormalite?: string

    /**
     * Sort facture by totalTTC
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly orderTotalTtc?: string

    /**
     * Sort facture by dateFacture
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly orderdateDateFacture?: string

    /**
     * Sort facture by montantPaiementRecu
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly orderMontantPaiementRecu?: string

    /**
     * Search term
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchFacturesIndexByIdsPost operation in FactureOpenSearchApi.
 * @export
 * @interface FactureOpenSearchApiApiOpensearchFacturesIndexByIdsPostRequest
 */
export interface FactureOpenSearchApiApiOpensearchFacturesIndexByIdsPostRequest {
    /**
     * The new Facture Open Search resource
     * @type {FactureOpenSearchJsonldOpensearchFactureIndexBacth}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesIndexByIdsPost
     */
    readonly factureOpenSearchJsonldOpensearchFactureIndexBacth: FactureOpenSearchJsonldOpensearchFactureIndexBacth

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesIndexByIdsPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiOpensearchFacturesPrescripteursGetCollection operation in FactureOpenSearchApi.
 * @export
 * @interface FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollectionRequest
 */
export interface FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter invoices list by ddmIds
     * @type {Array<number>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollection
     */
    readonly ddmId?: Array<number>

    /**
     * Search term
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollection
     */
    readonly q?: string
}

/**
 * Request parameters for apiOpensearchFacturesReferencesGetCollection operation in FactureOpenSearchApi.
 * @export
 * @interface FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollectionRequest
 */
export interface FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollection
     */
    readonly page?: number

    /**
     * The number of items per page
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollection
     */
    readonly itemsPerPage?: number

    /**
     * Filter invoices list by ddmIds
     * @type {Array<number>}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollection
     */
    readonly ddmId?: Array<number>

    /**
     * Filter invoices list by prescripteur ids
     * @type {number}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollection
     */
    readonly prescripteurId?: number

    /**
     * Search term
     * @type {string}
     * @memberof FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollection
     */
    readonly q?: string
}

/**
 * FactureOpenSearchApi - object-oriented interface
 * @export
 * @class FactureOpenSearchApi
 * @extends {BaseAPI}
 */
export class FactureOpenSearchApi extends BaseAPI {
    /**
     * Récupérer les informations d\'une facture indexée sur Open Search
     * @summary Récupérer les informations d\'une facture indexée sur Open Search
     * @param {FactureOpenSearchApiApiOpensearchFactureIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureOpenSearchApi
     */
    public apiOpensearchFactureIdGet(requestParameters: FactureOpenSearchApiApiOpensearchFactureIdGetRequest, options?: RawAxiosRequestConfig) {
        return FactureOpenSearchApiFp(this.configuration).apiOpensearchFactureIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les clients des factures indexées sur Open Search
     * @summary Lister les clients des factures indexées sur Open Search
     * @param {FactureOpenSearchApiApiOpensearchFacturesClientsGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureOpenSearchApi
     */
    public apiOpensearchFacturesClientsGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesClientsGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FactureOpenSearchApiFp(this.configuration).apiOpensearchFacturesClientsGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les collections de factures indexées sur Open Search
     * @summary Lister les collections de factures indexées sur Open Search
     * @param {FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureOpenSearchApi
     */
    public apiOpensearchFacturesCollectionGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesCollectionGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FactureOpenSearchApiFp(this.configuration).apiOpensearchFacturesCollectionGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les domaines des factures indexées sur Open Search
     * @summary Lister les domaines des factures indexées sur Open Search
     * @param {FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureOpenSearchApi
     */
    public apiOpensearchFacturesDomainesGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesDomainesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FactureOpenSearchApiFp(this.configuration).apiOpensearchFacturesDomainesGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les dossiers ayant des collection de dossier liés aux factures indexées sur Open Search
     * @summary Lister les dossiers ayant des collection de dossier liés aux factures indexées sur Open Search
     * @param {FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureOpenSearchApi
     */
    public apiOpensearchFacturesDossiersCollectionCommandeGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesDossiersCollectionCommandeGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FactureOpenSearchApiFp(this.configuration).apiOpensearchFacturesDossiersCollectionCommandeGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les dossiers liés aux factures indexées sur Open Search
     * @summary Lister les dossiers liés aux factures indexées sur Open Search
     * @param {FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureOpenSearchApi
     */
    public apiOpensearchFacturesDossiersGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesDossiersGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FactureOpenSearchApiFp(this.configuration).apiOpensearchFacturesDossiersGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les factures indexés sur Open Search
     * @summary Lister les factures indexées sur Open Search
     * @param {FactureOpenSearchApiApiOpensearchFacturesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureOpenSearchApi
     */
    public apiOpensearchFacturesGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FactureOpenSearchApiFp(this.configuration).apiOpensearchFacturesGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.id, requestParameters.clientId, requestParameters.factureNumero, requestParameters.dossierNumero, requestParameters.reference, requestParameters.status, requestParameters.type, requestParameters.dateDecheanceFactureDebut, requestParameters.dateDecheanceFactureFin, requestParameters.dateFactureDebut, requestParameters.dateFactureFin, requestParameters.enPreparation, requestParameters.fGroupee, requestParameters.fPayee, requestParameters.totalTTC, requestParameters.dossierCollectionId, requestParameters.orderFactureNumero, requestParameters.orderReference, requestParameters.orderSocieteFacturee, requestParameters.orderdateDateEcheanceFacture, requestParameters.orderTypeFormalite, requestParameters.orderTotalTtc, requestParameters.orderdateDateFacture, requestParameters.orderMontantPaiementRecu, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Indexer un lot de factures sur Open Search
     * @summary Indexer un lot de factures sur Open Search
     * @param {FactureOpenSearchApiApiOpensearchFacturesIndexByIdsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureOpenSearchApi
     */
    public apiOpensearchFacturesIndexByIdsPost(requestParameters: FactureOpenSearchApiApiOpensearchFacturesIndexByIdsPostRequest, options?: RawAxiosRequestConfig) {
        return FactureOpenSearchApiFp(this.configuration).apiOpensearchFacturesIndexByIdsPost(requestParameters.factureOpenSearchJsonldOpensearchFactureIndexBacth, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les prescripteurs des factures indexées sur Open Search
     * @summary Lister les prescripteurs des factures indexées sur Open Search
     * @param {FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureOpenSearchApi
     */
    public apiOpensearchFacturesPrescripteursGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesPrescripteursGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FactureOpenSearchApiFp(this.configuration).apiOpensearchFacturesPrescripteursGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lister les références liés aux factures indexées sur Open Search
     * @summary Lister les références liés aux factures indexées sur Open Search
     * @param {FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FactureOpenSearchApi
     */
    public apiOpensearchFacturesReferencesGetCollection(requestParameters: FactureOpenSearchApiApiOpensearchFacturesReferencesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return FactureOpenSearchApiFp(this.configuration).apiOpensearchFacturesReferencesGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.itemsPerPage, requestParameters.ddmId, requestParameters.prescripteurId, requestParameters.q, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LigneFactureApi - axios parameter creator
 * @export
 */
export const LigneFactureApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des lignes de factures
         * @summary Obtenir la liste des lignes de factures
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [idFproPrestaFormArtId] 
         * @param {Array<number>} [idFproPrestaFormArtId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLignesFacturesGetCollection: async (xIdSociete?: number, page?: number, idFproPrestaFormArtId?: number, idFproPrestaFormArtId2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/lignes-factures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (idFproPrestaFormArtId !== undefined) {
                localVarQueryParameter['idFproPrestaFormArt.id'] = idFproPrestaFormArtId;
            }

            if (idFproPrestaFormArtId2) {
                localVarQueryParameter['idFproPrestaFormArt.id[]'] = idFproPrestaFormArtId2;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'une ligne de facture
         * @summary Récupérer les informations d\'une ligne de facture
         * @param {string} id TblFligne identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLignesFacturesIdGet: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLignesFacturesIdGet', 'id', id)
            const localVarPath = `/facturation/lignes-factures/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LigneFactureApi - functional programming interface
 * @export
 */
export const LigneFactureApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LigneFactureApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des lignes de factures
         * @summary Obtenir la liste des lignes de factures
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [idFproPrestaFormArtId] 
         * @param {Array<number>} [idFproPrestaFormArtId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLignesFacturesGetCollection(xIdSociete?: number, page?: number, idFproPrestaFormArtId?: number, idFproPrestaFormArtId2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLignesFacturesGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLignesFacturesGetCollection(xIdSociete, page, idFproPrestaFormArtId, idFproPrestaFormArtId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LigneFactureApi.apiLignesFacturesGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'une ligne de facture
         * @summary Récupérer les informations d\'une ligne de facture
         * @param {string} id TblFligne identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLignesFacturesIdGet(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LigneFactureJsonldLigneFactureRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLignesFacturesIdGet(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LigneFactureApi.apiLignesFacturesIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LigneFactureApi - factory interface
 * @export
 */
export const LigneFactureApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LigneFactureApiFp(configuration)
    return {
        /**
         * Obtenir la liste des lignes de factures
         * @summary Obtenir la liste des lignes de factures
         * @param {LigneFactureApiApiLignesFacturesGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLignesFacturesGetCollection(requestParameters: LigneFactureApiApiLignesFacturesGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiLignesFacturesGetCollection200Response> {
            return localVarFp.apiLignesFacturesGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.idFproPrestaFormArtId, requestParameters.idFproPrestaFormArtId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'une ligne de facture
         * @summary Récupérer les informations d\'une ligne de facture
         * @param {LigneFactureApiApiLignesFacturesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLignesFacturesIdGet(requestParameters: LigneFactureApiApiLignesFacturesIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<LigneFactureJsonldLigneFactureRead> {
            return localVarFp.apiLignesFacturesIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLignesFacturesGetCollection operation in LigneFactureApi.
 * @export
 * @interface LigneFactureApiApiLignesFacturesGetCollectionRequest
 */
export interface LigneFactureApiApiLignesFacturesGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof LigneFactureApiApiLignesFacturesGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof LigneFactureApiApiLignesFacturesGetCollection
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof LigneFactureApiApiLignesFacturesGetCollection
     */
    readonly idFproPrestaFormArtId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof LigneFactureApiApiLignesFacturesGetCollection
     */
    readonly idFproPrestaFormArtId2?: Array<number>
}

/**
 * Request parameters for apiLignesFacturesIdGet operation in LigneFactureApi.
 * @export
 * @interface LigneFactureApiApiLignesFacturesIdGetRequest
 */
export interface LigneFactureApiApiLignesFacturesIdGetRequest {
    /**
     * TblFligne identifier
     * @type {string}
     * @memberof LigneFactureApiApiLignesFacturesIdGet
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof LigneFactureApiApiLignesFacturesIdGet
     */
    readonly xIdSociete?: number
}

/**
 * LigneFactureApi - object-oriented interface
 * @export
 * @class LigneFactureApi
 * @extends {BaseAPI}
 */
export class LigneFactureApi extends BaseAPI {
    /**
     * Obtenir la liste des lignes de factures
     * @summary Obtenir la liste des lignes de factures
     * @param {LigneFactureApiApiLignesFacturesGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LigneFactureApi
     */
    public apiLignesFacturesGetCollection(requestParameters: LigneFactureApiApiLignesFacturesGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return LigneFactureApiFp(this.configuration).apiLignesFacturesGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.idFproPrestaFormArtId, requestParameters.idFproPrestaFormArtId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'une ligne de facture
     * @summary Récupérer les informations d\'une ligne de facture
     * @param {LigneFactureApiApiLignesFacturesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LigneFactureApi
     */
    public apiLignesFacturesIdGet(requestParameters: LigneFactureApiApiLignesFacturesIdGetRequest, options?: RawAxiosRequestConfig) {
        return LigneFactureApiFp(this.configuration).apiLignesFacturesIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LogActionDossierApi - axios parameter creator
 * @export
 */
export const LogActionDossierApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Retrieves the collection of LogActionDossier resources.
         * @param {string} entityId LogActionDossier identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDossierClientEntityIdGetCollection: async (entityId: string, xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('apiLogActionDossierClientEntityIdGetCollection', 'entityId', entityId)
            const localVarPath = `/facturation/log-action-dossier-client/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a LogActionDossier resource.
         * @summary Creates a LogActionDossier resource.
         * @param {LogActionDossierJsonld} logActionDossierJsonld The new LogActionDossier resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDossiersFormatPost: async (logActionDossierJsonld: LogActionDossierJsonld, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'logActionDossierJsonld' is not null or undefined
            assertParamExists('apiLogActionDossiersFormatPost', 'logActionDossierJsonld', logActionDossierJsonld)
            const localVarPath = `/facturation/log_action_dossiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(logActionDossierJsonld, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LogActionDossierApi - functional programming interface
 * @export
 */
export const LogActionDossierApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LogActionDossierApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Retrieves the collection of LogActionDossier resources.
         * @param {string} entityId LogActionDossier identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionDossierClientEntityIdGetCollection(entityId: string, xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLogActionDossierClientEntityIdGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionDossierClientEntityIdGetCollection(entityId, xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogActionDossierApi.apiLogActionDossierClientEntityIdGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Creates a LogActionDossier resource.
         * @summary Creates a LogActionDossier resource.
         * @param {LogActionDossierJsonld} logActionDossierJsonld The new LogActionDossier resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLogActionDossiersFormatPost(logActionDossierJsonld: LogActionDossierJsonld, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LogActionDossierJsonld>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLogActionDossiersFormatPost(logActionDossierJsonld, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LogActionDossierApi.apiLogActionDossiersFormatPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LogActionDossierApi - factory interface
 * @export
 */
export const LogActionDossierApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LogActionDossierApiFp(configuration)
    return {
        /**
         * Retrieves the collection of LogActionDossier resources.
         * @summary Retrieves the collection of LogActionDossier resources.
         * @param {LogActionDossierApiApiLogActionDossierClientEntityIdGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDossierClientEntityIdGetCollection(requestParameters: LogActionDossierApiApiLogActionDossierClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiLogActionDossierClientEntityIdGetCollection200Response> {
            return localVarFp.apiLogActionDossierClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a LogActionDossier resource.
         * @summary Creates a LogActionDossier resource.
         * @param {LogActionDossierApiApiLogActionDossiersFormatPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLogActionDossiersFormatPost(requestParameters: LogActionDossierApiApiLogActionDossiersFormatPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<LogActionDossierJsonld> {
            return localVarFp.apiLogActionDossiersFormatPost(requestParameters.logActionDossierJsonld, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLogActionDossierClientEntityIdGetCollection operation in LogActionDossierApi.
 * @export
 * @interface LogActionDossierApiApiLogActionDossierClientEntityIdGetCollectionRequest
 */
export interface LogActionDossierApiApiLogActionDossierClientEntityIdGetCollectionRequest {
    /**
     * LogActionDossier identifier
     * @type {string}
     * @memberof LogActionDossierApiApiLogActionDossierClientEntityIdGetCollection
     */
    readonly entityId: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof LogActionDossierApiApiLogActionDossierClientEntityIdGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof LogActionDossierApiApiLogActionDossierClientEntityIdGetCollection
     */
    readonly page?: number
}

/**
 * Request parameters for apiLogActionDossiersFormatPost operation in LogActionDossierApi.
 * @export
 * @interface LogActionDossierApiApiLogActionDossiersFormatPostRequest
 */
export interface LogActionDossierApiApiLogActionDossiersFormatPostRequest {
    /**
     * The new LogActionDossier resource
     * @type {LogActionDossierJsonld}
     * @memberof LogActionDossierApiApiLogActionDossiersFormatPost
     */
    readonly logActionDossierJsonld: LogActionDossierJsonld

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof LogActionDossierApiApiLogActionDossiersFormatPost
     */
    readonly xIdSociete?: number
}

/**
 * LogActionDossierApi - object-oriented interface
 * @export
 * @class LogActionDossierApi
 * @extends {BaseAPI}
 */
export class LogActionDossierApi extends BaseAPI {
    /**
     * Retrieves the collection of LogActionDossier resources.
     * @summary Retrieves the collection of LogActionDossier resources.
     * @param {LogActionDossierApiApiLogActionDossierClientEntityIdGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogActionDossierApi
     */
    public apiLogActionDossierClientEntityIdGetCollection(requestParameters: LogActionDossierApiApiLogActionDossierClientEntityIdGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return LogActionDossierApiFp(this.configuration).apiLogActionDossierClientEntityIdGetCollection(requestParameters.entityId, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a LogActionDossier resource.
     * @summary Creates a LogActionDossier resource.
     * @param {LogActionDossierApiApiLogActionDossiersFormatPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LogActionDossierApi
     */
    public apiLogActionDossiersFormatPost(requestParameters: LogActionDossierApiApiLogActionDossiersFormatPostRequest, options?: RawAxiosRequestConfig) {
        return LogActionDossierApiFp(this.configuration).apiLogActionDossiersFormatPost(requestParameters.logActionDossierJsonld, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PanierPaiementApi - axios parameter creator
 * @export
 */
export const PanierPaiementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Obtenir la liste des liens de paniers
         * @summary Obtenir la liste des liens de paniers
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLienPanierReglementGetCollection: async (xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/lien-panier-reglement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un lien de panier
         * @summary Récupérer les informations d\'un lien de panier
         * @param {string} id TblLienPanierReglement identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLienPanierReglementIdGet: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiLienPanierReglementIdGet', 'id', id)
            const localVarPath = `/facturation/lien-panier-reglement/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Obtenir la liste des paniers
         * @summary Obtenir la liste des paniers
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [collectionsId] 
         * @param {Array<number>} [collectionsId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPanierReglementGetCollection: async (xIdSociete?: number, page?: number, collectionsId?: number, collectionsId2?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/facturation/panier-reglement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (collectionsId !== undefined) {
                localVarQueryParameter['collections.id'] = collectionsId;
            }

            if (collectionsId2) {
                localVarQueryParameter['collections.id[]'] = collectionsId2;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Créer un panier de règlement
         * @summary Créer un panier de règlement
         * @param {PanierPaiementJsonldPanierCreate} panierPaiementJsonldPanierCreate The new Panier paiement resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPanierReglementPost: async (panierPaiementJsonldPanierCreate: PanierPaiementJsonldPanierCreate, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'panierPaiementJsonldPanierCreate' is not null or undefined
            assertParamExists('apiPanierReglementPost', 'panierPaiementJsonldPanierCreate', panierPaiementJsonldPanierCreate)
            const localVarPath = `/facturation/panier-reglement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(panierPaiementJsonldPanierCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @summary Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @param {PanierPaiementJsonldLienpanierrecouvrementCreate} panierPaiementJsonldLienpanierrecouvrementCreate The new Panier paiement resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPanierReglementRecouvrementDoiPost: async (panierPaiementJsonldLienpanierrecouvrementCreate: PanierPaiementJsonldLienpanierrecouvrementCreate, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'panierPaiementJsonldLienpanierrecouvrementCreate' is not null or undefined
            assertParamExists('apiPanierReglementRecouvrementDoiPost', 'panierPaiementJsonldLienpanierrecouvrementCreate', panierPaiementJsonldLienpanierrecouvrementCreate)
            const localVarPath = `/facturation/panier-reglement/recouvrementDoi`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(panierPaiementJsonldLienpanierrecouvrementCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @summary Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @param {PanierPaiementJsonldLienpanierrecouvrementCreate} panierPaiementJsonldLienpanierrecouvrementCreate The new Panier paiement resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPanierReglementRecouvrementNorDodPost: async (panierPaiementJsonldLienpanierrecouvrementCreate: PanierPaiementJsonldLienpanierrecouvrementCreate, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'panierPaiementJsonldLienpanierrecouvrementCreate' is not null or undefined
            assertParamExists('apiPanierReglementRecouvrementNorDodPost', 'panierPaiementJsonldLienpanierrecouvrementCreate', panierPaiementJsonldLienpanierrecouvrementCreate)
            const localVarPath = `/facturation/panier-reglement/recouvrementNorDod`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(panierPaiementJsonldLienpanierrecouvrementCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer les informations d\'un panier
         * @summary Récupérer les informations d\'un panier
         * @param {string} id PanierUnitaire identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicPanierReglementIdGet: async (id: string, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiPublicPanierReglementIdGet', 'id', id)
            const localVarPath = `/facturation/public/panier-reglement/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupérer le lien de paiement pour un panier
         * @summary Récupérer le lien de paiement pour un panier
         * @param {PanierPaiementJsonldLienpaiementpanierCreate} panierPaiementJsonldLienpaiementpanierCreate The new Panier paiement resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicPanierReglementLienPost: async (panierPaiementJsonldLienpaiementpanierCreate: PanierPaiementJsonldLienpaiementpanierCreate, xIdSociete?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'panierPaiementJsonldLienpaiementpanierCreate' is not null or undefined
            assertParamExists('apiPublicPanierReglementLienPost', 'panierPaiementJsonldLienpaiementpanierCreate', panierPaiementJsonldLienpaiementpanierCreate)
            const localVarPath = `/facturation/public/panier-reglement/lien`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/ld+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(panierPaiementJsonldLienpaiementpanierCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PanierPaiementApi - functional programming interface
 * @export
 */
export const PanierPaiementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PanierPaiementApiAxiosParamCreator(configuration)
    return {
        /**
         * Obtenir la liste des liens de paniers
         * @summary Obtenir la liste des liens de paniers
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLienPanierReglementGetCollection(xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiLienPanierReglementGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLienPanierReglementGetCollection(xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanierPaiementApi.apiLienPanierReglementGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un lien de panier
         * @summary Récupérer les informations d\'un lien de panier
         * @param {string} id TblLienPanierReglement identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiLienPanierReglementIdGet(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PanierPaiementJsonldPanierLienRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiLienPanierReglementIdGet(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanierPaiementApi.apiLienPanierReglementIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Obtenir la liste des paniers
         * @summary Obtenir la liste des paniers
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {number} [collectionsId] 
         * @param {Array<number>} [collectionsId2] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPanierReglementGetCollection(xIdSociete?: number, page?: number, collectionsId?: number, collectionsId2?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiPanierReglementGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPanierReglementGetCollection(xIdSociete, page, collectionsId, collectionsId2, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanierPaiementApi.apiPanierReglementGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Créer un panier de règlement
         * @summary Créer un panier de règlement
         * @param {PanierPaiementJsonldPanierCreate} panierPaiementJsonldPanierCreate The new Panier paiement resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPanierReglementPost(panierPaiementJsonldPanierCreate: PanierPaiementJsonldPanierCreate, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PanierPaiementJsonldPanierRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPanierReglementPost(panierPaiementJsonldPanierCreate, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanierPaiementApi.apiPanierReglementPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @summary Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @param {PanierPaiementJsonldLienpanierrecouvrementCreate} panierPaiementJsonldLienpanierrecouvrementCreate The new Panier paiement resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPanierReglementRecouvrementDoiPost(panierPaiementJsonldLienpanierrecouvrementCreate: PanierPaiementJsonldLienpanierrecouvrementCreate, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PanierPaiementJsonldLienpanierrecouvrementRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPanierReglementRecouvrementDoiPost(panierPaiementJsonldLienpanierrecouvrementCreate, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanierPaiementApi.apiPanierReglementRecouvrementDoiPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @summary Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @param {PanierPaiementJsonldLienpanierrecouvrementCreate} panierPaiementJsonldLienpanierrecouvrementCreate The new Panier paiement resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPanierReglementRecouvrementNorDodPost(panierPaiementJsonldLienpanierrecouvrementCreate: PanierPaiementJsonldLienpanierrecouvrementCreate, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PanierPaiementJsonldLienpanierrecouvrementRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPanierReglementRecouvrementNorDodPost(panierPaiementJsonldLienpanierrecouvrementCreate, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanierPaiementApi.apiPanierReglementRecouvrementNorDodPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer les informations d\'un panier
         * @summary Récupérer les informations d\'un panier
         * @param {string} id PanierUnitaire identifier
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPublicPanierReglementIdGet(id: string, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PanierPaiementJsonldPanierunitaireRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPublicPanierReglementIdGet(id, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanierPaiementApi.apiPublicPanierReglementIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Récupérer le lien de paiement pour un panier
         * @summary Récupérer le lien de paiement pour un panier
         * @param {PanierPaiementJsonldLienpaiementpanierCreate} panierPaiementJsonldLienpaiementpanierCreate The new Panier paiement resource
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPublicPanierReglementLienPost(panierPaiementJsonldLienpaiementpanierCreate: PanierPaiementJsonldLienpaiementpanierCreate, xIdSociete?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PanierPaiementJsonldPanierLienRead>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPublicPanierReglementLienPost(panierPaiementJsonldLienpaiementpanierCreate, xIdSociete, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PanierPaiementApi.apiPublicPanierReglementLienPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PanierPaiementApi - factory interface
 * @export
 */
export const PanierPaiementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PanierPaiementApiFp(configuration)
    return {
        /**
         * Obtenir la liste des liens de paniers
         * @summary Obtenir la liste des liens de paniers
         * @param {PanierPaiementApiApiLienPanierReglementGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLienPanierReglementGetCollection(requestParameters: PanierPaiementApiApiLienPanierReglementGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiLienPanierReglementGetCollection200Response> {
            return localVarFp.apiLienPanierReglementGetCollection(requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un lien de panier
         * @summary Récupérer les informations d\'un lien de panier
         * @param {PanierPaiementApiApiLienPanierReglementIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiLienPanierReglementIdGet(requestParameters: PanierPaiementApiApiLienPanierReglementIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PanierPaiementJsonldPanierLienRead> {
            return localVarFp.apiLienPanierReglementIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Obtenir la liste des paniers
         * @summary Obtenir la liste des paniers
         * @param {PanierPaiementApiApiPanierReglementGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPanierReglementGetCollection(requestParameters: PanierPaiementApiApiPanierReglementGetCollectionRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ApiPanierReglementGetCollection200Response> {
            return localVarFp.apiPanierReglementGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.collectionsId, requestParameters.collectionsId2, options).then((request) => request(axios, basePath));
        },
        /**
         * Créer un panier de règlement
         * @summary Créer un panier de règlement
         * @param {PanierPaiementApiApiPanierReglementPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPanierReglementPost(requestParameters: PanierPaiementApiApiPanierReglementPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PanierPaiementJsonldPanierRead> {
            return localVarFp.apiPanierReglementPost(requestParameters.panierPaiementJsonldPanierCreate, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @summary Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @param {PanierPaiementApiApiPanierReglementRecouvrementDoiPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPanierReglementRecouvrementDoiPost(requestParameters: PanierPaiementApiApiPanierReglementRecouvrementDoiPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PanierPaiementJsonldLienpanierrecouvrementRead> {
            return localVarFp.apiPanierReglementRecouvrementDoiPost(requestParameters.panierPaiementJsonldLienpanierrecouvrementCreate, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @summary Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
         * @param {PanierPaiementApiApiPanierReglementRecouvrementNorDodPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPanierReglementRecouvrementNorDodPost(requestParameters: PanierPaiementApiApiPanierReglementRecouvrementNorDodPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PanierPaiementJsonldLienpanierrecouvrementRead> {
            return localVarFp.apiPanierReglementRecouvrementNorDodPost(requestParameters.panierPaiementJsonldLienpanierrecouvrementCreate, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer les informations d\'un panier
         * @summary Récupérer les informations d\'un panier
         * @param {PanierPaiementApiApiPublicPanierReglementIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicPanierReglementIdGet(requestParameters: PanierPaiementApiApiPublicPanierReglementIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PanierPaiementJsonldPanierunitaireRead> {
            return localVarFp.apiPublicPanierReglementIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupérer le lien de paiement pour un panier
         * @summary Récupérer le lien de paiement pour un panier
         * @param {PanierPaiementApiApiPublicPanierReglementLienPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPublicPanierReglementLienPost(requestParameters: PanierPaiementApiApiPublicPanierReglementLienPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PanierPaiementJsonldPanierLienRead> {
            return localVarFp.apiPublicPanierReglementLienPost(requestParameters.panierPaiementJsonldLienpaiementpanierCreate, requestParameters.xIdSociete, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiLienPanierReglementGetCollection operation in PanierPaiementApi.
 * @export
 * @interface PanierPaiementApiApiLienPanierReglementGetCollectionRequest
 */
export interface PanierPaiementApiApiLienPanierReglementGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PanierPaiementApiApiLienPanierReglementGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof PanierPaiementApiApiLienPanierReglementGetCollection
     */
    readonly page?: number
}

/**
 * Request parameters for apiLienPanierReglementIdGet operation in PanierPaiementApi.
 * @export
 * @interface PanierPaiementApiApiLienPanierReglementIdGetRequest
 */
export interface PanierPaiementApiApiLienPanierReglementIdGetRequest {
    /**
     * TblLienPanierReglement identifier
     * @type {string}
     * @memberof PanierPaiementApiApiLienPanierReglementIdGet
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PanierPaiementApiApiLienPanierReglementIdGet
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiPanierReglementGetCollection operation in PanierPaiementApi.
 * @export
 * @interface PanierPaiementApiApiPanierReglementGetCollectionRequest
 */
export interface PanierPaiementApiApiPanierReglementGetCollectionRequest {
    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PanierPaiementApiApiPanierReglementGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof PanierPaiementApiApiPanierReglementGetCollection
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof PanierPaiementApiApiPanierReglementGetCollection
     */
    readonly collectionsId?: number

    /**
     * 
     * @type {Array<number>}
     * @memberof PanierPaiementApiApiPanierReglementGetCollection
     */
    readonly collectionsId2?: Array<number>
}

/**
 * Request parameters for apiPanierReglementPost operation in PanierPaiementApi.
 * @export
 * @interface PanierPaiementApiApiPanierReglementPostRequest
 */
export interface PanierPaiementApiApiPanierReglementPostRequest {
    /**
     * The new Panier paiement resource
     * @type {PanierPaiementJsonldPanierCreate}
     * @memberof PanierPaiementApiApiPanierReglementPost
     */
    readonly panierPaiementJsonldPanierCreate: PanierPaiementJsonldPanierCreate

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PanierPaiementApiApiPanierReglementPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiPanierReglementRecouvrementDoiPost operation in PanierPaiementApi.
 * @export
 * @interface PanierPaiementApiApiPanierReglementRecouvrementDoiPostRequest
 */
export interface PanierPaiementApiApiPanierReglementRecouvrementDoiPostRequest {
    /**
     * The new Panier paiement resource
     * @type {PanierPaiementJsonldLienpanierrecouvrementCreate}
     * @memberof PanierPaiementApiApiPanierReglementRecouvrementDoiPost
     */
    readonly panierPaiementJsonldLienpanierrecouvrementCreate: PanierPaiementJsonldLienpanierrecouvrementCreate

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PanierPaiementApiApiPanierReglementRecouvrementDoiPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiPanierReglementRecouvrementNorDodPost operation in PanierPaiementApi.
 * @export
 * @interface PanierPaiementApiApiPanierReglementRecouvrementNorDodPostRequest
 */
export interface PanierPaiementApiApiPanierReglementRecouvrementNorDodPostRequest {
    /**
     * The new Panier paiement resource
     * @type {PanierPaiementJsonldLienpanierrecouvrementCreate}
     * @memberof PanierPaiementApiApiPanierReglementRecouvrementNorDodPost
     */
    readonly panierPaiementJsonldLienpanierrecouvrementCreate: PanierPaiementJsonldLienpanierrecouvrementCreate

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PanierPaiementApiApiPanierReglementRecouvrementNorDodPost
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiPublicPanierReglementIdGet operation in PanierPaiementApi.
 * @export
 * @interface PanierPaiementApiApiPublicPanierReglementIdGetRequest
 */
export interface PanierPaiementApiApiPublicPanierReglementIdGetRequest {
    /**
     * PanierUnitaire identifier
     * @type {string}
     * @memberof PanierPaiementApiApiPublicPanierReglementIdGet
     */
    readonly id: string

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PanierPaiementApiApiPublicPanierReglementIdGet
     */
    readonly xIdSociete?: number
}

/**
 * Request parameters for apiPublicPanierReglementLienPost operation in PanierPaiementApi.
 * @export
 * @interface PanierPaiementApiApiPublicPanierReglementLienPostRequest
 */
export interface PanierPaiementApiApiPublicPanierReglementLienPostRequest {
    /**
     * The new Panier paiement resource
     * @type {PanierPaiementJsonldLienpaiementpanierCreate}
     * @memberof PanierPaiementApiApiPublicPanierReglementLienPost
     */
    readonly panierPaiementJsonldLienpaiementpanierCreate: PanierPaiementJsonldLienpaiementpanierCreate

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof PanierPaiementApiApiPublicPanierReglementLienPost
     */
    readonly xIdSociete?: number
}

/**
 * PanierPaiementApi - object-oriented interface
 * @export
 * @class PanierPaiementApi
 * @extends {BaseAPI}
 */
export class PanierPaiementApi extends BaseAPI {
    /**
     * Obtenir la liste des liens de paniers
     * @summary Obtenir la liste des liens de paniers
     * @param {PanierPaiementApiApiLienPanierReglementGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanierPaiementApi
     */
    public apiLienPanierReglementGetCollection(requestParameters: PanierPaiementApiApiLienPanierReglementGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return PanierPaiementApiFp(this.configuration).apiLienPanierReglementGetCollection(requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un lien de panier
     * @summary Récupérer les informations d\'un lien de panier
     * @param {PanierPaiementApiApiLienPanierReglementIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanierPaiementApi
     */
    public apiLienPanierReglementIdGet(requestParameters: PanierPaiementApiApiLienPanierReglementIdGetRequest, options?: RawAxiosRequestConfig) {
        return PanierPaiementApiFp(this.configuration).apiLienPanierReglementIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Obtenir la liste des paniers
     * @summary Obtenir la liste des paniers
     * @param {PanierPaiementApiApiPanierReglementGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanierPaiementApi
     */
    public apiPanierReglementGetCollection(requestParameters: PanierPaiementApiApiPanierReglementGetCollectionRequest = {}, options?: RawAxiosRequestConfig) {
        return PanierPaiementApiFp(this.configuration).apiPanierReglementGetCollection(requestParameters.xIdSociete, requestParameters.page, requestParameters.collectionsId, requestParameters.collectionsId2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Créer un panier de règlement
     * @summary Créer un panier de règlement
     * @param {PanierPaiementApiApiPanierReglementPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanierPaiementApi
     */
    public apiPanierReglementPost(requestParameters: PanierPaiementApiApiPanierReglementPostRequest, options?: RawAxiosRequestConfig) {
        return PanierPaiementApiFp(this.configuration).apiPanierReglementPost(requestParameters.panierPaiementJsonldPanierCreate, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
     * @summary Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
     * @param {PanierPaiementApiApiPanierReglementRecouvrementDoiPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanierPaiementApi
     */
    public apiPanierReglementRecouvrementDoiPost(requestParameters: PanierPaiementApiApiPanierReglementRecouvrementDoiPostRequest, options?: RawAxiosRequestConfig) {
        return PanierPaiementApiFp(this.configuration).apiPanierReglementRecouvrementDoiPost(requestParameters.panierPaiementJsonldLienpanierrecouvrementCreate, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
     * @summary Récupérer les informations d\'un panier pour les factures à payer d\'un tiers
     * @param {PanierPaiementApiApiPanierReglementRecouvrementNorDodPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanierPaiementApi
     */
    public apiPanierReglementRecouvrementNorDodPost(requestParameters: PanierPaiementApiApiPanierReglementRecouvrementNorDodPostRequest, options?: RawAxiosRequestConfig) {
        return PanierPaiementApiFp(this.configuration).apiPanierReglementRecouvrementNorDodPost(requestParameters.panierPaiementJsonldLienpanierrecouvrementCreate, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer les informations d\'un panier
     * @summary Récupérer les informations d\'un panier
     * @param {PanierPaiementApiApiPublicPanierReglementIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanierPaiementApi
     */
    public apiPublicPanierReglementIdGet(requestParameters: PanierPaiementApiApiPublicPanierReglementIdGetRequest, options?: RawAxiosRequestConfig) {
        return PanierPaiementApiFp(this.configuration).apiPublicPanierReglementIdGet(requestParameters.id, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupérer le lien de paiement pour un panier
     * @summary Récupérer le lien de paiement pour un panier
     * @param {PanierPaiementApiApiPublicPanierReglementLienPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PanierPaiementApi
     */
    public apiPublicPanierReglementLienPost(requestParameters: PanierPaiementApiApiPublicPanierReglementLienPostRequest, options?: RawAxiosRequestConfig) {
        return PanierPaiementApiFp(this.configuration).apiPublicPanierReglementLienPost(requestParameters.panierPaiementJsonldLienpaiementpanierCreate, requestParameters.xIdSociete, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RemisesDesArticlesDePrestationFormalitApi - axios parameter creator
 * @export
 */
export const RemisesDesArticlesDePrestationFormalitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Lister les réductions possibles pour des articles de prestation formalité
         * @summary Lister les réductions possibles pour des articles de prestation formalité
         * @param {Array<number>} ids Identifiants des articles de prestation
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReductionArticlesPrestationGetCollection: async (ids: Array<number>, xIdSociete?: number, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('apiReductionArticlesPrestationGetCollection', 'ids', ids)
            const localVarPath = `/facturation/reduction-articles-prestation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth", [], configuration)

            if (ids) {
                localVarQueryParameter['ids'] = ids.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (xIdSociete != null) {
                localVarHeaderParameter['X-Id-Societe'] = typeof xIdSociete === 'string'
                    ? xIdSociete
                    : JSON.stringify(xIdSociete);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RemisesDesArticlesDePrestationFormalitApi - functional programming interface
 * @export
 */
export const RemisesDesArticlesDePrestationFormalitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RemisesDesArticlesDePrestationFormalitApiAxiosParamCreator(configuration)
    return {
        /**
         * Lister les réductions possibles pour des articles de prestation formalité
         * @summary Lister les réductions possibles pour des articles de prestation formalité
         * @param {Array<number>} ids Identifiants des articles de prestation
         * @param {number} [xIdSociete] Identifiant de la société
         * @param {number} [page] The collection page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReductionArticlesPrestationGetCollection(ids: Array<number>, xIdSociete?: number, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiReductionArticlesPrestationGetCollection200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReductionArticlesPrestationGetCollection(ids, xIdSociete, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RemisesDesArticlesDePrestationFormalitApi.apiReductionArticlesPrestationGetCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RemisesDesArticlesDePrestationFormalitApi - factory interface
 * @export
 */
export const RemisesDesArticlesDePrestationFormalitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RemisesDesArticlesDePrestationFormalitApiFp(configuration)
    return {
        /**
         * Lister les réductions possibles pour des articles de prestation formalité
         * @summary Lister les réductions possibles pour des articles de prestation formalité
         * @param {RemisesDesArticlesDePrestationFormalitApiApiReductionArticlesPrestationGetCollectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReductionArticlesPrestationGetCollection(requestParameters: RemisesDesArticlesDePrestationFormalitApiApiReductionArticlesPrestationGetCollectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiReductionArticlesPrestationGetCollection200Response> {
            return localVarFp.apiReductionArticlesPrestationGetCollection(requestParameters.ids, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiReductionArticlesPrestationGetCollection operation in RemisesDesArticlesDePrestationFormalitApi.
 * @export
 * @interface RemisesDesArticlesDePrestationFormalitApiApiReductionArticlesPrestationGetCollectionRequest
 */
export interface RemisesDesArticlesDePrestationFormalitApiApiReductionArticlesPrestationGetCollectionRequest {
    /**
     * Identifiants des articles de prestation
     * @type {Array<number>}
     * @memberof RemisesDesArticlesDePrestationFormalitApiApiReductionArticlesPrestationGetCollection
     */
    readonly ids: Array<number>

    /**
     * Identifiant de la société
     * @type {number}
     * @memberof RemisesDesArticlesDePrestationFormalitApiApiReductionArticlesPrestationGetCollection
     */
    readonly xIdSociete?: number

    /**
     * The collection page number
     * @type {number}
     * @memberof RemisesDesArticlesDePrestationFormalitApiApiReductionArticlesPrestationGetCollection
     */
    readonly page?: number
}

/**
 * RemisesDesArticlesDePrestationFormalitApi - object-oriented interface
 * @export
 * @class RemisesDesArticlesDePrestationFormalitApi
 * @extends {BaseAPI}
 */
export class RemisesDesArticlesDePrestationFormalitApi extends BaseAPI {
    /**
     * Lister les réductions possibles pour des articles de prestation formalité
     * @summary Lister les réductions possibles pour des articles de prestation formalité
     * @param {RemisesDesArticlesDePrestationFormalitApiApiReductionArticlesPrestationGetCollectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RemisesDesArticlesDePrestationFormalitApi
     */
    public apiReductionArticlesPrestationGetCollection(requestParameters: RemisesDesArticlesDePrestationFormalitApiApiReductionArticlesPrestationGetCollectionRequest, options?: RawAxiosRequestConfig) {
        return RemisesDesArticlesDePrestationFormalitApiFp(this.configuration).apiReductionArticlesPrestationGetCollection(requestParameters.ids, requestParameters.xIdSociete, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }
}



